// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import TextareaAutosize from 'react-textarea-autosize';
// import SaviFullLogo from '../Images/SAVI AI full.png';
// import {
//     useReactTable,
//     getCoreRowModel,
//     flexRender,
//     createColumnHelper,
// } from '@tanstack/react-table';

// import Settings from './Settings';
// import Sidebar from './Sidebar';
// import Faq from './Faq';
// import ChartVisualization from './ChartVisualization';

// import '../Styles/Settings.css';
// import '../Styles/Chat.css';
// import '../Styles/Sidebar.css';

// import SessionTimeout from './SessionTimeout';
// import SessionTimeoutWarning from './SessionTimeoutWarning';
// import DOMPurify from 'dompurify';


// import {
//     FiSettings,
//     FiLogOut,
//     FiRefreshCw,
//     FiSend,
//     FiArrowRight,
//     FiUser,
//     FiX,
//     FiInfo,
//     FiThumbsUp,
//     FiThumbsDown,
//     FiCopy,
//     FiPaperclip,
//     FiFile,
//     FiImage,
//     FiFileText,
//     FiDownload,
//     // FiRefreshCw,

// } from 'react-icons/fi';

// // import {fa-refresh} from 'react-icons/fa';

// // import {fa-refresh} from 'react-icons/fa';

// // Move components outside to prevent re-creation on every render
// const ExpandableMessage = React.memo(({ message }) => {
//     const isLong = message.length > 100;
//     const [expanded, setExpanded] = useState(false);
    
//     return (
//         <div className="expandable-message">
//             <div className={`message-content ${expanded ? 'expanded' : ''}`}>
//                 {expanded || !isLong ? message : `${message.substring(0, 100)}...`}
//             </div>
//             {isLong && (
//                 <button 
//                     className="expand-btn"
//                     onClick={() => setExpanded(!expanded)}
//                 >
//                     {expanded ? 'Show Less' : 'Show More'}
//                 </button>
//             )}
//         </div>
//     );
// });
// ExpandableMessage.displayName = 'ExpandableMessage';

// // ItemsModal component - moved outside
// const ItemsModal = React.memo(({ isOpen, onClose, items, title }) => {
//     // Add keyboard listener for Escape key
//     React.useEffect(() => {
//         if (isOpen) {
//             const handleKeyDown = (e) => {
//                 if (e.key === 'Escape') {
//                     handleClose();
//                 }
//             };
//             document.addEventListener('keydown', handleKeyDown);
//             return () => document.removeEventListener('keydown', handleKeyDown);
//         }
//     }, [isOpen]);

//     if (!isOpen) return null;

//     const handleClose = () => {
//         if (onClose) {
//             onClose();
//         }
//     };

//     const handleOverlayClick = (e) => {
//         if (e.target === e.currentTarget) {
//             handleClose();
//         }
//     };

//     const handleCloseButtonClick = (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         handleClose();
//     };

//     return (
//         <div className="modal-overlay" onClick={handleOverlayClick}>
//             <div className="modal-content items-modal" onClick={(e) => e.stopPropagation()}>
//                 <div className="modal-header">
//                     <h3>{title}</h3>
//                     <button 
//                         className="modal-close-btn" 
//                         onClick={handleCloseButtonClick}
//                         onPointerDown={handleCloseButtonClick}
//                         onMouseDown={(e) => {
//                             e.preventDefault();
//                         }}
//                         type="button"
//                         style={{ 
//                             background: '#f44336', 
//                             color: 'white',
//                             border: 'none', 
//                             fontSize: '16px', 
//                             cursor: 'pointer',
//                             padding: '8px 12px',
//                             borderRadius: '4px',
//                             fontWeight: 'bold',
//                             zIndex: '10000',
//                             position: 'relative',
//                             minWidth: '80px',
//                             minHeight: '36px',
//                             pointerEvents: 'auto'
//                         }}
//                     >
//                         ✕ CLOSE
//                     </button>
//                 </div>
//                 <div className="modal-body">
//                     {items && items.length > 0 ? (
//                         <div className="items-grid">
//                             <div className="items-count-badge">
//                                 📦 {items.length} Item{items.length !== 1 ? 's' : ''} Found
//                             </div>
//                             {items.map((item, index) => (
//                                 <div key={index} className="item-card">
//                                     <div className="item-header">
//                                         <span className="item-number">#{index + 1}</span>
//                                         <span className="item-type">Line Item</span>
//                                     </div>
//                                     <div className="item-details">
//                                         {Object.entries(item).map(([key, value]) => (
//                                             <div key={key} className="item-field">
//                                                 <span className="field-label">
//                                                     {key.replace(/([A-Z])/g, ' $1').trim()}:
//                                                 </span>
//                                                 <span className="field-value">
//                                                     {value !== null && value !== undefined ? String(value) : 'N/A'}
//                                                 </span>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     ) : (
//                         <div className="no-items">
//                             <div className="no-items-icon">📋</div>
//                             <h4>No Items Found</h4>
//                             <p>This invoice doesn't contain any line items.</p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// });
// ItemsModal.displayName = 'ItemsModal';

// // FailedInvoicesModal component - moved outside
// const FailedInvoicesModal = React.memo(({ isOpen, onClose, failedInvoices, title }) => {
//     // Add keyboard listener for Escape key
//     React.useEffect(() => {
//         if (isOpen) {
//             const handleKeyDown = (e) => {
//                 if (e.key === 'Escape') {
//                     handleClose();
//                 }
//             };
//             document.addEventListener('keydown', handleKeyDown);
//             return () => document.removeEventListener('keydown', handleKeyDown);
//         }
//     }, [isOpen]);

//     if (!isOpen) return null;

//     const handleClose = () => {
//         if (onClose) onClose();
//     };

//     const handleOverlayClick = (e) => {
//         if (e.target === e.currentTarget) {
//             handleClose();
//         }
//     };

//     const handleCloseButtonClick = (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         handleClose();
//     };

//     return (
//         <div className="modal-overlay" onClick={handleOverlayClick}>
//             <div className="modal-content failed-invoices-modal" onClick={(e) => e.stopPropagation()}>
//                 <div className="modal-header">
//                     <h3>{title || 'Failed Invoices'}</h3>
//                     <button 
//                         className="modal-close-btn" 
//                         onClick={handleCloseButtonClick}
//                         onPointerDown={handleCloseButtonClick}
//                         onMouseDown={(e) => {
//                             e.preventDefault();
//                         }}
//                         type="button"
//                         style={{ 
//                             background: '#f44336', 
//                             color: 'white',
//                             border: 'none', 
//                             fontSize: '16px', 
//                             cursor: 'pointer',
//                             padding: '8px 12px',
//                             borderRadius: '4px',
//                             fontWeight: 'bold',
//                             zIndex: '10000',
//                             position: 'relative',
//                             minWidth: '80px',
//                             minHeight: '36px',
//                             pointerEvents: 'auto'
//                         }}
//                     >
//                         ✕ CLOSE
//                     </button>
//                 </div>
//                 <div className="modal-body">
//                     {failedInvoices && failedInvoices.length > 0 ? (
//                         <div className="failed-invoices-container">
//                             <div className="failed-invoices-count-badge">
//                                 ❌ {failedInvoices.length} Failed Invoice{failedInvoices.length !== 1 ? 's' : ''} Found
//                             </div>
//                             <div className="failed-invoices-list">
//                                 {failedInvoices.map((invoice, index) => (
//                                     <div key={index} className="failed-invoice-card">
//                                         <div className="failed-invoice-header">
//                                             <span className="invoice-number">#{index + 1}</span>
//                                             <span className="invoice-name">{invoice.name}</span>
//                                             <span className="invoice-status">Failed</span>
//                                         </div>
//                                         <div className="failed-invoice-details">
//                                             <div className="invoice-field">
//                                                 <span className="field-label">📅 Timestamp:</span>
//                                                 <span className="field-value">
//                                                     {new Date(invoice.timestamp).toLocaleString()}
//                                                 </span>
//                                             </div>
//                                             <div className="invoice-field">
//                                                 <span className="field-label">❗ Error Message:</span>
//                                                 <span className="field-value error-message">
//                                                     {invoice.message || 'Unknown error occurred'}
//                                                 </span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 ))}
//                             </div>
//                         </div>
//                     ) : (
//                         <div className="no-failed-invoices">
//                             <div className="no-failed-invoices-icon">✅</div>
//                             <h4>No Failed Invoices</h4>
//                             <p>All invoices were processed successfully!</p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// });
// FailedInvoicesModal.displayName = 'FailedInvoicesModal';

// const Chat = ({
//     dashboardUrl,
//     setDashboardUrl,
//     activeNavItem,
//     setActiveNavItem,
//     showFAQ,
//     setShowFAQ
// }) => {

//     const navigate = useNavigate();
//     const messagesEndRef = useRef(null);
//     const textareaRef = useRef(null);
//     const [inputText, setInputText] = useState('');
//     const [messages, setMessages] = useState([]);
//     const [chatHistory, setChatHistory] = useState([]);
//     const [activeChatId, setActiveChatId] = useState(null);
//     const [isSidebarActive, setSidebarActive] = useState(false);
//     const [loading, setLoading] = useState(false);
//     const [showDashboard, setShowDashboard] = useState(false);
//     const [activeDashboard, setActiveDashboard] = useState(null);
//     const [deletedChats, setDeletedChats] = useState([]);
//     const [openDropdown, setOpenDropdown] = useState(null);
//     const [newChatTitle, setNewChatTitle] = useState('');
//     const [isEditingTitle, setIsEditingTitle] = useState(false);
//     const [showChatList, setShowChatList] = useState(false);
//     const [openNestedDropdown, setOpenNestedDropdown] = useState(null);
//     const [faqQuestionSelected, setFaqQuestionSelected] = useState(false);
//     const [placeholder, setPlaceholder] = useState("Ask Savi...");
//     const [showSignOutOptions, setShowSignOutOptions] = useState(false);
//     const [openSubmenuParent, setOpenSubmenuParent] = useState(null);
//     const [loadedDashboards, setLoadedDashboards] = useState({});
//     const [showSettings, setShowSettings] = useState(false);
//     const [userInitial, setUserInitial] = useState('');
//     const [renameAnchorEl, setRenameAnchorEl] = useState(null);
//     const [overlayMenus, setOverlayMenus] = useState([]);
//     const [typingMessage, setTypingMessage] = useState(null);
//     const [currentTypingText, setCurrentTypingText] = useState('');
//     const typingInterval = useRef(null);
//     const currentRequestRef = useRef(null);
//     const [currentTheme, setCurrentTheme] = useState(
//         localStorage.getItem('theme') || 'light'
//     );
//     const [quickResponseLoading, setQuickResponseLoading] = useState(false);
//     const [quickResponseError, setQuickResponseError] = useState(null);
//     const [messageFeedback, setMessageFeedback] = useState({});
//     const [chartLoadingStates, setChartLoadingStates] = useState({});
//     const [chartLoadingProgress, setChartLoadingProgress] = useState({});
//     const [pendingVisualizations, setPendingVisualizations] = useState({});

//     // Attachment states
//     const [selectedFiles, setSelectedFiles] = useState([]);
//     const [isUploading, setIsUploading] = useState(false);

//     // Table states for invoice data display
//     const [invoiceData, setInvoiceData] = useState(null);
//     const [dragActive, setDragActive] = useState(false);
    
//     // Modal state for line items popup
//     const [showItemsModal, setShowItemsModal] = useState(false);
//     const [selectedItems, setSelectedItems] = useState(null);
//     const [modalTitle, setModalTitle] = useState('');
    
//     // Modal state for failed invoices popup
//     const [showFailedInvoicesModal, setShowFailedInvoicesModal] = useState(false);
//     const [selectedFailedInvoices, setSelectedFailedInvoices] = useState(null);
//     // State for expanded rows (inline items display)
//     const [expandedRows, setExpandedRows] = useState(new Set());
    
//     // State for email sending
//     const [isSendingEmail, setIsSendingEmail] = useState(false);
//     const [emailSendStatus, setEmailSendStatus] = useState(null);

//     // Memoize quick responses to prevent re-creation on every render
//     const quickResponses = useMemo(() => [
//         {
//             id: 1,
//             text: "Top 3 opportunities",
//             prompt: "Top 3 opportunities with respect to annual revenue in our pipeline?",
//             category: "creative"
//         },
//         {
//             id: 2,
//             text: "Give 5 deals",
//             prompt: "Give 5 deals that we won due to",
//             category: "writing"
//         },
//         {
//             id: 3,
//             text: "Breakdown of accounts",
//             prompt: "Breakdown of accounts by sector",
//             category: "writing"
//         },
//         {
//             id: 4,
//             text: "Show me all project",
//             prompt: "Show me all project names under elangovan",
//             category: "translation"
//         },
//         {
//             id: 5,
//             text: "Companies expecting revenue",
//             prompt: "Companies expecting revenue more than 10 Lakh",
//             category: "writing"
//         },
//         {
//             id: 6,
//             text: "Revenue lost",
//             prompt: "Revenue lost in Q1 2024",
//             category: "creative"
//         },
//         {
//             id: 7,
//             text: "Lost opportunities",
//             prompt: "Lost opportunities in Q1 2024",
//             category: "advice"
//         },
//         {
//             id: 8,
//             text: "healthcare sector",
//             prompt: "companies in healthcare sector",
//             category: "analysis"
//         }
//     ], []);

//     // Create SummaryCards component with proper event handlers
//     const SummaryCards = useMemo(() => React.memo(({ results, onFailedInvoicesClick }) => {
//         const handleFailedInvoicesClick = useCallback(() => {
//             onFailedInvoicesClick(results.failed_invoices || []);
//         }, [results.failed_invoices, onFailedInvoicesClick]);

//         return (
//             <div className="invoice-summary-cards">
//                 <div className="summary-card">
//                     <div className="summary-card-value">{results.total_invoices_loaded || 0}</div>
//                     <div className="summary-card-label">Total Invoices Scanned</div>
//                 </div>
//                 <div className="summary-card success">
//                     <div className="summary-card-value">{results.successful_pushed_invoices || 0}</div>
//                     <div className="summary-card-label">Successfully Pushed to SAP</div>
//                 </div>
//                 <div 
//                     className="summary-card error clickable failed-invoices-card" 
//                     onClick={handleFailedInvoicesClick}
//                     style={{ 
//                         cursor: 'pointer',
//                         pointerEvents: 'auto',
//                         zIndex: 10,
//                         position: 'relative'
//                     }}
//                     title="Click to view failed invoices details"
//                 >
//                     <div className="summary-card-value" style={{ pointerEvents: 'none' }}>
//                         {results.failed_invoices_count || 0}
//                     </div>
//                     <div className="summary-card-label" style={{ pointerEvents: 'none' }}>
//                         Pending to Process
//                     </div>
//                     {results.failed_invoices_count > 0 && (
//                         <div className="click-hint" style={{ pointerEvents: 'none' }}>
//                             Click to view details
//                         </div>
//                     )}
//                 </div>
//             </div>
//         );
//     }), []);
//     SummaryCards.displayName = 'SummaryCards';

//     // Handler for failed invoices click
//     const handleFailedInvoicesClick = useCallback((failedInvoices) => {
//         setSelectedFailedInvoices(failedInvoices);
//         setShowFailedInvoicesModal(true);
//     }, []);

//     // Handler for sending email with invoice data
//     const handleSendEmail = useCallback(async (extractedData, invoiceResults) => {
//         try {
//             setIsSendingEmail(true);
//             setEmailSendStatus(null);
            
//             // Get user email from localStorage
//             const userType = localStorage.getItem('userType');
//             const userEmail = userType === 'vendor' 
//                 ? localStorage.getItem('userEmail') 
//                 : localStorage.getItem('user');
            
//             if (!userEmail) {
//                 setEmailSendStatus({ type: 'error', message: 'User email not found. Please login again.' });
//                 return;
//             }
            
//             // Build the sap_payload_list from extractedData
//             const sap_payload_list = [];
            
//             if (extractedData && extractedData.length > 0) {
//                 extractedData.forEach((invoiceArray) => {
//                     if (Array.isArray(invoiceArray)) {
//                         sap_payload_list.push({
//                             extracted_data: invoiceArray,
//                             document_file_path: "Uploaded via web interface",
//                             document_type: "PDF"
//                         });
//                     }
//                 });
//             }
            
//             // Prepare the request body
//             const emailPayload = {
//                 recipient: userEmail,
//                 sap_payload_list: sap_payload_list
//             };
            
//             console.log('📧 Sending email with payload:', emailPayload);
            
//             // Send request to the email API
//             const response = await axios.post(
//                 'https://ocrtool.savictech.com/api/invoice/send_email',
//                 emailPayload,
//                 {
//                     headers: { 'Content-Type': 'application/json' },
//                     timeout: 30000
//                 }
//             );
            
//             console.log('✅ Email sent successfully:', response.data);
//             setEmailSendStatus({ 
//                 type: 'success', 
//                 message: `Email sent successfully to ${userEmail}` 
//             });
            
//             // Clear success message after 5 seconds
//             setTimeout(() => setEmailSendStatus(null), 5000);
            
//         } catch (error) {
//             console.error('❌ Error sending email:', error);
//             const errorMessage = error.response?.data?.message || error.message || 'Failed to send email';
//             setEmailSendStatus({ 
//                 type: 'error', 
//                 message: `Failed to send email: ${errorMessage}` 
//             });
            
//             // Clear error message after 8 seconds
//             setTimeout(() => setEmailSendStatus(null), 8000);
//         } finally {
//             setIsSendingEmail(false);
//         }
//     }, []);

//     // Handler for downloading Excel file from server
//     const handleDownloadExcel = useCallback(async (extractedData, invoiceResults) => {
//         try {
//             setIsSendingEmail(true); // Reuse loading state
//             setEmailSendStatus(null);
            
//             // Build the sap_payload_list from extractedData
//             const sap_payload_list = [];
            
//             if (extractedData && extractedData.length > 0) {
//                 extractedData.forEach((invoiceArray) => {
//                     if (Array.isArray(invoiceArray)) {
//                         sap_payload_list.push({
//                             extracted_data: invoiceArray,
//                             document_file_path: "Uploaded via web interface",
//                             document_type: "PDF"
//                         });
//                     }
//                 });
//             }
            
//             // Prepare the request body
//             const exportPayload = {
//                 sap_payload_list: sap_payload_list
//             };
            
//             console.log('📥 Downloading Excel with payload:', exportPayload);
            
//             // Send request to the Excel export API
//             const response = await axios.post(
//                 'https://ocrtool.savictech.com/api/export-invoices-excel',
//                 exportPayload,
//                 {
//                     headers: { 'Content-Type': 'application/json' },
//                     responseType: 'blob', // Important for file download
//                     timeout: 60000
//                 }
//             );
            
//             // Create blob and download
//             const blob = new Blob([response.data], { 
//                 type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
//             });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
            
//             // Extract filename from Content-Disposition header or use default
//             const contentDisposition = response.headers['content-disposition'];
//             let filename = 'SAP_Invoices.xlsx';
//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
//                 if (filenameMatch && filenameMatch[1]) {
//                     filename = filenameMatch[1].replace(/['"]/g, '');
//                 }
//             }
            
//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
            
//             console.log('✅ Excel file downloaded successfully');
//             setEmailSendStatus({ 
//                 type: 'success', 
//                 message: 'Excel file downloaded successfully' 
//             });
            
//             // Clear success message after 5 seconds
//             setTimeout(() => setEmailSendStatus(null), 5000);
            
//         } catch (error) {
//             console.error('❌ Error downloading Excel:', error);
//             const errorMessage = error.response?.data?.message || error.message || 'Failed to download Excel file';
//             setEmailSendStatus({ 
//                 type: 'error', 
//                 message: `Failed to download: ${errorMessage}` 
//             });
            
//             // Clear error message after 8 seconds
//             setTimeout(() => setEmailSendStatus(null), 8000);
//         } finally {
//             setIsSendingEmail(false);
//         }
//     }, []);

//     // Optimized ExtractedDataTable component with memoization
//     const ExtractedDataTable = useMemo(() => React.memo(({ extractedData, expandedRows, onToggleExpansion, onSendEmail, onDownloadExcel, invoiceResults, isSendingEmail, emailSendStatus }) => {
//         // Flatten the extracted data and prepare for table display
//         const flattenedData = useMemo(() => {
//             const result = [];
//             if (extractedData && extractedData.length > 0) {
//                 extractedData.forEach((invoiceArray, invoiceIndex) => {
//                     if (Array.isArray(invoiceArray)) {
//                         invoiceArray.forEach((invoice, docIndex) => {
//                             // Handle both uppercase 'Items' and lowercase 'items' from backend
//                             const { Items, items, ...invoiceWithoutItems } = invoice;
//                             const itemsArray = Items || items || [];
//                             const rowId = `invoice-${invoiceIndex}-${docIndex}`;
//                             result.push({
//                                 ...invoiceWithoutItems,
//                                 invoiceIndex,
//                                 docIndex,
//                                 Items: itemsArray,
//                                 id: rowId
//                             });
//                         });
//                     }
//                 });
//             }
//             return result;
//         }, [extractedData]);

//         const columnHelper = createColumnHelper();
        
//         // Auto-detect columns from the first invoice (excluding Items)
//         const columns = useMemo(() => {
//             const firstInvoice = flattenedData[0];
//             const dynamicColumns = firstInvoice ? 
//                 Object.keys(firstInvoice)
//                     .filter(key => key !== 'Items' && key !== 'invoiceIndex' && key !== 'docIndex' && key !== 'id')
//                     .map(key => 
//                         columnHelper.accessor(key, {
//                             header: key.replace(/([A-Z])/g, ' $1').trim(),
//                             cell: info => info.getValue() || 'N/A',
//                         })
//                     ) : [];

//             // Add action column for viewing items
//             return [
//                 {
//                     id: 'actions',
//                     header: 'Actions',
//                     cell: ({ row }) => {
//                         const hasItems = row.original.Items && row.original.Items.length > 0;
                        
//                         if (!hasItems) {
//                             return <span style={{ color: '#999', fontStyle: 'italic', fontSize: '12px' }}>—</span>;
//                         }
                        
//                         const isExpanded = expandedRows.has(row.id);
                        
//                         return React.createElement('button', {
//                             onClick: function(e) {
//                                 e.preventDefault();
//                                 e.stopPropagation();
//                                 onToggleExpansion(row.id);
//                             },
//                             style: {
//                                 backgroundColor: isExpanded ? '#dc3545' : '#28a745',
//                                 color: 'white',
//                                 border: 'none',
//                                 padding: '6px 10px',
//                                 borderRadius: '50%',
//                                 cursor: 'pointer',
//                                 fontSize: '14px',
//                                 fontWeight: 'bold',
//                                 whiteSpace: 'nowrap',
//                                 position: 'relative',
//                                 zIndex: 9999,
//                                 pointerEvents: 'auto',
//                                 width: '32px',
//                                 height: '32px',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 transition: 'all 0.2s ease'
//                             }
//                         }, isExpanded ? '▼' : '▶');
//                     }
//                 },
//                 ...dynamicColumns
//             ];
//         }, [flattenedData, expandedRows, onToggleExpansion, columnHelper]);

//         const table = useReactTable({
//             data: flattenedData,
//             columns,
//             getCoreRowModel: getCoreRowModel(),
//         });

//         if (!extractedData || extractedData.length === 0) return null;
//         if (!flattenedData[0]) return null;

//         return (
//             <div className="invoice-table-container">
//                 <div className="table-header-controls" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '10px' }}>
//                     <h4 className="table-title" style={{ margin: 0 }}>📋 Extracted Invoice Data</h4>
//                     <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//                         {emailSendStatus && (
//                             <div style={{
//                                 padding: '8px 16px',
//                                 borderRadius: '6px',
//                                 fontSize: '14px',
//                                 fontWeight: '500',
//                                 backgroundColor: emailSendStatus.type === 'success' ? '#d4edda' : '#f8d7da',
//                                 color: emailSendStatus.type === 'success' ? '#155724' : '#721c24',
//                                 border: `1px solid ${emailSendStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px'
//                             }}>
//                                 {emailSendStatus.type === 'success' ? '✅' : '❌'} {emailSendStatus.message}
//                             </div>
//                         )}
//                         {/* <button 
//                             className="send-email-btn"
//                             onClick={() => onSendEmail && onSendEmail(extractedData, invoiceResults)}
//                             disabled={isSendingEmail}
//                             title="Send invoice data via email"
//                             style={{
//                                 backgroundColor: isSendingEmail ? '#6c757d' : '#007bff',
//                                 color: 'white',
//                                 border: 'none',
//                                 padding: '8px 16px',
//                                 borderRadius: '6px',
//                                 cursor: isSendingEmail ? 'not-allowed' : 'pointer',
//                                 fontSize: '14px',
//                                 fontWeight: '500',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                                 transition: 'background-color 0.2s ease',
//                                 opacity: isSendingEmail ? 0.7 : 1
//                             }}
//                             onMouseEnter={(e) => { if (!isSendingEmail) e.target.style.backgroundColor = '#0056b3'; }}
//                             onMouseLeave={(e) => { if (!isSendingEmail) e.target.style.backgroundColor = '#007bff'; }}
//                         >
//                             {isSendingEmail ? (
//                                 <>
//                                     <div style={{
//                                         width: '14px',
//                                         height: '14px',
//                                         border: '2px solid white',
//                                         borderTopColor: 'transparent',
//                                         borderRadius: '50%',
//                                         animation: 'spin 0.8s linear infinite'
//                                     }}></div>
//                                     Sending...
//                                 </>
//                             ) : (
//                                 <>
//                                     <FiSend style={{ fontSize: '16px' }} /> Send Email
//                                 </>
//                             )}
//                         </button> */}
//                         <button 
//                             className="download-excel-btn"
//                             onClick={() => onDownloadExcel && onDownloadExcel(extractedData, invoiceResults)}
//                             disabled={isSendingEmail}
//                             title="Download as Excel file"
//                             style={{
//                                 backgroundColor: isSendingEmail ? '#6c757d' : '#28a745',
//                                 color: 'white',
//                                 border: 'none',
//                                 padding: '8px 16px',
//                                 borderRadius: '6px',
//                                 cursor: isSendingEmail ? 'not-allowed' : 'pointer',
//                                 fontSize: '14px',
//                                 fontWeight: '500',
//                                 display: 'flex',
//                                 alignItems: 'center',
//                                 gap: '6px',
//                                 transition: 'background-color 0.2s ease',
//                                 opacity: isSendingEmail ? 0.7 : 1
//                             }}
//                             onMouseEnter={(e) => { if (!isSendingEmail) e.target.style.backgroundColor = '#218838'; }}
//                             onMouseLeave={(e) => { if (!isSendingEmail) e.target.style.backgroundColor = '#28a745'; }}
//                         >
//                             {isSendingEmail ? (
//                                 <>
//                                     <div style={{
//                                         width: '14px',
//                                         height: '14px',
//                                         border: '2px solid white',
//                                         borderTopColor: 'transparent',
//                                         borderRadius: '50%',
//                                         animation: 'spin 0.8s linear infinite'
//                                     }}></div>
//                                     Downloading...
//                                 </>
//                             ) : (
//                                 <>
//                                     <FiDownload style={{ fontSize: '16px' }} /> Download Excel
//                                 </>
//                             )}
//                         </button>
//                     </div>
//                 </div>
//                 <div className="table-wrapper">
//                     <table className="invoice-table">
//                         <thead>
//                             {table.getHeaderGroups().map(headerGroup => (
//                                 <tr key={headerGroup.id}>
//                                     {headerGroup.headers.map(header => (
//                                         <th key={header.id}>
//                                             {header.isPlaceholder
//                                                 ? null
//                                                 : flexRender(
//                                                     header.column.columnDef.header,
//                                                     header.getContext()
//                                                 )}
//                                         </th>
//                                     ))}
//                                 </tr>
//                             ))}
//                         </thead>
//                         <tbody>
//                             {table.getRowModel().rows.map(row => (
//                                 <React.Fragment key={row.id}>
//                                     <tr>
//                                         {row.getVisibleCells().map(cell => (
//                                             <td key={cell.id}>
//                                                 {flexRender(cell.column.columnDef.cell, cell.getContext())}
//                                             </td>
//                                         ))}
//                                     </tr>
//                                     {/* Inline Items Display */}
//                                     {expandedRows.has(row.id) && row.original.Items && row.original.Items.length > 0 && (
//                                         <tr className="expanded-row">
//                                             <td colSpan={columns.length} className="expanded-cell">
//                                                 <div className="inline-items-container">
//                                                     <div className="inline-items-header">
//                                                         <h4>📦 Items for Invoice {row.original.InvoiceNumber || row.original.DocumentNumber || 'Unknown'}</h4>
//                                                         <div className="items-count-badge">
//                                                             {row.original.Items.length} Item{row.original.Items.length !== 1 ? 's' : ''} Found
//                                                         </div>
//                                                     </div>
//                                                     <div className="inline-items-table-wrapper">
//                                                         <table className="inline-items-table">
//                                                             <thead>
//                                                                 <tr>
//                                                                     <th>#</th>
//                                                                     {row.original.Items.length > 0 && Object.keys(row.original.Items[0]).map(key => (
//                                                                         <th key={key}>
//                                                                             {key.replace(/([A-Z])/g, ' $1').trim()}
//                                                                         </th>
//                                                                     ))}
//                                                                 </tr>
//                                                             </thead>
//                                                             <tbody>
//                                                                 {row.original.Items.map((item, index) => (
//                                                                     <tr key={index}>
//                                                                         <td className="item-number-cell">#{index + 1}</td>
//                                                                         {Object.entries(item).map(([key, value]) => (
//                                                                             <td key={key} className="item-value-cell">
//                                                                                 {value !== null && value !== undefined ? String(value) : 'N/A'}
//                                                                             </td>
//                                                                         ))}
//                                                                     </tr>
//                                                                 ))}
//                                                             </tbody>
//                                                         </table>
//                                                     </div>
//                                                 </div>
//                                             </td>
//                                         </tr>
//                                     )}
//                                 </React.Fragment>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         );
//     }), []);
//     ExtractedDataTable.displayName = 'ExtractedDataTable';

//     // Handler for toggling row expansion
//     const handleToggleExpansion = useCallback((rowId) => {
//         setExpandedRows(prev => {
//             const newSet = new Set(prev);
//             if (newSet.has(rowId)) {
//                 newSet.delete(rowId);
//             } else {
//                 newSet.add(rowId);
//             }
//             return newSet;
//         });
//     }, []);

//     const handleSignOut = () => {
//         localStorage.removeItem('isAuthenticated');
//         localStorage.removeItem('user');
//         localStorage.removeItem('userType');
//         localStorage.removeItem('userEmail');
//         localStorage.removeItem('token');
//         sessionStorage.removeItem('savi_chat_messages');
//         sessionStorage.removeItem('savi_chat_token');
//         navigate('/', { replace: true });
//     };

//     // Message feedback handlers - optimized with useCallback
//     const handleThumbsUp = useCallback((messageIndex) => {
//         setMessageFeedback(prev => ({
//             ...prev,
//             [messageIndex]: { ...prev[messageIndex], thumbsUp: !prev[messageIndex]?.thumbsUp, thumbsDown: false }
//         }));
//     }, []);

//     const handleThumbsDown = useCallback((messageIndex) => {
//         setMessageFeedback(prev => ({
//             ...prev,
//             [messageIndex]: { ...prev[messageIndex], thumbsDown: !prev[messageIndex]?.thumbsDown, thumbsUp: false }
//         }));
//     }, []);

//     const [copiedMessageId, setCopiedMessageId] = useState(null);

//     const handleCopyMessage = useCallback(async (messageText, messageId) => {
//         // Create a temporary div to extract text from HTML
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = messageText;
//         const plainText = tempDiv.textContent || tempDiv.innerText || messageText;
        
//         try {
//             await navigator.clipboard.writeText(plainText);
            
//             // Show visual feedback
//             setCopiedMessageId(messageId);
//             setTimeout(() => setCopiedMessageId(null), 2000);
//         } catch (err) {
//             console.error('Failed to copy message: ', err);
//             // Fallback for older browsers
//             try {
//                 const textArea = document.createElement('textarea');
//                 textArea.value = plainText;
//                 document.body.appendChild(textArea);
//                 textArea.select();
//                 document.execCommand('copy');
//                 document.body.removeChild(textArea);
                
//                 setCopiedMessageId(messageId);
//                 setTimeout(() => setCopiedMessageId(null), 2000);
//             } catch (fallbackErr) {
//                 console.error('Fallback copy method also failed: ', fallbackErr);
//             }
//         }
//     }, []);

//     const handleRefreshMessage = useCallback(async (messageIndex) => {
//         if (messageIndex === 0 || !messages[messageIndex - 1]) {
//             console.error('Cannot refresh: No previous user message found');
//             return;
//         }

//         const userMessage = messages[messageIndex - 1];
//         if (userMessage.sender !== 'user') {
//             console.error('Cannot refresh: Previous message is not from user');
//             return;
//         }

//         // Check if the user message had file attachments
//         if (userMessage.attachments && userMessage.attachments.length > 0) {
//             console.log('Cannot refresh: Original message contained file attachments');
//             // Show a toast or alert to inform the user
//             alert('Cannot refresh messages that included file uploads. Please upload the files again if needed.');
//             return;
//         }

//         // Remove the AI message that's being refreshed and any messages after it
//         const updatedMessages = messages.slice(0, messageIndex);
//         setMessages(updatedMessages);

//         // Set loading state
//         setLoading(true);

//         try {
//             // Get the user's original input
//             const userInput = userMessage.text;
            
//             // Use the same API configuration as handleSendMessage
//             const endpoint = process.env.REACT_APP_UNIFIED_API;
//             if (!endpoint) {
//                 throw new Error('API endpoint not configured');
//             }

//             // Create AbortController for request cancellation
//             const abortController = new AbortController();
//             currentRequestRef.current = abortController;

//             // Note: This API is primarily designed for invoice processing
//             // For text-only queries, we'll try to make a request but it may not be supported
//             const payload = { 
//                 question: userInput,
//                 action: 'text_query' // Add action parameter for Django API
//             };
//             const response = await axios.post(endpoint, payload, {
//                 headers: { 'Content-Type': 'application/json' },
//                 timeout: 600000,
//                 signal: abortController.signal,
//                 maxRetries: 2,
//                 retryDelay: 1000
//             });

//             // Clear the request ref after successful completion
//             currentRequestRef.current = null;

//             // Process successful response - use the same parsing logic as handleSendMessage
//             const aiFullText = parseApiResponse(response.data) || 'No response received';
//             const visualizationData = extractVisualizationData(response.data);
//             const tableData = extractInvoiceTableData(response.data);
            
//             // Create AI message with typing effect like in handleSendMessage
//             const aiMessage = createMessage('', 'ai', 'text', true, null, null, tableData.showInvoiceTables, tableData.invoiceResults);
//             const finalMessages = [...updatedMessages, aiMessage];
            
//             setMessages(finalMessages);
//             setTypingMessage({ fullText: aiFullText });

//             // If there are visualizations, store them for delayed loading after typing completes
//             if (visualizationData) {
//                 const messageIndex = finalMessages.length - 1;
//                 setPendingVisualizations(prev => ({
//                     ...prev,
//                     [messageIndex]: visualizationData
//                 }));
//             }

//             // Update chat history if there's an active chat
//             if (activeChatId) {
//                 updateChatHistory(activeChatId, finalMessages, userInput.substring(0, 30));
//             }
            
//             // Update session storage
//             sessionStorage.setItem('savi_chat_messages', JSON.stringify(finalMessages));

//         } catch (error) {
//             // Clear the request ref
//             currentRequestRef.current = null;
            
//             // Handle request cancellation
//             if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
//                 return;
//             }
            
//             // Handle API errors - check if it's a Django API issue
//             let errorMessage;
//             if (error.response?.status === 400 || error.response?.status === 405) {
//                 errorMessage = "This API is designed for invoice processing with file uploads. Refresh functionality is not available for text-only queries.";
//             } else {
//                 errorMessage = handleAPIError(error, userMessage.text);
//             }
            
//             const aiMessage = createMessage('', 'ai', 'text', true);
//             const finalMessages = [...updatedMessages, aiMessage];
            
//             setMessages(finalMessages);
//             setTypingMessage({ fullText: sanitizeInput(errorMessage) });
            
//             if (activeChatId) {
//                 updateChatHistory(activeChatId, finalMessages, userMessage.text.substring(0, 30));
//             }
            
//         } finally {
//             setLoading(false);
//         }
//     }, [messages, setMessages, setLoading, activeChatId]);

//     const handleQuickResponse = useCallback(async (response) => {
//         try {
//             setQuickResponseLoading(true);
//             setQuickResponseError(null);

//             if (typingMessage) {
//                 stopTyping();
//             }

//             setInputText(response.prompt);

//             if (textareaRef.current) {
//                 textareaRef.current.focus();
//                 const length = response.prompt.length;
//                 textareaRef.current.setSelectionRange(length, length);
//             }

//         } catch (error) {
//             console.error('Error handling quick response:', error);
//             setQuickResponseError('Failed to process quick response. Please try again.');
//         } finally {
//             setQuickResponseLoading(false);
//         }
//     }, []);

//     const sanitizeInput = (input) => {
//         const div = document.createElement('div');
//         div.textContent = input;
//         return div.innerHTML;
//     };
    
//     const openOverlayMenu = (items, e, parentName = null) => {
//         const rect = e.target.getBoundingClientRect();
//         const overlayHeight = 50 * items.length + 16; // 48px per item + padding
//         const viewportHeight = window.innerHeight;
//         let top = rect.top;

//         // If overlay would overflow bottom, adjust top
//         if (top + overlayHeight > viewportHeight) {
//             top = Math.max(8, viewportHeight - overlayHeight - 8);
//         }

//         setOverlayMenus(prev => {
//             // For nested overlays (CEO, CSO, CMO)
//             if (parentName && prev.length > 0) {
//                 // If clicking the same nested item again, close it (toggle)
//                 if (prev.length > 1 && prev[1].parentName === parentName) {
//                     return [prev[0]]; // Keep only main overlay
//                 }
//                 // Otherwise replace existing nested overlay with new one
//                 return [
//                     prev[0], // Keep main overlay
//                     {
//                         items,
//                         position: { left: rect.right, top },
//                         parentName
//                     }
//                 ];
//             }
//             // If the last overlay is for the same parent, close it (toggle)
//             if (prev.length > 0 && prev[prev.length - 1].parentName === parentName) {
//                 setOpenSubmenuParent(null);
//                 return prev.slice(0, -1);
//             }
//             // Otherwise, add new overlay
//             setOpenSubmenuParent(parentName);
//             return [
//                 ...prev,
//                 {
//                     items,
//                     position: { left: rect.right, top },
//                     parentName
//                 }
//             ];
//         });
//     };

//     // To close the last overlay (back)
//     const closeLastOverlay = () => setOverlayMenus(prev => prev.slice(0, -1));

//     // To close all overlays
//     const closeAllOverlays = () => {
//         setOverlayMenus([]);
//         setOpenSubmenuParent(null); // <-- reset submenu state
//     };
//     const handleShowFAQ = () => {
//         stopTyping(); // Stop AI typing effect if running
//         setShowFAQ(true);
//         setShowDashboard(false);
//         setMessages([]);
//     };

//     const handleInputFocus = () => {
//         if (window.innerWidth < 769) {
//             setSidebarActive(false); // Collapse sidebar
//         }
//     };

//     // Handle navigation to a specific dashboard
//     // const handleDashboardNavigation = (dashboardName, url) => {
//     //     stopTyping(); // Stop any typing effect
//     //     setActiveNavItem('Dashboard');
//     //     setActiveDashboard(dashboardName);
//     //     setDashboardUrl(dashboardUrl);
//     //     setShowDashboard(true);
//     //     setShowFAQ(false);
//     //     setActiveChatId(null);
//     //     setMessages([]);
//     //     setInputText('');

//     //     // Track that this dashboard has been loaded
//     //     setLoadedDashboards((prev) => ({
//     //         ...prev,
//     //         [dashboardName]: true,
//     //     }));



//     //     // Add a helpful system message about the dashboard context
//     //     const systemMessage = {
//     //         text: `You're now viewing the ${dashboardName} dashboard. You can ask questions about the data shown here.`,
//     //         sender: 'system',
//     //         timestamp: new Date(),
//     //         dashboardContext: dashboardName,
//     //     };

//     //     // Keep existing messages if they're related to this dashboard
//     //     let newMessages = [];
//     //     if (activeDashboard === dashboardName) {
//     //         newMessages = [...messages, systemMessage];
//     //     } else {
//     //         newMessages = [systemMessage];
//     //     }

//     //     setMessages(newMessages);

//     //     // Generate contextual prompt suggestions based on dashboard type
//     //     let suggestedPrompt = '';
//     //     switch (dashboardName) {
//     //         case 'Customer Details':
//     //             suggestedPrompt = 'What are the top customer segments by revenue?';
//     //             break;
//     //         case 'Vendor Details':
//     //             suggestedPrompt = 'Which vendors have the highest fulfillment rates?';
//     //             break;
//     //         case 'Vendor Aging':
//     //             suggestedPrompt = 'Show me vendors with outstanding payments over 60 days';
//     //             break;
//     //         default:
//     //             suggestedPrompt = `Analyze the data in the ${dashboardName} dashboard`;
//     //     }

//     //     setInputText(suggestedPrompt);
//     // };

//     {/*Input Bar logic*/ }
//     // Move this useEffect outside of the other useEffect
//     // useEffect(() => {
//     //     if (localStorage.getItem('isAuthenticated')) {
//     //         const manager = setupSessionTimeout(navigate);
//     //         setSessionManager(manager);
//     //         window.sessionTimeout = manager; // Make it globally available for the warning component
//     //         manager.startListening();

//     //         return () => {
//     //             manager.stopListening();
//     //         };
//     //     }
//     // }, [navigate]);

//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth < 445) {
//                 setPlaceholder("");
//             } else {
//                 setPlaceholder("Ask Savi...");
//             }
//         };

//         // Add event listener for window resize
//         window.addEventListener("resize", handleResize);

//         // Call the function initially
//         handleResize();

//         // Cleanup
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     useEffect(() => {
//         const handleResize = () => {
//             if (window.innerWidth < 445) {
//                 setPlaceholder("Ask Savi...");
//             } else {
//                 setPlaceholder("Ask Savi...");
//             }
//         };

//         // Add event listener for window resize
//         window.addEventListener("resize", handleResize);

//         // Call the function initially
//         handleResize();

//         // Cleanup
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);


//     useEffect(() => {
//         const handleBackButton = (e) => {
//             // Prevent default back button behavior
//             e.preventDefault();
//             // Optionally, you can show a confirmation message
//             // window.confirm('Are you sure you want to leave?');
//         };

//         // Add event listener when component mounts
//         window.history.pushState(null, null, window.location.pathname);
//         window.addEventListener('popstate', handleBackButton);

//         // Clean up event listener when component unmounts
//         return () => {
//             window.removeEventListener('popstate', handleBackButton);
//         };
//     }, []);
//     useEffect(() => {
//         // Push a new entry to the history stack to prevent going back
//         window.history.pushState(null, '', window.location.pathname);

//         const handlePopState = (e) => {
//             // Prevent default back/forward behavior
//             e.preventDefault();
//             // Keep the user on the current page
//             window.history.pushState(null, '', window.location.pathname);
//         };

//         window.addEventListener('popstate', handlePopState);

//         return () => {
//             window.removeEventListener('popstate', handlePopState);
//         };
//     }, []);

//     // Add this effect to handle click outside
//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             // Only close if click is outside BOTH the dropdown and the settings modal
//             if (
//                 showSignOutOptions &&
//                 !e.target.closest('.sign-out-container') &&
//                 !e.target.closest('.settings-modal')
//             ) {
//                 setShowSignOutOptions(false);
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, [showSignOutOptions]);

//     useEffect(() => {
//         // Only set user initial, do not redirect
//         const userType = localStorage.getItem('userType');
//         const userEmail = userType === 'vendor' 
//             ? localStorage.getItem('userEmail') 
//             : localStorage.getItem('user');
        
//         if (userEmail) {
//             setUserInitial(userEmail.charAt(0).toUpperCase());
//         }
//     }, []);

//     // Auto-scroll to bottom when messages change
//     useEffect(() => {
//         const scrollToBottom = () => {
//             if (messagesEndRef.current) {
//                 // Only scroll if user isn't manually scrolling up
//                 const container = messagesEndRef.current.parentElement;
//                 const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 100;

//                 if (isNearBottom || !messages.length) {
//                     messagesEndRef.current.scrollIntoView({
//                         behavior: 'smooth',
//                         block: 'nearest'
//                     });
//                 }
//             }
//         };

//         // Debounce the scroll to prevent jankiness
//         const debouncedScroll = setTimeout(scrollToBottom, 100);

//         return () => clearTimeout(debouncedScroll);
//     }, [messages]);

//     useEffect(() => {
//         if (showFAQ) setFaqQuestionSelected(false);
//     }, [showFAQ]);

//     useEffect(() => {
//         document.documentElement.setAttribute('data-theme', currentTheme);
//     }, [currentTheme]);

//     useEffect(() => {
//         // This hook ensures chatHistory in localStorage is always synced with state
//         // We debounce to avoid excessive writes
//         const timer = setTimeout(() => {
//             localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
//         }, 300);

//         return () => clearTimeout(timer);
//     }, [chatHistory]);

//     useEffect(() => {
//         const storedHistory = localStorage.getItem('chatHistory');
//         if (storedHistory) {
//             try {
//                 let parsed = JSON.parse(storedHistory);
//                 if (!Array.isArray(parsed)) parsed = [];
//                 // Clean up last chat's messages to avoid duplicate AI responses
//                 if (parsed.length > 0) {
//                     const lastChat = parsed[parsed.length - 1];
//                     if (lastChat && Array.isArray(lastChat.messages)) {
//                         // Remove empty AI messages and duplicate consecutive AI messages
//                         let cleaned = [];
//                         for (let i = 0; i < lastChat.messages.length; i++) {
//                             const msg = lastChat.messages[i];
//                             if (
//                                 msg.sender === 'ai' &&
//                                 (!msg.text || msg.text.trim() === '')
//                             ) {
//                                 continue; // skip empty AI messages
//                             }
//                             if (
//                                 i > 0 &&
//                                 msg.sender === 'ai' &&
//                                 lastChat.messages[i - 1].sender === 'ai'
//                             ) {
//                                 continue; // skip duplicate consecutive AI messages
//                             }
//                             cleaned.push(msg);
//                         }
//                         lastChat.messages = cleaned;
//                     }
//                 }
//                 setChatHistory(parsed);
//                 setTimeout(cleanupDuplicateChats, 1000);
//             } catch (e) {
//                 console.error('Failed to parse chat history:', e);
//                 setChatHistory([]); // fallback to empty
//             }
//         } else {
//             setChatHistory([]); // fallback to empty
//         }
//     }, []);

//     useEffect(() => {
//         const handleResize = () => {
//             setSidebarActive(window.innerWidth > 375);
//         };

//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     useEffect(() => {
//         localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
//     }, [chatHistory]);

//     useEffect(() => {
//         localStorage.setItem('deletedChats', JSON.stringify(deletedChats));
//     }, [deletedChats]);

//     // Typing effect for AI response
//     // useEffect(() => {
//     //     if (!typingMessage) return;

//     //     // Use currentTypingText as the starting point
//     //     let currentText = currentTypingText || (
//     //         typingMessage.originalFullText
//     //             ? typingMessage.originalFullText.substring(0, typingMessage.originalFullText.length - typingMessage.fullText.length)
//     //             : ''
//     //     );

//     //     let i = currentText.length;

//     //     typingInterval.current = setInterval(() => {
//     //         currentText += typingMessage.fullText[i];
//     //         i++;
//     //         setCurrentTypingText(currentText);
//     //         setMessages(prev => {
//     //             const updated = [...prev];
//     //             // Find the last AI message (should be the last message)
//     //             for (let j = updated.length - 1; j >= 0; j--) {
//     //                 if (updated[j].sender === 'ai' && updated[j].isTyping) {
//     //                     updated[j] = {
//     //                         ...updated[j],
//     //                         text: currentText,
//     //                         fullText: typingMessage.originalFullText || typingMessage.fullText
//     //                     };
//     //                     break;
//     //                 }
//     //             }
//     //             return updated;
//     //         });

//     //         if (i >= typingMessage.fullText.length) {
//     //             clearInterval(typingInterval.current);
//     //             setTypingMessage(null);
//     //             setCurrentTypingText('');
//     //             localStorage.removeItem('interruptedChatId');
//     //             // Remove isTyping flag after done
//     //             setMessages(prev => {
//     //                 const updated = [...prev];
//     //                 for (let j = updated.length - 1; j >= 0; j--) {
//     //                     if (updated[j].sender === 'ai' && updated[j].isTyping) {
//     //                         updated[j] = {
//     //                             ...updated[j],
//     //                             isTyping: false,
//     //                             text: typingMessage.originalFullText || currentText
//     //                         };
//     //                         break;
//     //                     }
//     //                 }
//     //                 // Also update chatHistory with the final AI message
//     //                 if (activeChatId) {
//     //                     setChatHistory(prevHistory =>
//     //                         prevHistory.map(chat =>
//     //                             chat.id === activeChatId
//     //                                 ? {
//     //                                     ...chat,
//     //                                     messages: updated
//     //                                 }
//     //                                 : chat
//     //                         )
//     //                     );
//     //                 }
//     //                 return updated;
//     //             });
//     //         }
//     //     }, 14); // Typing speed (ms per character)

//     //     return () => clearInterval(typingInterval.current);
//     // }, [typingMessage, currentTypingText, activeChatId]); 


//     // In your useEffect for typing effect
//     useEffect(() => {
//         if (!typingMessage) return;

//         // Use currentTypingText as the starting point
//         let currentText = currentTypingText || (
//             typingMessage.originalFullText
//                 ? typingMessage.originalFullText.substring(0, typingMessage.originalFullText.length - typingMessage.fullText.length)
//                 : ''
//         );

//         let i = currentText.length;
//         const chunkSize = 3; // Type 3 characters at a time for faster appearance
//         const typingSpeed = 5; // Reduced from 14ms to 5ms per chunk

//         typingInterval.current = setInterval(() => {
//             // Add a chunk of characters at once
//             const chunk = typingMessage.fullText.substring(i, i + chunkSize);
//             currentText += chunk;
//             i += chunkSize;

//             setCurrentTypingText(currentText);
//             setMessages(prev => {
//                 const updated = [...prev];
//                 // Find the last AI message (should be the last message)
//                 for (let j = updated.length - 1; j >= 0; j--) {
//                     if (updated[j].sender === 'ai' && updated[j].isTyping) {
//                         updated[j] = {
//                             ...updated[j],
//                             text: currentText,
//                             fullText: typingMessage.originalFullText || typingMessage.fullText
//                         };
//                         break;
//                     }
//                 }
//                 return updated;
//             });

//             if (i >= typingMessage.fullText.length) {
//                 clearInterval(typingInterval.current);
//                 setTypingMessage(null);
//                 setCurrentTypingText('');
//                 localStorage.removeItem('interruptedChatId');
                
//                 // Remove isTyping flag after done
//                 setMessages(prev => {
//                     const updated = [...prev];
//                     let messageIndex = -1;
//                     for (let j = updated.length - 1; j >= 0; j--) {
//                         if (updated[j].sender === 'ai' && updated[j].isTyping) {
//                             updated[j] = {
//                                 ...updated[j],
//                                 isTyping: false,
//                                 text: typingMessage.originalFullText || currentText
//                             };
//                             messageIndex = j;
//                             break;
//                         }
//                     }
                    
//                     // Check if there are pending visualizations for this message
//                     if (messageIndex !== -1 && pendingVisualizations[messageIndex]) {
//                         const visualizationData = pendingVisualizations[messageIndex];
                        
//                         // Start chart loading indicator
//                         setChartLoadingStates(prev => ({
//                             ...prev,
//                             [messageIndex]: true
//                         }));
                        
//                         // Progress animation: 10% -> 50% -> 75% -> 100%
//                         const progressSteps = [10, 50, 75, 100];
//                         const stepDuration = 1250; // 5000ms / 4 steps = 1250ms per step
                        
//                         progressSteps.forEach((progress, stepIndex) => {
//                             setTimeout(() => {
//                                 setChartLoadingProgress(prev => ({
//                                     ...prev,
//                                     [messageIndex]: progress
//                                 }));
                                
//                                 // When progress reaches 100%, show all charts
//                                 if (progress === 100) {
//                                     setTimeout(() => {
//                                         setMessages(prevMessages => {
//                                             const updatedMessages = [...prevMessages];
//                                             if (updatedMessages[messageIndex]) {
//                                                 updatedMessages[messageIndex] = {
//                                                     ...updatedMessages[messageIndex],
//                                                     visualizations: visualizationData
//                                                 };
//                                             }
//                                             return updatedMessages;
//                                         });
                                        
//                                         setChartLoadingStates(prev => {
//                                             const newStates = { ...prev };
//                                             delete newStates[messageIndex];
//                                             return newStates;
//                                         });
                                        
//                                         setChartLoadingProgress(prev => {
//                                             const newProgress = { ...prev };
//                                             delete newProgress[messageIndex];
//                                             return newProgress;
//                                         });
                                        
//                                         // Update chat history with complete visualizations
//                                         if (activeChatId) {
//                                             setChatHistory(prevHistory => 
//                                                 prevHistory.map(chat => {
//                                                     if (chat.id === activeChatId) {
//                                                         const updatedChatMessages = [...chat.messages];
//                                                         if (updatedChatMessages[messageIndex]) {
//                                                             updatedChatMessages[messageIndex] = {
//                                                                 ...updatedChatMessages[messageIndex],
//                                                                 visualizations: visualizationData
//                                                             };
//                                                         }
//                                                         return { ...chat, messages: updatedChatMessages };
//                                                     }
//                                                     return chat;
//                                                 })
//                                             );
//                                         }
//                                     }, 200); // Small delay after reaching 100%
//                                 }
//                             }, (stepIndex + 1) * stepDuration);
//                         });
                        
//                         // Clear pending visualization
//                         setPendingVisualizations(prev => {
//                             const newPending = { ...prev };
//                             delete newPending[messageIndex];
//                             return newPending;
//                         });
//                     }
                    
//                     // Also update chatHistory with the final AI message
//                     if (activeChatId) {
//                         setChatHistory(prevHistory =>
//                             prevHistory.map(chat =>
//                                 chat.id === activeChatId
//                                     ? {
//                                         ...chat,
//                                         messages: updated
//                                     }
//                                     : chat
//                             )
//                         );
//                     }
//                     return updated;
//                 });
//             }
//         }, typingSpeed); // Reduced typing speed (ms per chunk)

//         return () => clearInterval(typingInterval.current);
//     }, [typingMessage, currentTypingText, activeChatId]);

//     useEffect(() => {
//         // Save incomplete AI response if user leaves chat or component unmounts
//         return () => {
//             if (typingMessage && activeChatId && currentTypingText) {
//                 setChatHistory(prevHistory => {
//                     return prevHistory.map(chat => {
//                         if (chat.id === activeChatId) {
//                             // Find last AI message (with isTyping)
//                             const updatedMessages = [...chat.messages];
//                             let found = false;
//                             for (let i = updatedMessages.length - 1; i >= 0; i--) {
//                                 if (updatedMessages[i].sender === 'ai' && updatedMessages[i].isTyping) {
//                                     const fullText = typingMessage.originalFullText || typingMessage.fullText;
//                                     const isComplete = currentTypingText === fullText;
//                                     updatedMessages[i] = {
//                                         ...updatedMessages[i],
//                                         text: currentTypingText,
//                                         isTyping: !isComplete,
//                                         fullText: fullText
//                                     };
//                                     found = true;
//                                     break;
//                                 }
//                             }
//                             // Only add a new AI message if not found AND we have meaningful content
//                             if (!found && currentTypingText && currentTypingText.trim()) {
//                                 updatedMessages.push({
//                                     text: currentTypingText,
//                                     sender: 'ai',
//                                     timestamp: new Date(),
//                                     type: 'text',
//                                     isTyping: true,
//                                     fullText: typingMessage.originalFullText || typingMessage.fullText
//                                 });
//                             }
//                             return { ...chat, messages: updatedMessages };
//                         }
//                         return chat;
//                     });
//                 });
//             }
//         };
//     }, [activeChatId, typingMessage, currentTypingText]);

//     useEffect(() => {
//         // Load saved theme
//         const savedTheme = localStorage.getItem('theme') || 'light';
//         document.documentElement.setAttribute('data-theme', savedTheme);
//         setCurrentTheme(savedTheme);
//     }, []);

//     //  add detection for system preferences
//     useEffect(() => {
//         // Check for saved theme preference
//         const savedTheme = localStorage.getItem('theme');

//         if (!savedTheme) {
//             // If no saved preference, check system preference
//             const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
//             const defaultTheme = prefersDark ? 'dark' : 'light';
//             setCurrentTheme(defaultTheme);
//         }
//     }, []);

//     const stopTyping = () => {
//         if (typingInterval.current) {
//             clearInterval(typingInterval.current);
//         }

//         const incompleteText = currentTypingText;

//         setTypingMessage(null);
//         setCurrentTypingText('');

//         setMessages(prev => {
//             const updated = prev.map((msg, index) => {
//                 if (msg.sender === 'ai' && msg.isTyping) {
//                     const fullText = msg.fullText || msg.text;
//                     // Always set isTyping: false when manually stopped
//                     const updatedMsg = {
//                         ...msg,
//                         text: incompleteText || msg.text, // Fallback to existing text if incompleteText is empty
//                         isTyping: false, // Always set to false when manually stopped
//                         fullText: fullText // always preserve fullText for resuming
//                     };
                    
//                     // Check if there are pending visualizations for this message
//                     if (pendingVisualizations[index]) {
//                         const visualizationData = pendingVisualizations[index];
                        
//                         // Start chart loading indicator
//                         setChartLoadingStates(prevStates => ({
//                             ...prevStates,
//                             [index]: true
//                         }));
                        
//                         // Progress animation: 10% -> 50% -> 75% -> 100%
//                         const progressSteps = [10, 50, 75, 100];
//                         const stepDuration = 1250; // 5000ms / 4 steps = 1250ms per step
                        
//                         progressSteps.forEach((progress, stepIndex) => {
//                             setTimeout(() => {
//                                 setChartLoadingProgress(prev => ({
//                                     ...prev,
//                                     [index]: progress
//                                 }));
                                
//                                 // When progress reaches 100%, show all charts
//                                 if (progress === 100) {
//                                     setTimeout(() => {
//                                         setMessages(prevMessages => {
//                                             const updatedMessages = [...prevMessages];
//                                             if (updatedMessages[index]) {
//                                                 updatedMessages[index] = {
//                                                     ...updatedMessages[index],
//                                                     visualizations: visualizationData
//                                                 };
//                                             }
//                                             return updatedMessages;
//                                         });
                                        
//                                         setChartLoadingStates(prevStates => {
//                                             const newStates = { ...prevStates };
//                                             delete newStates[index];
//                                             return newStates;
//                                         });
                                        
//                                         setChartLoadingProgress(prev => {
//                                             const newProgress = { ...prev };
//                                             delete newProgress[index];
//                                             return newProgress;
//                                         });
                                        
//                                         // Update chat history with complete visualizations
//                                         if (activeChatId) {
//                                             setChatHistory(prevHistory => 
//                                                 prevHistory.map(chat => {
//                                                     if (chat.id === activeChatId) {
//                                                         const updatedChatMessages = [...chat.messages];
//                                                         if (updatedChatMessages[index]) {
//                                                             updatedChatMessages[index] = {
//                                                                 ...updatedChatMessages[index],
//                                                                 visualizations: visualizationData
//                                                             };
//                                                         }
//                                                         return { ...chat, messages: updatedChatMessages };
//                                                     }
//                                                     return chat;
//                                                 })
//                                             );
//                                         }
//                                     }, 200); // Small delay after reaching 100%
//                                 }
//                             }, (stepIndex + 1) * stepDuration);
//                         });
                        
//                         // Clear pending visualization
//                         setPendingVisualizations(prevPending => {
//                             const newPending = { ...prevPending };
//                             delete newPending[index];
//                             return newPending;
//                         });
//                     }
                    
//                     return updatedMsg;
//                 }
//                 return msg;
//             });

//             // Update chat history if there's an active chat
//             if (activeChatId) {
//                 setChatHistory(prevHistory =>
//                     prevHistory.map(chat =>
//                         chat.id === activeChatId
//                             ? { ...chat, messages: updated }
//                             : chat
//                     )
//                 );
//             }

//             // Save interrupted chat id if not complete and we have meaningful content
//             if (activeChatId && incompleteText && typingMessage) {
//                 const fullText = typingMessage.originalFullText || typingMessage.fullText;
//                 if (incompleteText !== fullText && incompleteText.trim()) {
//                     localStorage.setItem('interruptedChatId', activeChatId);
//                 } else {
//                     localStorage.removeItem('interruptedChatId');
//                 }
//             }

//             return updated;
//         });
//     };

//     const cancelRequest = () => {
//         // Cancel any ongoing API request
//         if (currentRequestRef.current) {
//             currentRequestRef.current.abort();
//             currentRequestRef.current = null;
//         }

//         // Stop any typing animation
//         stopTyping();

//         // Reset loading state
//         setLoading(false);

//         // Remove the last user message and any pending AI response
//         setMessages(prev => {
//             // Find the last user message and remove it along with any pending AI response
//             const filtered = prev.filter((msg, index) => {
//                 // Keep all messages except the last user message and any AI response that's currently typing
//                 if (msg.sender === 'ai' && (msg.isTyping || msg.text === '')) {
//                     return false;
//                 }
//                 // Check if this is the last user message (most recent one)
//                 const lastUserIndex = [...prev].reverse().findIndex(m => m.sender === 'user');
//                 const actualLastUserIndex = lastUserIndex >= 0 ? prev.length - 1 - lastUserIndex : -1;
//                 return index !== actualLastUserIndex;
//             });
//             return filtered;
//         });

//         // Update chat history
//         if (activeChatId) {
//             setChatHistory(prevHistory =>
//                 prevHistory.map(chat => {
//                     if (chat.id === activeChatId) {
//                         const filtered = chat.messages.filter((msg, index) => {
//                             if (msg.sender === 'ai' && (msg.isTyping || msg.text === '')) {
//                                 return false;
//                             }
//                             const lastUserIndex = [...chat.messages].reverse().findIndex(m => m.sender === 'user');
//                             const actualLastUserIndex = lastUserIndex >= 0 ? chat.messages.length - 1 - lastUserIndex : -1;
//                             return index !== actualLastUserIndex;
//                         });
//                         return { ...chat, messages: filtered };
//                     }
//                     return chat;
//                 })
//             );
//         }
//     };

//     const toggleSidebar = () => {
//         setSidebarActive(!isSidebarActive);
//     };

//     const generateLocalResponse = (message) => {
//         // Simple fallback response generator
//         const responses = [
//             `I'm currently operating in offline mode due to connection issues. Your message was: "${message}"`,
//             `I couldn't reach my AI service, but I've received your message: "${message}". Please try again later.`,
//             `Thanks for your message. I'm experiencing connection issues with my backend service. Your input has been saved.`
//         ];

//         return responses[Math.floor(Math.random() * responses.length)];
//     };

//     // Function to clean up formatting and convert markdown to HTML-like formatting
//     const cleanFormatting = (text) => {
//         if (!text) return '';

//         // Remove dtype lines completely
//         text = text.replace(/\s*dtype:\s*\w+\s*[\r\n]*/g, '');

//         // Clean up data frame indices for better readability
//         text = text.replace(/^\s*\d+\s+/gm, '');

//         // Replace markdown headers with clean bold text
//         text = text.replace(/^#+\s*(.*?)\s*#*$/gm, '<strong>$1</strong>');

//         // Replace **bold** with <strong>
//         text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

//         // Replace *italic* with <em>
//         text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');

//         // Replace literal \n with actual line breaks
//         text = text.replace(/\\n/g, '\n');

//         // Replace markdown lists with HTML-like lists
//         text = text.replace(/^\s*[-*+]\s+(.*)/gm, '• $1');

//         // Add special formatting for key metrics and values
//         text = text.replace(/(\d+(\.\d+)?)%/g, '<span class="metric-value">$1%</span>');

//         // Format dates to be more visible
//         text = text.replace(/(\d{4}-\d{2}-\d{2}|\d{2}\/\d{2}\/\d{4})/g,
//             '<span class="date-value">$1</span>');

//         return text;
//     };

//     const formatResponse = (data) => {
//         // Check for error messages specifically
//         if (data.error) {
//             return { text: `Error: ${data.error}`, visualizations: null };
//         }

//         // Handle Django API response format (invoice upload)
//         // Check for results object regardless of success flag (backend might return success: false even with data)
//         if (data.results && typeof data.results === 'object') {
//             // Store invoice data for table display
//             setInvoiceData(data.results);
            
//             // Debug logging
//             console.log('📊 Invoice Data Received:', {
//                 success: data.success,
//                 total: data.results.total_invoices_loaded,
//                 successful: data.results.successful_pushed_invoices,
//                 failed: data.results.failed_invoices_count,
//                 extractedDataLength: data.results.extracted_data?.length || 0,
//                 hasExtractedData: !!(data.results.extracted_data && data.results.extracted_data.length > 0)
//             });
            
//             // Return minimal text with table display flag
//             const summaryText = data.message ? `${data.message}` : 'Invoice processing completed';
//             return { 
//                 text: summaryText, 
//                 visualizations: null,
//                 showInvoiceTables: true,
//                 invoiceResults: data.results 
//             };
//         }

//         // Simple response with just a message
//         if (data.response) {
//             // Check if the response field contains stringified JSON with visualizations
//             try {
//                 const parsedResponse = JSON.parse(data.response);
//                 if (parsedResponse.visualizations || parsedResponse.visualisation || parsedResponse.summary) {
//                     let formattedText = '';
//                     let visualizations = null;

//                     // Handle the summary text
//                     if (parsedResponse.summary) {
//                         formattedText += cleanFormatting(parsedResponse.summary);
//                     }

//                     // Extract visualizations (handle both spellings: visualizations and visualisation)
//                     if (parsedResponse.visualizations && Array.isArray(parsedResponse.visualizations)) {
//                         visualizations = parsedResponse.visualizations;
//                     } else if (parsedResponse.visualisation) {
//                         // Single visualization object, convert to array
//                         visualizations = [parsedResponse.visualisation];
//                     }

//                     return { text: formattedText, visualizations: visualizations };
//                 }
//             } catch (e) {
//                 // If parsing fails, treat as regular text response
//             }
            
//             return { text: cleanFormatting(data.response), visualizations: null };
//         }

//         // Check for report/analysis structure
//         if (data.report || data.ai_insights) {
//             let formattedText = '';

//             // Add a header for report section if it exists
//             if (data.report) {
//                 formattedText += '<strong>📊 Analysis Report</strong>\n\n';
//                 formattedText += cleanFormatting(data.report);
//             }

//             // Add a separator if both sections exist
//             if (data.report && data.ai_insights) {
//                 formattedText += '\n\n';
//             }

//             // Add a header for insights section if it exists
//             if (data.ai_insights) {
//                 formattedText += '<strong>💡 AI Insights</strong>\n\n';
//                 formattedText += cleanFormatting(data.ai_insights);
//             }

//             return { text: formattedText, visualizations: null };
//         }

//         // Check for visualization data in the response
//         if (data.visualizations || data.charts) {
//             let formattedText = '';
//             let visualizations = null;

//             // Handle the summary text
//             if (data.summary) {
//                 formattedText += cleanFormatting(data.summary);
//             } else {
//                 formattedText += '<strong>📈 Data Visualization</strong>';
//             }

//             // Extract visualizations
//             if (data.visualizations && Array.isArray(data.visualizations)) {
//                 visualizations = data.visualizations;
//             } else if (data.charts && Array.isArray(data.charts)) {
//                 visualizations = data.charts;
//             }

//             return { text: formattedText, visualizations: visualizations };
//         }

//         // Check for other common fields
//         const possibleFields = ['message', 'content', 'answer', 'text'];
//         for (const field of possibleFields) {
//             if (data[field]) {
//                 return { text: cleanFormatting(data[field]), visualizations: null };
//             }
//         }

//         // OpenAI format
//         if (data.choices && data.choices[0]?.message?.content) {
//             return { text: cleanFormatting(data.choices[0].message.content), visualizations: null };
//         }

//         // If we can't find a specific field to extract, format the entire object
//         return { text: cleanFormatting(JSON.stringify(data, null, 2)), visualizations: null };
//     };


//     // const parseApiResponse = (responseData) => {
//     //             if (typeof responseData === 'string') {
//     //                 return responseData;
//     //             } else if (responseData && typeof responseData === 'object') {
//     //                 return responseData.response || JSON.stringify(responseData, null, 2);
//     //             }
//     //             return String(responseData);
//     //         };
//     const chatSessionRef = useRef(0);

    


//     // Helper function to detect message types
//     const detectMessageType = (input) => {
//         const lowerInput = input.toLowerCase();
        
//         const greetings = [
//             'hi', 'hello', 'hey', 'greetings', 'good morning', 'good afternoon', 'good evening'
//         ];
        
//         const farewells = [
//             'bye', 'goodbye', 'see you', 'see ya', 'take care', 'farewell', 'have a good day',
//             'later', 'signing off', 'talk later', 'catch you later'
//         ];

//         const isGreeting = greetings.some(greet => lowerInput.startsWith(greet));
//         const isFarewell = farewells.some(farewell => lowerInput.includes(farewell));

//         return { isGreeting, isFarewell };
//     };

//     // Helper function to generate contextual responses
//     const generateContextualResponse = (messageType) => {
//         if (messageType.isGreeting) {
//             return `Hi there! 👋<br/>
// I'm SAVICAI — your AI assistant for Sales, Revenue, and Business Insights.<br/>
// What would you like to do today?<br/>
// You can ask me things like:<br/>
// • "Summarize my sales pipeline"<br/>
// • "Give me revenue insights for Q2"<br/>
// • "Update a customer status in CRM"<br/>
// Just type your request, and I'll take care of the rest.`;
//         }
        
//         if (messageType.isFarewell) {
//             const farewellMessages = [
//                 `Goodbye! 👋<br/>It was great assisting you today.<br/>`,
//                 `Until next time! 😊<br/>Don't hesitate to return if you need help!<br/>Take care!`,
//                 `See you soon! 🌟<br/>`,
//                 `Farewell for now! 💼<br/>`,
//                 `Take care! 📊<br/>`
//             ];
//             return farewellMessages[Math.floor(Math.random() * farewellMessages.length)];
//         }
        
//         return null;
//     };

//     // Helper function to create a standardized message object
//     const createMessage = (text, sender, type = 'text', isTyping = false, visualizations = null, attachments = null, showInvoiceTables = false, invoiceResults = null) => ({
//         text: sender === 'user' ? sanitizeInput(text) : text,
//         sender,
//         timestamp: new Date(),
//         type,
//         ...(isTyping && { isTyping: true }),
//         ...(visualizations && { visualizations }),
//         ...(attachments && { attachments }),
//         ...(showInvoiceTables && { showInvoiceTables, invoiceResults })
//     });

//     // Helper function to update chat history efficiently
//     const updateChatHistory = (chatId, messages, title) => {
//         setChatHistory(prevHistory => {
//             const existingChatIndex = prevHistory.findIndex(chat => chat.id === chatId);
            
//             if (existingChatIndex >= 0) {
//                 // Update existing chat
//                 const updatedHistory = [...prevHistory];
//                 updatedHistory[existingChatIndex] = {
//                     ...updatedHistory[existingChatIndex],
//                     messages
//                 };
//                 return updatedHistory;
//             } else {
//                 // Add new chat
//                 return [...prevHistory, {
//                     id: chatId,
//                     title: title || `New Chat ${new Date().toLocaleTimeString()}`,
//                     messages,
//                     createdAt: new Date()
//                 }];
//             }
//         });
//     };

//     // Helper function to handle UI state updates
//     const updateUIState = (chatId, clearUploadedDoc = true) => {
//         setActiveChatId(chatId);
//         setShowDashboard(false);
//         setShowFAQ(false);
//         setActiveNavItem('Chat');
//         // uploadedDocument functionality removed
//     };

//     // Helper function to handle API errors with better categorization
//     const handleAPIError = (error, originalInput) => {
//         console.error('API call failed:', error);
        
//         let errorMessage;
        
//         if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
//             errorMessage = "Request timed out. Please try again with a shorter message.";
//         } else if (error.response?.status === 429) {
//             errorMessage = "I'm receiving too many requests right now. Please try again in a moment.";
//         } else if (error.response?.status === 503) {
//             errorMessage = "Service is temporarily unavailable. Please try again later.";
//         } else if (error.response?.status >= 500) {
//             errorMessage = "Server error occurred. Please try again later.";
//         } else if (!navigator.onLine) {
//             errorMessage = "No internet connection. Please check your network and try again.";
//         } else {
//             errorMessage = generateLocalResponse(originalInput);
//         }
        
//         return errorMessage;
//     };

//     // const handleSendMessage = async () => {
//     //     // Early validation - prevent multiple sends
//     //     if ((!inputText?.trim() && selectedFiles.length === 0) || loading || typingMessage) return;

//     //     const originalInput = inputText.trim();
//     //     const messageType = detectMessageType(originalInput);
        
//     //     // If only files are uploaded without text, show a placeholder message
//     //     const displayText = originalInput || (selectedFiles.length > 0 ? `📎 Uploaded ${selectedFiles.length} document${selectedFiles.length > 1 ? 's' : ''}` : '');
        
//     //     // Create user message with attachments and update UI immediately
//     //     const userMessage = createMessage(displayText, 'user', 'text', false, null, selectedFiles.length > 0 ? [...selectedFiles] : null);
//     //     const updatedMessages = [...messages, userMessage];
//     //     setMessages(updatedMessages);
        
//     //     // Clear input and attachments
//     //     setInputText('');
//     //     const attachedFiles = [...selectedFiles];
//     //     setSelectedFiles([]);

//     //     // Get or create chat ID
//     //     const currentChatId = activeChatId || createNewChat(updatedMessages, originalInput);
//     //     const chatTitle = originalInput.substring(0, 30);

//     //     // Handle contextual responses (greetings/farewells) - but not if there are attachments
//     //     if ((messageType.isGreeting || messageType.isFarewell) && attachedFiles.length === 0) {
//     //         const responseText = generateContextualResponse(messageType);
//     //         const aiMessage = createMessage(responseText, 'ai');
//     //         const finalMessages = [...updatedMessages, aiMessage];
            
//     //         setMessages(finalMessages);
//     //         updateChatHistory(currentChatId, finalMessages, chatTitle);
//     //         updateUIState(currentChatId, false);
//     //         return;
//     //     }

//     //     // Handle API requests
//     //     setLoading(true);
//     //     setIsUploading(attachedFiles.length > 0);
        
//     //     try {
//     //         // Select API endpoint based on whether files are attached
//     //         const endpoint = attachedFiles.length > 0 
//     //             ? 'https://ocrtool.savictech.com/api/'  // New API for document uploads
//     //             : process.env.REACT_APP_UNIFIED_API;  // Unified API for text-only
            
//     //         if (!endpoint) {
//     //             throw new Error('API endpoint not configured');
//     //         }

//     //         // Create AbortController for request cancellation
//     //         const abortController = new AbortController();
//     //         currentRequestRef.current = abortController;

//     //         // Prepare API request with files if any
//     //         let response;
//     //         if (attachedFiles.length > 0) {
//     //             // Create FormData for file upload
//     //             const formData = new FormData();
//     //             formData.append('action', 'upload_invoice');
                
//     //             attachedFiles.forEach((fileData) => {
//     //                 formData.append('invoice', fileData.file);
//     //             });

//     //             response = await axios.post(endpoint, formData, {
//     //                 headers: { 
//     //                     'Content-Type': 'multipart/form-data'
//     //                 },
//     //                 timeout: 120000, // Longer timeout for file uploads
//     //                 signal: abortController.signal,
//     //                 maxRetries: 2,
//     //                 retryDelay: 1000,
//     //                 onUploadProgress: (progressEvent) => {
//     //                     // You could add upload progress indication here
//     //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//     //                     console.log(`Upload Progress: ${percentCompleted}%`);
//     //                 }
//     //             });
//     //         } else {
//     //             // Regular text-only request
//     //             const payload = { question: originalInput };
//     //             response = await axios.post(endpoint, payload, {
//     //                 headers: { 'Content-Type': 'application/json' },
//     //                 timeout: 60000,
//     //                 signal: abortController.signal,
//     //                 maxRetries: 2,
//     //                 retryDelay: 1000
//     //             });
//     //         }

//     //         // Clear the request ref after successful completion
//     //         currentRequestRef.current = null;

//     //         // Process successful response
//     //         console.log('🔍 Full API Response:', response.data);
            
//     //         const aiFullText = parseApiResponse(response.data) || 'No response received';
//     //         const visualizationData = extractVisualizationData(response.data);
//     //         const tableData = extractInvoiceTableData(response.data);
            
//     //         console.log('🔍 Table Data:', {
//     //             showInvoiceTables: tableData.showInvoiceTables,
//     //             hasInvoiceResults: !!tableData.invoiceResults,
//     //             extractedDataLength: tableData.invoiceResults?.extracted_data?.length
//     //         });
            
//     //         // Check if this is an invoice upload response with table data
//     //         if (tableData.showInvoiceTables && tableData.invoiceResults) {
//     //             console.log('✅ Invoice upload detected - showing tables immediately');
//     //             // For invoice uploads, show the complete message immediately with tables
//     //             const aiMessage = createMessage(aiFullText, 'ai', 'text', false, null, null, tableData.showInvoiceTables, tableData.invoiceResults);
//     //             const finalMessages = [...updatedMessages, aiMessage];
                
//     //             console.log('📋 AI Message created:', {
//     //                 hasShowInvoiceTables: aiMessage.showInvoiceTables,
//     //                 hasInvoiceResults: !!aiMessage.invoiceResults,
//     //                 invoiceResultsKeys: aiMessage.invoiceResults ? Object.keys(aiMessage.invoiceResults) : []
//     //             });
                
//     //             setMessages(finalMessages);
//     //             updateChatHistory(currentChatId, finalMessages, chatTitle);
//     //             updateUIState(currentChatId);
//     //         } else {
//     //             console.log('ℹ️ Regular text response - using typing animation');

//     //             // For regular text responses, use typing animation
//     //             // Create AI message with summary only first
//     //             const aiMessage = createMessage('', 'ai', 'text', true, null, null, false, null);
//     //             const finalMessages = [...updatedMessages, aiMessage];
                
//     //             setMessages(finalMessages);
//     //             setTypingMessage({ fullText: aiFullText });
                
//     //             // If there are visualizations, store them for delayed loading after typing completes
//     //             if (visualizationData) {
//     //                 const messageIndex = finalMessages.length - 1;
//     //                 setPendingVisualizations(prev => ({
//     //                     ...prev,
//     //                     [messageIndex]: visualizationData
//     //                 }));
//     //             }
                
//     //             updateChatHistory(currentChatId, finalMessages, chatTitle);
//     //             updateUIState(currentChatId);
//     //         }

//     //     } catch (error) {
//     //         // Clear the request ref
//     //         currentRequestRef.current = null;
            
//     //         // Handle request cancellation
//     //         if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
//     //             // Request was cancelled, don't show error message
//     //             return;
//     //         }
            
//     //         // Handle API errors gracefully
//     //         const errorMessage = handleAPIError(error, originalInput);
//     //         const aiMessage = createMessage('', 'ai', 'text', true);
//     //         const finalMessages = [...updatedMessages, aiMessage];
            
//     //         setMessages(finalMessages);
//     //         setTypingMessage({ fullText: sanitizeInput(errorMessage) });
//     //         updateChatHistory(currentChatId, finalMessages, chatTitle);
//     //         updateUIState(currentChatId);
            
//     //     } finally {
//     //         setLoading(false);
//     //         setIsUploading(false);
//     //     }
//     // };

//     // Main handleSendMessage function - now much cleaner and more maintainable
//     const handleSendMessage = async () => {
//         // Early validation - prevent multiple sends
//         if ((!inputText?.trim() && selectedFiles.length === 0) || loading || typingMessage) return;

//         const originalInput = inputText.trim();
//         const messageType = detectMessageType(originalInput);
        
//         // If only files are uploaded without text, show a placeholder message
//         const displayText = originalInput || (selectedFiles.length > 0 ? `📎 Uploaded ${selectedFiles.length} document${selectedFiles.length > 1 ? 's' : ''}` : '');
        
//         // Create user message with attachments and update UI immediately
//         const userMessage = createMessage(displayText, 'user', 'text', false, null, selectedFiles.length > 0 ? [...selectedFiles] : null);
//         const updatedMessages = [...messages, userMessage];
//         setMessages(updatedMessages);
        
//         // Clear input and attachments
//         setInputText('');
//         const attachedFiles = [...selectedFiles];
//         setSelectedFiles([]);

//         // Get or create chat ID
//         const currentChatId = activeChatId || createNewChat(updatedMessages, originalInput);
//         const chatTitle = originalInput.substring(0, 30);

//         // Handle contextual responses (greetings/farewells) - but not if there are attachments
//         if ((messageType.isGreeting || messageType.isFarewell) && attachedFiles.length === 0) {
//             const responseText = generateContextualResponse(messageType);
//             const aiMessage = createMessage(responseText, 'ai');
//             const finalMessages = [...updatedMessages, aiMessage];
            
//             setMessages(finalMessages);
//             updateChatHistory(currentChatId, finalMessages, chatTitle);
//             updateUIState(currentChatId, false);
//             return;
//         }

//         // Check if user is sending text-only (no files attached) - this would use unified API which user doesn't have access to
//         if (attachedFiles.length === 0 && originalInput.length > 0) {
//             // User is sending text-only query - they don't have access to unified API
//             // Politely deny and suggest uploading documents instead
//             const denialMessages = [
//                 "I appreciate your question! However, I'm specifically designed to process documents and invoices. To help you, please upload a file (PDF, image, etc.) and I'll extract the information for you. 📄✨",
//                 "Thanks for reaching out! I work best with document uploads. Please upload your invoice, receipt, or any document you'd like me to analyze, and I'll get the data for you right away! 📋",
//                 "Great to help! I'm currently configured to handle document processing only. Could you please upload a document or image, and I'll extract the information you need? 📑",
//                 "I appreciate the question! I'm specialized in document and invoice processing. Please upload your file, and I'll assist you with extracting the data you need. 📄"
//             ];
            
//             const denialMessage = denialMessages[Math.floor(Math.random() * denialMessages.length)];
//             const aiMessage = createMessage(denialMessage, 'ai');
//             const finalMessages = [...updatedMessages, aiMessage];
            
//             setMessages(finalMessages);
//             updateChatHistory(currentChatId, finalMessages, chatTitle);
//             updateUIState(currentChatId, false);
//             return;
//         }

//         // Handle API requests for file uploads only
//         setLoading(true);
//         setIsUploading(attachedFiles.length > 0);
        
//         try {
//             // Only proceed if files are attached (OCR API)
//             if (attachedFiles.length === 0) {
//                 throw new Error('No files attached - cannot proceed');
//             }

//             const endpoint = 'https://ocrtool.savictech.com/api/';  // OCR API for document uploads
            
//             if (!endpoint) {
//                 throw new Error('API endpoint not configured');
//             }

//             // Create AbortController for request cancellation
//             const abortController = new AbortController();
//             currentRequestRef.current = abortController;

//             // Create FormData for file upload
//             const formData = new FormData();
//             formData.append('action', 'upload_invoice');
            
//             attachedFiles.forEach((fileData) => {
//                 formData.append('invoice', fileData.file);
//             });

//             const response = await axios.post(endpoint, formData, {
//                 headers: { 
//                     'Content-Type': 'multipart/form-data'
//                     },
//                     timeout: 120000, // Longer timeout for file uploads
//                     signal: abortController.signal,
//                     maxRetries: 2,
//                     retryDelay: 1000,
//                     onUploadProgress: (progressEvent) => {
//                         // You could add upload progress indication here
//                         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                         console.log(`Upload Progress: ${percentCompleted}%`);
//                     }
//                 });

//             // Clear the request ref after successful completion
//             currentRequestRef.current = null;

//             // Process successful response
//             console.log('🔍 Full API Response:', response.data);
            
//             const aiFullText = parseApiResponse(response.data) || 'No response received';
//             const visualizationData = extractVisualizationData(response.data);
//             const tableData = extractInvoiceTableData(response.data);
            
//             console.log('🔍 Table Data:', {
//                 showInvoiceTables: tableData.showInvoiceTables,
//                 hasInvoiceResults: !!tableData.invoiceResults,
//                 extractedDataLength: tableData.invoiceResults?.extracted_data?.length
//             });
            
//             // Check if this is an invoice upload response with table data
//             if (tableData.showInvoiceTables && tableData.invoiceResults) {
//                 console.log('✅ Invoice upload detected - showing tables immediately');
//                 // For invoice uploads, show the complete message immediately with tables
//                 const aiMessage = createMessage(aiFullText, 'ai', 'text', false, null, null, tableData.showInvoiceTables, tableData.invoiceResults);
//                 const finalMessages = [...updatedMessages, aiMessage];
                
//                 console.log('📋 AI Message created:', {
//                     hasShowInvoiceTables: aiMessage.showInvoiceTables,
//                     hasInvoiceResults: !!aiMessage.invoiceResults,
//                     invoiceResultsKeys: aiMessage.invoiceResults ? Object.keys(aiMessage.invoiceResults) : []
//                 });
                
//                 setMessages(finalMessages);
//                 updateChatHistory(currentChatId, finalMessages, chatTitle);
//                 updateUIState(currentChatId);
//             } else {
//                 console.log('ℹ️ Regular text response - using typing animation');

//                 // For regular text responses, use typing animation
//                 // Create AI message with summary only first
//                 const aiMessage = createMessage('', 'ai', 'text', true, null, null, false, null);
//                 const finalMessages = [...updatedMessages, aiMessage];
                
//                 setMessages(finalMessages);
//                 setTypingMessage({ fullText: aiFullText });
                
//                 // If there are visualizations, store them for delayed loading after typing completes
//                 if (visualizationData) {
//                     const messageIndex = finalMessages.length - 1;
//                     setPendingVisualizations(prev => ({
//                         ...prev,
//                         [messageIndex]: visualizationData
//                     }));
//                 }
                
//                 updateChatHistory(currentChatId, finalMessages, chatTitle);
//                 updateUIState(currentChatId);
//             }

//         } catch (error) {
//             // Clear the request ref
//             currentRequestRef.current = null;
            
//             // Handle request cancellation
//             if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
//                 // Request was cancelled, don't show error message
//                 return;
//             }
            
//             // Handle API errors gracefully
//             const errorMessage = handleAPIError(error, originalInput);
//             const aiMessage = createMessage('', 'ai', 'text', true);
//             const finalMessages = [...updatedMessages, aiMessage];
            
//             setMessages(finalMessages);
//             setTypingMessage({ fullText: sanitizeInput(errorMessage) });
//             updateChatHistory(currentChatId, finalMessages, chatTitle);
//             updateUIState(currentChatId);
            
//         } finally {
//             setLoading(false);
//             setIsUploading(false);
//         }
//     };





//     const createNewChat = (initialMessages = [], chatTitle = '') => {
//         const newChatId = Date.now().toString();
//         const defaultTitle = chatTitle
//             ? sanitizeInput(chatTitle.substring(0, 30))
//             : initialMessages.length > 0 && initialMessages[0].text
//                 ? sanitizeInput(initialMessages[0].text.substring(0, 30))
//                 : `New Chat ${new Date().toLocaleTimeString()}`;

//         setNewChatTitle(defaultTitle);

//         // We'll handle the actual creation in updateChat
//         return newChatId;
//     };

//     const updateChat = (chatId, updatedMessages, originalInput, isNewChat) => {
//         if (!chatId) return;

//         setChatHistory(prevHistory => {
//             // For existing chats
//             if (!isNewChat) {
//                 return prevHistory.map(chat =>
//                     chat.id === chatId
//                         ? { ...chat, messages: updatedMessages }
//                         : chat
//                 );
//             }

//             // For newly created chats, DO NOT add again (already added in handleSendMessage)
//             return prevHistory.map(chat =>
//                 chat.id === chatId
//                     ? { ...chat, messages: updatedMessages }
//                     : chat
//             );

//             // Otherwise, add the new chat
//             const newChat = {
//                 id: chatId,
//                 title: originalInput.substring(0, 30) || `New Chat ${new Date().toLocaleTimeString()}`,
//                 messages: updatedMessages,
//                 createdAt: new Date(),
//             };

//             return [...prevHistory, newChat];
//         });
//     }


//     const updateCurrentChat = (updatedMessages) => {
//         if (!activeChatId) return;

//         // Update chat history state with the latest messages
//         setChatHistory((prevHistory) => {
//             const updatedHistory = prevHistory.map((chat) =>
//                 chat.id === activeChatId
//                     ? { ...chat, messages: updatedMessages }
//                     : chat
//             );

//             // Save the updated chat history to localStorage AFTER updating state
//             localStorage.setItem('chatHistory', JSON.stringify(updatedHistory));

//             return updatedHistory;
//         });
//     };

//     //Enhanced parser that handles various response formats, including special report formatting
//     const parseApiResponse = (responseData) => {
//         // For string responses
//         if (typeof responseData === 'string') {
//             try {
//                 // Try to parse if it's a stringified JSON
//                 const parsed = JSON.parse(responseData);
//                 const formatted = formatResponse(parsed);
//                 return formatted.text || formatted; // Handle both old and new formats
//             } catch {
//                 // If not valid JSON, return as is
//                 return responseData;
//             }
//         }
//         // For object responses
//         else if (responseData && typeof responseData === 'object') {
//             const formatted = formatResponse(responseData);
//             return formatted.text || formatted; // Handle both old and new formats
//         }

//         // If all else fails, convert to string
//         return String(responseData);
//     };

//     // Function to extract visualization data from API response
//     const extractVisualizationData = (responseData) => {
//         // For string responses
//         if (typeof responseData === 'string') {
//             try {
//                 // Try to parse if it's a stringified JSON
//                 const parsed = JSON.parse(responseData);
//                 const formatted = formatResponse(parsed);
//                 return formatted.visualizations || null;
//             } catch {
//                 return null;
//             }
//         }
//         // For object responses
//         else if (responseData && typeof responseData === 'object') {
//             const formatted = formatResponse(responseData);
//             return formatted.visualizations || null;
//         }

//         return null;
//     };

//     // Function to extract invoice table data from API response
//     const extractInvoiceTableData = (responseData) => {
//         // For string responses
//         if (typeof responseData === 'string') {
//             try {
//                 // Try to parse if it's a stringified JSON
//                 const parsed = JSON.parse(responseData);
//                 const formatted = formatResponse(parsed);
//                 return {
//                     showInvoiceTables: formatted.showInvoiceTables || false,
//                     invoiceResults: formatted.invoiceResults || null
//                 };
//             } catch {
//                 return { showInvoiceTables: false, invoiceResults: null };
//             }
//         }
//         // For object responses
//         else if (responseData && typeof responseData === 'object') {
//             const formatted = formatResponse(responseData);
//             return {
//                 showInvoiceTables: formatted.showInvoiceTables || false,
//                 invoiceResults: formatted.invoiceResults || null
//             };
//         }

//         return { showInvoiceTables: false, invoiceResults: null };
//     };


//     const handleKeyPress = (e) => {
//         if (e.key === 'Enter' && !e.shiftKey) {
//             e.preventDefault();
//             // Prevent sending message if loading or typing animation is active
//             if (!loading && !typingMessage && inputText.trim()) {
//                 handleSendMessage();
//             }
//         }
        
//         // Cancel request or stop typing with Escape key
//         if (e.key === 'Escape') {
//             e.preventDefault();
//             if (loading && !typingMessage) {
//                 // Cancel ongoing request
//                 cancelRequest();
//             } else if (typingMessage) {
//                 // Stop typing animation
//                 stopTyping();
//             }
//         }
//     };

//     const startNewChat = () => {
//         stopTyping(); // Stop any typing effect
//         chatSessionRef.current += 1; // Reset chat session ID
//         setMessages([]); // Clear messages
//         setActiveChatId(null);
//         setNewChatTitle('');
//         setShowDashboard(false);
//         setShowFAQ(false);
//         setInputText('');
//         setActiveNavItem('Chat');
        
//         // Clear attachments
//         selectedFiles.forEach(file => {
//             if (file.preview) {
//                 URL.revokeObjectURL(file.preview);
//             }
//         });
//         setSelectedFiles([]);
//         setDragActive(false);
//     };

//     const moveToTrash = (chatId, e) => {
//         e.stopPropagation();

//         const chatToDelete = chatHistory.find(chat => chat.id === chatId);
//         if (chatToDelete) {
//             setDeletedChats(prev => [...prev, { ...chatToDelete, deletedAt: new Date() }]);
//             setChatHistory(prev => prev.filter(chat => chat.id !== chatId));

//             if (chatId === activeChatId) {
//                 setActiveChatId(null);
//                 setMessages([]);
//                 setShowDashboard(false);
//                 setShowFAQ(false);
//                 setActiveNavItem('Chat');
//             }
//         }
//     };

//     const cleanupDuplicateChats = () => {
//         setChatHistory(prevHistory => {
//             // Group chats by their first user message
//             const chatGroups = {};

//             prevHistory.forEach(chat => {
//                 if (!chat.messages || chat.messages.length === 0) return;

//                 const firstUserMsg = chat.messages.find(msg => msg.sender === 'user');
//                 if (!firstUserMsg) return;

//                 const key = firstUserMsg.text;
//                 if (!chatGroups[key]) chatGroups[key] = [];
//                 chatGroups[key].push(chat);
//             });

//             // For each group with multiple chats, keep only the one with most messages
//             const chatsToKeep = [];

//             Object.values(chatGroups).forEach(group => {
//                 if (group.length === 1) {
//                     chatsToKeep.push(group[0]);
//                 } else if (group.length > 1) {
//                     // Sort by message count (descending) and creation time (ascending)
//                     group.sort((a, b) => {
//                         const countDiff = (b.messages?.length || 0) - (a.messages?.length || 0);
//                         if (countDiff !== 0) return countDiff;
//                         return new Date(a.createdAt) - new Date(b.createdAt);
//                     });

//                     // Keep the chat with most messages (or oldest if tie)
//                     chatsToKeep.push(group[0]);
//                 }
//             });

//             // Add any chats that didn't have a first user message
//             prevHistory.forEach(chat => {
//                 if (!chat.messages || chat.messages.length === 0 ||
//                     !chat.messages.some(msg => msg.sender === 'user')) {
//                     chatsToKeep.push(chat);
//                 }
//             });

//             return chatsToKeep;
//         });
//     };

//     //Edit
//     // Add these functions with your other functions
//     const saveTitle = () => {
//         if (activeChatId) {
//             const updatedHistory = chatHistory.map(chat => {
//                 if (chat.id === activeChatId) {
//                     return { ...chat, title: newChatTitle || 'Untitled Chat' };
//                 }
//                 return chat;
//             });
//             setChatHistory(updatedHistory);
//             setNewChatTitle(newChatTitle || 'Untitled Chat');
//         }
//         setIsEditingTitle(false);
//     };

//     const startEditTitle = () => {
//         const currentChat = chatHistory.find(chat => chat.id === activeChatId);
//         if (currentChat) {
//             setNewChatTitle(currentChat.title);
//         }
//         setIsEditingTitle(true);
//     };

//     const cancelEditTitle = () => {
//         const currentChat = chatHistory.find(chat => chat.id === activeChatId);
//         if (currentChat) {
//             setNewChatTitle(currentChat.title);
//         }
//         setIsEditingTitle(false);
//     };
//     //Select a chat from history
//     const selectChat = (chatId) => {
//         stopTyping();

//         setChatHistory(prevHistory => {
//             const selectedChat = prevHistory.find(chat => chat.id === chatId);
//             if (selectedChat) {
//                 setActiveChatId(chatId);
//                 const chatMessages = selectedChat.messages || [];

//                 // Clean up any duplicate or malformed messages before setting
//                 const cleanedMessages = chatMessages.filter((message, index) => {
//                     // Remove empty AI messages without text
//                     if (message.sender === 'ai' && (!message.text || message.text.trim() === '')) {
//                         return false;
//                     }
//                     // Remove duplicate consecutive AI messages
//                     if (index > 0 &&
//                         message.sender === 'ai' &&
//                         chatMessages[index - 1].sender === 'ai' &&
//                         !message.isTyping &&
//                         !chatMessages[index - 1].isTyping) {
//                         return false;
//                     }
//                     return true;
//                 });

//                 setMessages(cleanedMessages); // Only update once
//                 setNewChatTitle(selectedChat.title || 'Untitled Chat');
//                 setShowChatList(false);
//                 setShowFAQ(false);
//                 setActiveNavItem('Chat');

//                 // Resume typing if last AI message is incomplete
//                 const lastMessage = cleanedMessages[cleanedMessages.length - 1];
//                 if (
//                     lastMessage &&
//                     lastMessage.sender === 'ai' &&
//                     lastMessage.fullText &&
//                     lastMessage.text !== lastMessage.fullText
//                 ) {
//                     const fullText = lastMessage.fullText;
//                     const currentlyTyped = lastMessage.text || '';
//                     const remainingText = fullText.substring(currentlyTyped.length);

//                     if (remainingText.length > 0) {
//                         setTypingMessage({
//                             fullText: remainingText,
//                             originalFullText: fullText
//                         });
//                         setCurrentTypingText(currentlyTyped);

//                         localStorage.setItem('interruptedChatId', chatId);

//                         // Mark this chat as interrupted for future reference
//                         // Optionally, set isTyping to true for this message
//                         const updatedMessages = cleanedMessages.map((msg, idx) =>
//                             idx === cleanedMessages.length - 1
//                                 ? { ...msg, isTyping: true }
//                                 : msg
//                         );
//                         setMessages(updatedMessages); // Only update once
//                     } else {
//                         // Message is already complete, just remove isTyping flag
//                         const updatedMessages = cleanedMessages.map(msg =>
//                             msg === lastMessage ? { ...msg, isTyping: false } : msg
//                         );
//                         setMessages(updatedMessages); // Only update once
//                         localStorage.removeItem('interruptedChatId');
//                     }
//                 }
//             }
//             return prevHistory;
//         });
//     };

//     // Smart suggestions state
//     const [suggestions, setSuggestions] = useState([]);
//     const [showSuggestions, setShowSuggestions] = useState(false);

//     // Generate smart suggestions based on user input letters
//     const generateSuggestions = (input) => {
//         if (!input.trim()) {
//             setShowSuggestions(false);
//             return [];
//         }

//         const inputLower = input.toLowerCase().trim();
        
//         // Define FAQ-based suggestions only
//         const allSuggestions = [
//             'List accounts with annual revenue greater than 5,000,000 that were updated before one year',
//             'Show me accounts that have no ERP or unknown CRM system',
//             'Are there any accounts with low revenue or small number of employees?',
//             'Group accounts by email domain',
//             'How many companies are there in each sector?',
//             'Which accounts have missing ownership or blank ownership status?',
//             'Show me companies with revenue more than 50000',
//             'Find companies with less than 100 employees',
//             'Are there any high revenue accounts that aren\'t being targeted but have ERP and CRM systems in place?',
//             'Break down the revenue by month for the third quarter of 2023',
//             'Generate comprehensive Monday morning CRM report',
//             'Analyze opportunities requiring immediate attention',
//             'Find stagnant opportunities over 30 days',
//             'Find urgent opportunities and send email to sales team',
//             'Create executive summary of current opportunities'
//         ];

//         // Filter FAQ suggestions based on input
//         const matchingSuggestions = allSuggestions.filter(suggestion => 
//             suggestion.toLowerCase().includes(inputLower)
//         );

//         // Limit to all matching FAQ suggestions (max 15)
//         return matchingSuggestions;
//     };

//     // Handle input changes with suggestions
//     const handleInputChangeWithSuggestions = (e) => {
//         const value = e.target.value;
//         setInputText(value);

//         // Show suggestions only when starting a new conversation (no messages yet) and user is typing
//         if (value.trim() && messages.length === 0) {
//             const newSuggestions = generateSuggestions(value);
//             setSuggestions(newSuggestions);
//             setShowSuggestions(newSuggestions.length > 0);
//         } else {
//             setShowSuggestions(false);
//             setSuggestions([]);
//         }
//     };

//     // Handle input focus to show FAQ suggestions
//     const handleInputFocusWithSuggestions = () => {
//         if (messages.length === 0 && !inputText.trim()) {
//             // Show all FAQ suggestions when input is focused and empty
//             const faqSuggestions = [
//                 'List accounts with annual revenue greater than 5,000,000 that were updated before one year',
//                 'Show me accounts that have no ERP or unknown CRM system',
//                 'Are there any accounts with low revenue or small number of employees?',
//                 'Group accounts by email domain',
//                 'How many companies are there in each sector?',
                
//             ];
//             setSuggestions(faqSuggestions);
//             setShowSuggestions(true);
//         }
//     };

//     // Handle suggestion click
//     const handleSuggestionClick = (suggestion) => {
//         setInputText(suggestion);
//         setShowSuggestions(false);
//         setSuggestions([]);
        
//         // Focus back to textarea
//         setTimeout(() => {
//             const textareas = document.querySelectorAll('.text-input');
//             if (textareas.length > 0) {
//                 textareas[0].focus();
//             }
//         }, 100);
//     };

//     // Handle clicking outside to hide suggestions
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (!event.target.closest('.chat-input')) {
//                 setShowSuggestions(false);
//                 setSuggestions([]);
//             }
//         };

//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     // File upload handlers
//     const handleFileSelect = (event) => {
//         const files = Array.from(event.target.files);
//         handleFilesAdded(files);
//         // Clear the input so the same file can be selected again
//         event.target.value = '';
//     };

//     const handleFilesAdded = (files) => {
//         const newFiles = files.map(file => ({
//             file,
//             id: Date.now() + Math.random(),
//             preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
//             type: getFileType(file.type),
//             size: formatFileSize(file.size),
//             name: file.name
//         }));

//         setSelectedFiles(prev => [...prev, ...newFiles]);
//     };

//     const handleAttachmentRemove = (fileId) => {
//         setSelectedFiles(prev => {
//             const updated = prev.filter(f => f.id !== fileId);
//             // Clean up object URLs to prevent memory leaks
//             const removedFile = prev.find(f => f.id === fileId);
//             if (removedFile && removedFile.preview) {
//                 URL.revokeObjectURL(removedFile.preview);
//             }
//             return updated;
//         });
//     };

//     const handleDragEnter = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         setDragActive(true);
//     }, []);

//     const handleDragLeave = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         setDragActive(false);
//     }, []);

//     const handleDragOver = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//     }, []);

//     const handleDrop = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         setDragActive(false);

//         const files = Array.from(e.dataTransfer.files);
//         if (files.length > 0) {
//             handleFilesAdded(files);
//         }
//     }, []);

//     // Handle paste event to capture files from clipboard
//     const handlePaste = useCallback((e) => {
//         const items = e.clipboardData?.items;
//         if (!items) return;

//         const files = [];
//         for (let i = 0; i < items.length; i++) {
//             const item = items[i];
            
//             // Check if the item is a file
//             if (item.kind === 'file') {
//                 const file = item.getAsFile();
//                 if (file) {
//                     files.push(file);
//                 }
//             }
//         }

//         // If files were found in clipboard, add them
//         if (files.length > 0) {
//             e.preventDefault(); // Prevent the default paste behavior for files
//             handleFilesAdded(files);
//         }
//         // If no files, allow normal text paste to continue
//     }, []);

//     // Helper functions for file handling
//     const getFileType = (mimeType) => {
//         if (mimeType.startsWith('image/')) return 'image';
//         if (mimeType.startsWith('text/') || mimeType.includes('document')) return 'document';
//         if (mimeType.includes('pdf')) return 'pdf';
//         if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'spreadsheet';
//         return 'file';
//     };

//     const formatFileSize = (bytes) => {
//         if (bytes === 0) return '0 Bytes';
//         const k = 1024;
//         const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//         const i = Math.floor(Math.log(bytes) / Math.log(k));
//         return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
//     };

//     const getFileIcon = (fileType) => {
//         switch (fileType) {
//             case 'image': return <FiImage />;
//             case 'document': case 'pdf': return <FiFileText />;
//             default: return <FiFile />;
//         }
//     };

//     return (
//         <SessionTimeout>
//             <div className="app-container">
//                 {/* Overlay for mobile */}
//                 {isSidebarActive && (
//                     <div
//                         className="sidebar-overlay"
//                         onClick={toggleSidebar}
//                         style={{ display: window.innerWidth <= 426 ? 'block' : 'none' }}
//                     />
//                 )}
//                 <Sidebar
//                     isSidebarActive={isSidebarActive}
//                     toggleSidebar={toggleSidebar}
//                     startNewChat={startNewChat}
//                     chatHistory={chatHistory}
//                     activeChatId={activeChatId}
//                     selectChat={selectChat}
//                     moveToTrash={moveToTrash}
//                     deletedChats={deletedChats}
//                     setDeletedChats={setDeletedChats}
//                     activeNavItem={activeNavItem}
//                     setActiveNavItem={setActiveNavItem}
//                     showFAQ={showFAQ}
//                     setShowFAQ={setShowFAQ}
//                     showDashboard={showDashboard}
//                     setShowDashboard={setShowDashboard}
//                     setActiveChatId={setActiveChatId}
//                     setMessages={setMessages}
//                     setActiveDashboard={setActiveDashboard}
//                     setDashboardUrl={setDashboardUrl}
//                     setInputText={setInputText}
//                     handleLogout={() => {
//                         localStorage.removeItem('isAuthenticated');
//                         navigate('/');
//                     }}
//                     handleSwitch={() => {
//                         alert('Account switching functionality would be implemented here');
//                     }}
//                     openDropdown={openDropdown}
//                     setOpenDropdown={setOpenDropdown}
//                     openNestedDropdown={openNestedDropdown}
//                     setOpenNestedDropdown={setOpenNestedDropdown}
//                     setChatHistory={setChatHistory}
//                     newChatTitle={newChatTitle}
//                     startEditTitle={startEditTitle}
//                     cancelEditTitle={cancelEditTitle}
//                     setNewChatTitle={setNewChatTitle}
//                     isEditingTitle={isEditingTitle}
//                     setIsEditingTitle={setIsEditingTitle}
//                     activeDashboard={activeDashboard}
//                     className={isSidebarActive ? 'active' : ''}
//                     renameAnchorEl={renameAnchorEl}
//                     setRenameAnchorEl={setRenameAnchorEl}
//                     openOverlayMenu={openOverlayMenu}
//                     closeAllOverlays={closeAllOverlays}
//                     setOverlayMenu={openOverlayMenu}
//                     openSubmenuParent={openSubmenuParent}
//                     setOpenSubmenuParent={setOpenSubmenuParent}
//                 />

//                 {overlayMenus.length > 0 && (
//                     <div className="sidebar-overlay-backdrop" onClick={closeAllOverlays}>
//                         {overlayMenus.map((menu, idx) => (
//                             <div
//                                 key={idx}
//                                 className="sidebar-overlay-menu"
//                                 style={{
//                                     left: menu.position.left + 8, // offset each overlay to the right
//                                     top: menu.position.top,
//                                     position: 'absolute',
//                                     zIndex: 1000 + idx
//                                 }}
//                                 onClick={e => e.stopPropagation()}
//                             >
//                                 {menu.items.map(item => (
//                                     <button
//                                         key={item.name}
//                                         className="overlay-menu-item"
//                                         onClick={e => {
//                                             if (item.nestedItems) {
//                                                 openOverlayMenu(item.nestedItems, e, item.name);
//                                             } else if (item.onClick) {
//                                                 item.onClick();
//                                                 closeAllOverlays();
//                                             }
//                                         }}
//                                     >
//                                         {item.name}
//                                         {item.nestedItems && (
//                                             <span>
//                                                 {(openSubmenuParent === item.name)
//                                                     ? (isSidebarActive ? '◀' : '▶') // open state
//                                                     : (isSidebarActive ? '▶' : '◀') // closed state
//                                                 }
//                                             </span>
//                                         )}
//                                     </button>
//                                 ))}
//                             </div>
//                         ))}
//                     </div>
//                 )}
//                 {renameAnchorEl && (
//                     <div className="rename-popup-overlay" onClick={() => setRenameAnchorEl(null)}>
//                         <div
//                             className="rename-popup"
//                             onClick={e => e.stopPropagation()}
//                         >
//                             <h4>Rename Chat</h4>
//                             <input
//                                 type="text"
//                                 value={newChatTitle}
//                                 onChange={e => setNewChatTitle(e.target.value)}
//                                 onKeyDown={e => {
//                                     if (e.key === 'Enter') {
//                                         // Confirm rename logic
//                                         if (newChatTitle.trim() && activeChatId) {
//                                             const updatedHistory = chatHistory.map(c =>
//                                                 c.id === activeChatId ? { ...c, title: newChatTitle } : c
//                                             );
//                                             setChatHistory(updatedHistory);
//                                         }
//                                         setRenameAnchorEl(null);
//                                     }
//                                 }}
//                                 autoFocus
//                             />
//                             <div className="rename-popup-actions">
//                                 <button
//                                     onClick={() => {
//                                         if (newChatTitle.trim() && activeChatId) {
//                                             const updatedHistory = chatHistory.map(c =>
//                                                 c.id === activeChatId ? { ...c, title: newChatTitle } : c
//                                             );
//                                             setChatHistory(updatedHistory);
//                                         }
//                                         setRenameAnchorEl(null);
//                                     }}
//                                     className="confirm-btn"
//                                 >
//                                     Confirm
//                                 </button>
//                                 <button
//                                     onClick={() => setRenameAnchorEl(null)}
//                                     className="cancel-btn"
//                                 >
//                                     Cancel
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 <div className={`main-content ${isSidebarActive ? 'sidebar-active' : 'sidebar-collapsed'}`}>
//                     <div className="top-nav">
//                         <div className='logo-container1' onClick={startNewChat} style={{ cursor: 'pointer' }}>
//                             {/* <img src={SaviFullLogo} alt="AV Logo" style={{ width: 53, height: 21 }} /> */}
//                         </div>
//                         {/* {activeChatId && !showFAQ && (
//                         <div className="chat-list-dropdown">
//                             <div className="chat-title-container">
//                                 {isEditingTitle ? (
//                                     <div className="rename-chat-container">
//                                         <input
//                                             type="text"
//                                             className="rename-chat-input"
//                                             value={newChatTitle}
//                                             onChange={(e) => setNewChatTitle(e.target.value)}
//                                             onKeyDown={(e) => {
//                                                 if (e.key === 'Enter') {
//                                                     saveTitle();
//                                                 }
//                                             }}
//                                             autoFocus
//                                         />
//                                         <button className="chat-title-btn" onClick={saveTitle}>
//                                             <FiCheck size={16} />
//                                         </button>
//                                         <button className="chat-title-btn" onClick={cancelEditTitle}>
//                                             <FiX size={16} />
//                                         </button>
//                                     </div>
//                                 ) : (
//                                     <div className="active-chat-controls" onClick={() => setShowChatList(!showChatList)}>
//                                         <span className="active-chat-title">{newChatTitle}</span>
//                                         <button
//                                             className="chat-title-btn"
//                                             onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 startEditTitle();
//                                             }}
//                                         >
//                                             <FiEdit2 size={16} />
//                                         </button>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     )} */}

//                         <div className="nav-actions">
//                             <div className="user-menu-container sign-out-container">
//                                 <button
//                                     className="user-menu-button"
//                                     onClick={() => setShowSignOutOptions(!showSignOutOptions)}
//                                 >
//                                     {userInitial ? (
//                                         <div className="user-initial">{userInitial}</div>
//                                     ) : (
//                                         <FiUser size={18} />
//                                     )}
//                                 </button>

//                                 {showSignOutOptions && (
//                                     <div className="user-menu-dropdown">
//                                         <button className="menu-item"
//                                             onClick={(e) => {
//                                                 e.stopPropagation();
//                                                 setShowSignOutOptions(false);
//                                                 setShowSettings(true); // Always open Settings modal
//                                             }}>
//                                             <FiSettings size={16} />
//                                             <span>Settings</span>
//                                         </button>
//                                         <button className="menu-item" onClick={handleSignOut} >
//                                             <FiLogOut size={16} />
//                                             <span>Log out</span>
//                                         </button>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                     <div className="content-area">
//                         {showDashboard && dashboardUrl ? (
//                             <div className="dashboard-container">
//                                 <iframe
//                                     title="Dashboard"
//                                     src={dashboardUrl}
//                                     width="100%"
//                                     height="100%"
//                                     frameBorder="0"
//                                     allowFullScreen
//                                 ></iframe>
//                             </div>
//                         ) : showFAQ ? (
//                             <Faq
//                                 setInputText={setInputText}
//                                 setActiveNavItem={setActiveNavItem}
//                                 setShowFAQ={setShowFAQ}
//                                 handleSendMessage={handleSendMessage}
//                                 setFaqQuestionSelected={setFaqQuestionSelected}
//                             />
//                         // ) : activeNavItem === 'Revenue' ?
//                         //     (
//                         //         <RevenueData />
//                             // ) : activeNavItem === 'InsightApps' ? (
//                             //     <InsightApps /> 
//                             // ) : activeNavItem === 'Agents' ? (
//                             //     <Agents />
//                             ) : (
//                                 <div className="chat-container">
//                                     {/* {messages.length === 0 && !showDashboard && !showFAQ ? (
//                                     <div className="welcome-message1" style={{ flexDirection: 'column', gap: '0px' }}>
//                                         <div>
//                                             <span className="welcome-hello1">Hello,</span>
//                                             <span className="welcome-username1">{(() => {
//                                                 const userType = localStorage.getItem('userType');
//                                                 const email = userType === 'vendor' 
//                                                     ? localStorage.getItem('userEmail') 
//                                                     : localStorage.getItem('user');
//                                                 if (!email) return 'User';
//                                                 const namePart = email.split('@')[0];
//                                                 return namePart
//                                                     .replace(/[._]/g, ' ')
//                                                     .replace(/\b\w/g, c => c.toUpperCase());
//                                             })()}</span>
//                                         </div>
//                                         <div className="welcome-sub-small">How Can I Help You?</div>
//                                     </div>
//                                 ) : ( */}
//                                     <div className="messages-container">
//                                         {messages.map((message, index) => (

//                                             <div key={index} className={`message ${message.sender}`}>
//                                                 <div className="message-content-wrapper">
//                                                         <div className="message-content">
//                                                             {message.sender === 'ai' ? (
//                                                                 <pre
//                                                                     className="ai-message-text"
//                                                                     style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}
//                                                                     dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.text) }}
//                                                                 />
//                                                             ) : (
//                                                                 message.text
//                                                             )}
//                                                         </div>
                                                        
//                                                         {/* Render attachments for user messages */}
//                                                         {message.attachments && message.attachments.length > 0 && (
//                                                             <div className="message-attachments">
//                                                                 {message.attachments.map((attachment) => (
//                                                                     <div key={attachment.id} className="message-attachment">
//                                                                         {attachment.preview ? (
//                                                                             <img 
//                                                                                 src={attachment.preview} 
//                                                                                 alt={attachment.name} 
//                                                                                 className="message-attachment-image"
//                                                                                 onClick={() => window.open(attachment.preview, '_blank')}
//                                                                             />
//                                                                         ) : (
//                                                                             <div className="message-attachment-file">
//                                                                                 <div className="message-attachment-icon">
//                                                                                     {getFileIcon(attachment.type)}
//                                                                                 </div>
//                                                                                 <div className="message-attachment-info">
//                                                                                     <span className="message-attachment-name">{attachment.name}</span>
//                                                                                     <span className="message-attachment-size">{attachment.size}</span>
//                                                                                 </div>
//                                                                             </div>
//                                                                         )}
//                                                                     </div>
//                                                                 ))}
//                                                             </div>
//                                                         )}
                                                        
//                                                         {/* Render charts if visualizations data exists */}
//                                                         {message.visualizations && (
//                                                             <div className="message-charts">
//                                                                 <ChartVisualization visualizations={message.visualizations} />
//                                                             </div>
//                                                         )}
                                                        
//                                                         {/* Render invoice tables if showInvoiceTables flag is set */}
//                                                         {(() => {
//                                                             if (message.showInvoiceTables && message.invoiceResults) {
//                                                                 console.log('🎨 Rendering invoice tables for message:', {
//                                                                     showInvoiceTables: message.showInvoiceTables,
//                                                                     hasInvoiceResults: !!message.invoiceResults,
//                                                                     extractedDataLength: message.invoiceResults.extracted_data?.length,
//                                                                     total: message.invoiceResults.total_invoices_loaded,
//                                                                     successful: message.invoiceResults.successful_pushed_invoices,
//                                                                     failed: message.invoiceResults.failed_invoices_count
//                                                                 });
                                                                
//                                                                 return (
//                                                                     <div className="invoice-tables-container">
//                                                                         {/* Level 1: Summary Cards */}
//                                                                         <SummaryCards 
//                                                                             results={message.invoiceResults} 
//                                                                             onFailedInvoicesClick={handleFailedInvoicesClick}
//                                                                         />
                                                                        
//                                                                         {/* Level 2: Extracted Data with Modal Items */}
//                                                                         {message.invoiceResults.extracted_data && 
//                                                                          message.invoiceResults.extracted_data.length > 0 ? (
//                                                                             <ExtractedDataTable 
//                                                                                 extractedData={message.invoiceResults.extracted_data}
//                                                                                 expandedRows={expandedRows}
//                                                                                 onToggleExpansion={handleToggleExpansion}
//                                                                                 onSendEmail={handleSendEmail}
//                                                                                 onDownloadExcel={handleDownloadExcel}
//                                                                                 invoiceResults={message.invoiceResults}
//                                                                                 isSendingEmail={isSendingEmail}
//                                                                                 emailSendStatus={emailSendStatus}
//                                                                             />
//                                                                         ) : (
//                                                                             <div className="no-extracted-data-message" style={{
//                                                                                 padding: '20px',
//                                                                                 textAlign: 'center',
//                                                                                 color: '#666',
//                                                                                 fontStyle: 'italic'
//                                                                             }}>
//                                                                                 ℹ️ No detailed invoice data was extracted from the uploaded document(s).
//                                                                             </div>
//                                                                         )}
//                                                                     </div>
//                                                                 );
//                                                             }
//                                                             return null;
//                                                         })()}
//                                                         {/* Show chart loading indicator */}
//                                                         {chartLoadingStates[index] && (
//                                                             <div className="message-charts-loading">
//                                                                 <div className="chart-loading-container">
//                                                                     <div className="chart-loading-header">
//                                                                         <div className="chart-loading-spinner"></div>
//                                                                         <span className="chart-loading-text">
//                                                                             Generating charts... {chartLoadingProgress[index] || 0}%
//                                                                         </span>
//                                                                     </div>
//                                                                     <div className="chart-progress-bar">
//                                                                         <div 
//                                                                             className="chart-progress-fill"
//                                                                             style={{ width: `${chartLoadingProgress[index] || 0}%` }}
//                                                                         ></div>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         )}
//                                                         {message.sender === 'ai' && !message.isTyping && (
//                                                             <div className="message-actions">
//                                                                 <button 
//                                                                     className={`action-btn ${messageFeedback[index]?.thumbsUp ? 'active' : ''}`}
//                                                                     onClick={() => handleThumbsUp(index)}
//                                                                     title="Good response"
//                                                                 >
//                                                                     <FiThumbsUp />
//                                                                 </button>
//                                                                 <button 
//                                                                     className={`action-btn ${messageFeedback[index]?.thumbsDown ? 'active' : ''}`}
//                                                                     onClick={() => handleThumbsDown(index)}
//                                                                     title="Poor response"
//                                                                 >
//                                                                     <FiThumbsDown />
//                                                                 </button>
//                                                                 <button 
//                                                                     className={`action-btn ${copiedMessageId === index ? 'copied' : ''}`}
//                                                                     onClick={() => handleCopyMessage(message.text, index)}
//                                                                     title={copiedMessageId === index ? "Copied!" : "Copy message"}
//                                                                 >
//                                                                     <FiCopy />
//                                                                 </button>
//                                                                 {/* Only show refresh button if the previous user message didn't have attachments */}
//                                                                 {!(index > 0 && messages[index - 1]?.attachments?.length > 0) && (
//                                                                     <button 
//                                                                         className="action-btn"
//                                                                         onClick={() => handleRefreshMessage(index)}
//                                                                         title="Regenerate response"
//                                                                         disabled={loading}
//                                                                     >
//                                                                         <FiRefreshCw />
//                                                                     </button>
//                                                                 )}
//                                                             </div>
//                                                         )}
//                                                 </div>
//                                             </div>
//                                         ))}
//                                         <div ref={messagesEndRef} />
//                                         {loading && (
//                                             <div className="message ai">
//                                                 <div className="message-content loading">
//                                                     <div className="typing-indicator">
//                                                         <span></span>
//                                                         <span></span>
//                                                         <span></span>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                     {/* )} */}
//                                 </div>
//                             )}
//                     </div>

//                     {!showDashboard && (!showFAQ || faqQuestionSelected)  && (
//                         <>
//                             {messages.length === 0 ? (
//                                 <div className="chat-input-floating">
//                                     <div className="welcome-message1">
//                                         <div>
//                                             <span className="welcome-hello1">Hello,</span>
//                                             <span className="welcome-username1">{(() => {
//                                                 const userType = localStorage.getItem('userType');
//                                                 const email = userType === 'vendor' 
//                                                     ? localStorage.getItem('userEmail') 
//                                                     : localStorage.getItem('user');
//                                                 if (!email) return 'User';
//                                                 const namePart = email.split('@')[0];
//                                                 return namePart
//                                                     .replace(/[._]/g, ' ')
//                                                     .replace(/\b\w/g, c => c.toUpperCase());
//                                             })()}</span>
//                                         </div>
//                                         <div className="welcome-sub-small">How Can I Help You?</div>
//                                     </div>
                                    
//                                     {/* Drag and drop overlay */}
//                                     {dragActive && (
//                                         <div className="drag-drop-overlay">
//                                             <div className="drag-drop-content">
//                                                 <FiPaperclip size={48} />
//                                                 <p>Drop files here to attach</p>
//                                             </div>
//                                         </div>
//                                     )}
                                    
//                                     <div 
//                                         className={`chat-input ${showSuggestions ? 'has-suggestions' : ''} ${dragActive ? 'drag-active' : ''}`}
//                                         onDragEnter={handleDragEnter}
//                                         onDragLeave={handleDragLeave}
//                                         onDragOver={handleDragOver}
//                                         onDrop={handleDrop}
//                                     >
//                                         {/* Attachment previews */}
//                                         {selectedFiles.length > 0 && (
//                                             <div className="attachment-previews">
//                                                 {selectedFiles.map((fileData) => (
//                                                     <div key={fileData.id} className="attachment-preview">
//                                                         <div className="attachment-content">
//                                                             {fileData.preview ? (
//                                                                 <img src={fileData.preview} alt={fileData.name} className="attachment-image" />
//                                                             ) : (
//                                                                 <div className="attachment-file-icon">
//                                                                     {getFileIcon(fileData.type)}
//                                                                 </div>
//                                                             )}
//                                                             <div className="attachment-info">
//                                                                 <span className="attachment-name">{fileData.name}</span>
//                                                                 <span className="attachment-size">{fileData.size}</span>
//                                                             </div>
//                                                         </div>
//                                                         <button 
//                                                             className="attachment-remove"
//                                                             onClick={() => handleAttachmentRemove(fileData.id)}
//                                                             title="Remove attachment"
//                                                         >
//                                                             <FiX size={16} />
//                                                         </button>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}

//                                         <TextareaAutosize
//                                             className="text-input"
//                                             placeholder={placeholder}
//                                             value={inputText}
//                                             onChange={handleInputChangeWithSuggestions}
//                                             onKeyDown={handleKeyPress}
//                                             onFocus={handleInputFocusWithSuggestions}
//                                             onPaste={handlePaste}
//                                             minRows={1}
//                                             maxRows={4}
//                                             style={{ resize: 'none' }}
//                                             disabled={loading || !!typingMessage}
//                                         />
//                                         {/* Suggestions dropdown */}
//                                         {showSuggestions && suggestions.length > 0 && (
//                                             <div className="suggestions-dropdown">
//                                                 {suggestions.map((suggestion, index) => (
//                                                     <div
//                                                         key={index}
//                                                         className="suggestion-item"
//                                                         onClick={() => handleSuggestionClick(suggestion)}
//                                                     >
//                                                         <span className="suggestion-text">{suggestion}</span>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}
//                                         <div className="input-icons-row">
//                                             <div className="left-icons">
//                                                 <input
//                                                     type="file"
//                                                     multiple
//                                                     onChange={handleFileSelect}
//                                                     style={{ display: 'none' }}
//                                                     id="file-upload-floating"
//                                                     accept="image/*,text/*,.pdf,.doc,.docx,.xls,.xlsx"
//                                                 />
//                                                 <label htmlFor="file-upload-floating" className="attachment-btn">
//                                                     <FiPaperclip size={18} />
//                                                 </label>
//                                             </div>
//                                             <div className="right-icons">
//                                                 {isUploading ? (
//                                                     <button className="upload-progress-btn" disabled>
//                                                         <div className="upload-spinner"></div>
//                                                     </button>
//                                                 ) : loading && !typingMessage ? (
//                                                     <button
//                                                         className="stop-btn"
//                                                         onClick={cancelRequest}
//                                                         title="Cancel request"
//                                                     >
//                                                         <FiX size={18} color="white" />
//                                                     </button>
//                                                 ) : typingMessage ? (
//                                                     <button
//                                                         className="stop-btn"
//                                                         onClick={stopTyping}
//                                                         title="Stop generating"
//                                                     >
//                                                         <FiX size={18} color="white" />
//                                                     </button>
//                                                 ) : (
//                                                     <button
//                                                         className="send-btn"
//                                                         onClick={handleSendMessage}
//                                                         disabled={(!inputText?.trim() && selectedFiles.length === 0) || loading || !!typingMessage}
//                                                         title={(!inputText?.trim() && selectedFiles.length === 0) ? "Type a message or attach a file to send" : "Send message"}
//                                                     >
//                                                         <FiArrowRight size={20} color="white" />
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>

//                                      {/* <div className="quick-responses">
//                                         {quickResponses.map((response) => (
//                                             <button
//                                                 key={response.id}
//                                                 className={`quick-response-btn ${response.category}`}
//                                                 onClick={() => handleQuickResponse(response)}
//                                                 disabled={loading || !!typingMessage}
//                                                 title={`Use template: ${response.prompt}`}
//                                             >
//                                                 {response.text}
//                                             </button>
//                                         ))}
//                                     </div>  */}
//                                 </div>
//                             ) : (
//                                 <div className={`chat-input-container${typingMessage ? ' input-blocked' : ''}`}>
//                                     {/* Drag and drop overlay */}
//                                     {dragActive && (
//                                         <div className="drag-drop-overlay">
//                                             <div className="drag-drop-content">
//                                                 <FiPaperclip size={48} />
//                                                 <p>Drop files here to attach</p>
//                                             </div>
//                                         </div>
//                                     )}
                                    
//                                     <div 
//                                         className={`chat-input ${dragActive ? 'drag-active' : ''}`}
//                                         onDragEnter={handleDragEnter}
//                                         onDragLeave={handleDragLeave}
//                                         onDragOver={handleDragOver}
//                                         onDrop={handleDrop}
//                                     >
//                                         {/* Attachment previews */}
//                                         {selectedFiles.length > 0 && (
//                                             <div className="attachment-previews">
//                                                 {selectedFiles.map((fileData) => (
//                                                     <div key={fileData.id} className="attachment-preview">
//                                                         <div className="attachment-content">
//                                                             {fileData.preview ? (
//                                                                 <img src={fileData.preview} alt={fileData.name} className="attachment-image" />
//                                                             ) : (
//                                                                 <div className="attachment-file-icon">
//                                                                     {getFileIcon(fileData.type)}
//                                                                 </div>
//                                                             )}
//                                                             <div className="attachment-info">
//                                                                 <span className="attachment-name">{fileData.name}</span>
//                                                                 <span className="attachment-size">{fileData.size}</span>
//                                                             </div>
//                                                         </div>
//                                                         <button 
//                                                             className="attachment-remove"
//                                                             onClick={() => handleAttachmentRemove(fileData.id)}
//                                                             title="Remove attachment"
//                                                         >
//                                                             <FiX size={16} />
//                                                         </button>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         )}

//                                         <TextareaAutosize
//                                             className="text-input"
//                                             placeholder={placeholder}
//                                             value={inputText}
//                                             onChange={handleInputChangeWithSuggestions}
//                                             onKeyDown={handleKeyPress}
//                                             onFocus={handleInputFocusWithSuggestions}
//                                             onPaste={handlePaste}
//                                             minRows={1}
//                                             maxRows={4}
//                                             style={{ resize: 'none' }}
//                                             disabled={loading || !!typingMessage}
//                                         />
//                                         <div className="input-icons-row">
//                                             <div className="left-icons">
//                                                 <input
//                                                     type="file"
//                                                     multiple
//                                                     onChange={handleFileSelect}
//                                                     style={{ display: 'none' }}
//                                                     id="file-upload-regular"
//                                                     accept="image/*,text/*,.pdf,.doc,.docx,.xls,.xlsx"
//                                                 />
//                                                 <label htmlFor="file-upload-regular" className="attachment-btn">
//                                                     <FiPaperclip size={18} />
//                                                 </label>
//                                             </div>
//                                             <div className="right-icons">
//                                                 {isUploading ? (
//                                                     <button className="upload-progress-btn" disabled>
//                                                         <div className="upload-spinner"></div>
//                                                     </button>
//                                                 ) : loading && !typingMessage ? (
//                                                     <button
//                                                         className="stop-btn"
//                                                         onClick={cancelRequest}
//                                                         title="Cancel request"
//                                                     >
//                                                         <FiX size={18} color="white" />
//                                                     </button>
//                                                 ) : typingMessage ? (
//                                                     <button
//                                                         className="stop-btn"
//                                                         onClick={stopTyping}
//                                                         title="Stop generating"
//                                                     >
//                                                         <FiX size={18} color="white" />
//                                                     </button>
//                                                 ) : (
//                                                     <button
//                                                         className="send-btn"
//                                                         onClick={handleSendMessage}
//                                                         disabled={(!inputText?.trim() && selectedFiles.length === 0) || loading || !!typingMessage}
//                                                         title={(!inputText?.trim() && selectedFiles.length === 0) ? "Type a message or attach a file to send" : "Send message"}
//                                                     >
//                                                         <FiArrowRight size={20} color="white" />
//                                                     </button>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}
//                         </>
//                     )}
//                 </div>
//                 {showSettings && (
//                     <Settings
//                         onClose={() => setShowSettings(false)}
//                         chatHistory={chatHistory}
//                         setChatHistory={setChatHistory}
//                         deletedChats={deletedChats}
//                         setDeletedChats={setDeletedChats}
//                         setActiveChatId={setActiveChatId} // add this
//                         setMessages={setMessages}         // add this
//                         setShowDashboard={setShowDashboard}
//                         currentTheme={currentTheme}
//                         setCurrentTheme={setCurrentTheme}
//                     />
//                 )}
//                 {/* {sessionManager && (
//             <SessionTimeoutWarning
//                 onStayLoggedIn={sessionManager.stayLoggedIn}
//                 onLogout={sessionManager.logout}
//             />
//         )} */}
//                 <SessionTimeoutWarning
//                     onStayLoggedIn={() => window.sessionTimeout?.stayLoggedIn()}
//                     onLogout={() => window.sessionTimeout?.logout()}
//                 />

//                 {/* Items Modal */}
//                 <ItemsModal
//                     isOpen={showItemsModal}
//                     onClose={() => setShowItemsModal(false)}
//                     items={selectedItems}
//                     title={modalTitle}
//                 />

//                 {/* Failed Invoices Modal */}
//                 <FailedInvoicesModal
//                     isOpen={showFailedInvoicesModal}
//                     onClose={() => {
//                         setShowFailedInvoicesModal(false);
//                         setSelectedFailedInvoices(null);
//                     }}
//                     failedInvoices={selectedFailedInvoices}
//                     title="Failed Invoices Details"
//                 />
//             </div>
//         </SessionTimeout>
//     );
// };

// export default Chat;



import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import TextareaAutosize from 'react-textarea-autosize';
import SaviFullLogo from '../Images/SAVI AI full.png';
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
    createColumnHelper,
} from '@tanstack/react-table';

import Settings from './Settings';
import Sidebar from './Sidebar';
import Faq from './Faq';
import ChartVisualization from './ChartVisualization';

import '../Styles/Settings.css';
import '../Styles/Chat.css';
import '../Styles/Sidebar.css';

import SessionTimeout from './SessionTimeout';
import SessionTimeoutWarning from './SessionTimeoutWarning';
import DOMPurify from 'dompurify';


import {
    FiSettings,
    FiLogOut,
    FiSend,
    FiArrowRight,
    FiUser,
    FiX,
    FiInfo,
    FiThumbsUp,
    FiThumbsDown,
    FiCopy,
    FiPaperclip,
    FiFile,
    FiImage,
    FiFileText,
    FiDownload,
} from 'react-icons/fi';

// import {fa-refresh} from 'react-icons/fa';

// import {fa-refresh} from 'react-icons/fa';

// Move components outside to prevent re-creation on every render
const ExpandableMessage = React.memo(({ message }) => {
    const isLong = message.length > 100;
    const [expanded, setExpanded] = useState(false);
    
    return (
        <div className="expandable-message">
            <div className={`message-content ${expanded ? 'expanded' : ''}`}>
                {expanded || !isLong ? message : `${message.substring(0, 100)}...`}
            </div>
            {isLong && (
                <button 
                    className="expand-btn"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? 'Show Less' : 'Show More'}
                </button>
            )}
        </div>
    );
});
ExpandableMessage.displayName = 'ExpandableMessage';

// ItemsModal component - moved outside
const ItemsModal = React.memo(({ isOpen, onClose, items, title }) => {
    // Add keyboard listener for Escape key
    React.useEffect(() => {
        if (isOpen) {
            const handleKeyDown = (e) => {
                if (e.key === 'Escape') {
                    handleClose();
                }
            };
            document.addEventListener('keydown', handleKeyDown);
            return () => document.removeEventListener('keydown', handleKeyDown);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    const handleCloseButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleClose();
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-content items-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{title}</h3>
                    <button 
                        className="modal-close-btn" 
                        onClick={handleCloseButtonClick}
                        onPointerDown={handleCloseButtonClick}
                        onMouseDown={(e) => {
                            e.preventDefault();
                        }}
                        type="button"
                        style={{ 
                            background: '#f44336', 
                            color: 'white',
                            border: 'none', 
                            fontSize: '16px', 
                            cursor: 'pointer',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            zIndex: '10000',
                            position: 'relative',
                            minWidth: '80px',
                            minHeight: '36px',
                            pointerEvents: 'auto'
                        }}
                    >
                        ✕ CLOSE
                    </button>
                </div>
                <div className="modal-body">
                    {items && items.length > 0 ? (
                        <div className="items-grid">
                            <div className="items-count-badge">
                                📦 {items.length} Item{items.length !== 1 ? 's' : ''} Found
                            </div>
                            {items.map((item, index) => (
                                <div key={index} className="item-card">
                                    <div className="item-header">
                                        <span className="item-number">#{index + 1}</span>
                                        <span className="item-type">Line Item</span>
                                    </div>
                                    <div className="item-details">
                                        {Object.entries(item).map(([key, value]) => (
                                            <div key={key} className="item-field">
                                                <span className="field-label">
                                                    {key.replace(/([A-Z])/g, ' $1').trim()}:
                                                </span>
                                                <span className="field-value">
                                                    {value !== null && value !== undefined ? String(value) : 'N/A'}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="no-items">
                            <div className="no-items-icon">📋</div>
                            <h4>No Items Found</h4>
                            <p>This invoice doesn't contain any line items.</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});
ItemsModal.displayName = 'ItemsModal';

// FailedInvoicesModal component - moved outside
const FailedInvoicesModal = React.memo(({ isOpen, onClose, failedInvoices, title }) => {
    // Add keyboard listener for Escape key
    React.useEffect(() => {
        if (isOpen) {
            const handleKeyDown = (e) => {
                if (e.key === 'Escape') {
                    handleClose();
                }
            };
            document.addEventListener('keydown', handleKeyDown);
            return () => document.removeEventListener('keydown', handleKeyDown);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleClose = () => {
        if (onClose) onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    const handleCloseButtonClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleClose();
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-content failed-invoices-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{title || 'Failed Invoices'}</h3>
                    <button 
                        className="modal-close-btn" 
                        onClick={handleCloseButtonClick}
                        onPointerDown={handleCloseButtonClick}
                        onMouseDown={(e) => {
                            e.preventDefault();
                        }}
                        type="button"
                        style={{ 
                            background: '#f44336', 
                            color: 'white',
                            border: 'none', 
                            fontSize: '16px', 
                            cursor: 'pointer',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            zIndex: '10000',
                            position: 'relative',
                            minWidth: '80px',
                            minHeight: '36px',
                            pointerEvents: 'auto'
                        }}
                    >
                        ✕ CLOSE
                    </button>
                </div>
                <div className="modal-body">
                    {failedInvoices && failedInvoices.length > 0 ? (
                        <div className="failed-invoices-container">
                            <div className="failed-invoices-count-badge">
                                ❌ {failedInvoices.length} Failed Invoice{failedInvoices.length !== 1 ? 's' : ''} Found
                            </div>
                            <div className="failed-invoices-list">
                                {failedInvoices.map((invoice, index) => (
                                    <div key={index} className="failed-invoice-card">
                                        <div className="failed-invoice-header">
                                            <span className="invoice-number">#{index + 1}</span>
                                            <span className="invoice-name">{invoice.name}</span>
                                            <span className="invoice-status">Failed</span>
                                        </div>
                                        <div className="failed-invoice-details">
                                            <div className="invoice-field">
                                                <span className="field-label">📅 Timestamp:</span>
                                                <span className="field-value">
                                                    {new Date(invoice.timestamp).toLocaleString()}
                                                </span>
                                            </div>
                                            <div className="invoice-field">
                                                <span className="field-label">❗ Error Message:</span>
                                                <span className="field-value error-message">
                                                    {invoice.message || 'Unknown error occurred'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="no-failed-invoices">
                            <div className="no-failed-invoices-icon">✅</div>
                            <h4>No Failed Invoices</h4>
                            <p>All invoices were processed successfully!</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});
FailedInvoicesModal.displayName = 'FailedInvoicesModal';

// DuplicateInvoicesModal component - similar to FailedInvoicesModal
const DuplicateInvoicesModal = React.memo(({ isOpen, onClose, duplicateInvoices, title }) => {
    // Add keyboard listener for Escape key
    React.useEffect(() => {
        if (isOpen) {
            const handleKeyDown = (e) => {
                if (e.key === 'Escape') {
                    handleClose();
                }
            };
            document.addEventListener('keydown', handleKeyDown);
            return () => document.removeEventListener('keydown', handleKeyDown);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    return (
        <div 
            className="modal-overlay" 
            onClick={handleOverlayClick}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            }}
        >
            <div 
                className="modal-container"
                style={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    width: '90%',
                    maxWidth: '800px',
                    maxHeight: '80vh',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div 
                    className="modal-header"
                    style={{
                        padding: '16px 20px',
                        borderBottom: '1px solid #e0e0e0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
                        {title || 'Duplicate Invoices'}
                    </h3>
                    <button
                        onClick={handleClose}
                        style={{ 
                            backgroundColor: '#ff4444',
                            color: 'white',
                            border: 'none',
                            fontSize: '16px', 
                            cursor: 'pointer',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            zIndex: '10000',
                            position: 'relative',
                            minWidth: '80px',
                            minHeight: '36px',
                            pointerEvents: 'auto'
                        }}
                    >
                        ✕ CLOSE
                    </button>
                </div>
                <div className="modal-body">
                    {duplicateInvoices && duplicateInvoices.length > 0 ? (
                        <div className="duplicate-invoices-container">
                            <div className="duplicate-invoices-count-badge" style={{
                                backgroundColor: '#fff3cd',
                                color: '#856404',
                                padding: '12px 16px',
                                borderRadius: '6px',
                                marginBottom: '16px',
                                fontWeight: '600',
                                fontSize: '16px',
                                textAlign: 'center'
                            }}>
                                ⚠️ {duplicateInvoices.length} Duplicate Invoice{duplicateInvoices.length !== 1 ? 's' : ''} Found
                            </div>
                            <div className="duplicate-invoices-list">
                                {duplicateInvoices.map((invoice, index) => (
                                    <div key={index} className="duplicate-invoice-card" style={{
                                        backgroundColor: '#fff9e6',
                                        border: '1px solid #ffd966',
                                        borderRadius: '8px',
                                        padding: '16px',
                                        marginBottom: '12px'
                                    }}>
                                        <div className="duplicate-invoice-header" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            marginBottom: '12px',
                                            paddingBottom: '8px',
                                            borderBottom: '1px solid #ffd966'
                                        }}>
                                            <span className="invoice-number" style={{
                                                backgroundColor: '#856404',
                                                color: 'white',
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                fontSize: '14px',
                                                fontWeight: '600'
                                            }}>#{index + 1}</span>
                                            <span className="invoice-name" style={{
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                flex: 1,
                                                marginLeft: '12px'
                                            }}>{invoice.invoice_number || 'N/A'}</span>
                                            <span className="invoice-status" style={{
                                                backgroundColor: '#ffc107',
                                                color: '#856404',
                                                padding: '4px 12px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                            }}>Duplicate</span>
                                        </div>
                                        <div className="duplicate-invoice-details">
                                            {invoice.filename && (
                                                <div className="invoice-field" style={{
                                                    display: 'flex',
                                                    marginBottom: '8px',
                                                    fontSize: '14px'
                                                }}>
                                                    <span className="field-label" style={{
                                                        fontWeight: '600',
                                                        marginRight: '8px',
                                                        minWidth: '140px'
                                                    }}>📄 Filename:</span>
                                                    <span className="field-value">{invoice.filename}</span>
                                                </div>
                                            )}
                                            {invoice.po_number && (
                                                <div className="invoice-field" style={{
                                                    display: 'flex',
                                                    marginBottom: '8px',
                                                    fontSize: '14px'
                                                }}>
                                                    <span className="field-label" style={{
                                                        fontWeight: '600',
                                                        marginRight: '8px',
                                                        minWidth: '140px'
                                                    }}>📋 PO Number:</span>
                                                    <span className="field-value">{invoice.po_number}</span>
                                                </div>
                                            )}
                                            {invoice.vendor_name && (
                                                <div className="invoice-field" style={{
                                                    display: 'flex',
                                                    marginBottom: '8px',
                                                    fontSize: '14px'
                                                }}>
                                                    <span className="field-label" style={{
                                                        fontWeight: '600',
                                                        marginRight: '8px',
                                                        minWidth: '140px'
                                                    }}>🏢 Vendor Name:</span>
                                                    <span className="field-value">{invoice.vendor_name}</span>
                                                </div>
                                            )}
                                            <div className="invoice-field" style={{
                                                display: 'flex',
                                                marginBottom: '8px',
                                                fontSize: '14px'
                                            }}>
                                                <span className="field-label" style={{
                                                    fontWeight: '600',
                                                    marginRight: '8px',
                                                    minWidth: '140px'
                                                }}>📅 Timestamp:</span>
                                                <span className="field-value">
                                                    {new Date(invoice.timestamp).toLocaleString()}
                                                </span>
                                            </div>
                                            <div className="invoice-field" style={{
                                                display: 'flex',
                                                marginBottom: '8px',
                                                fontSize: '14px'
                                            }}>
                                                <span className="field-label" style={{
                                                    fontWeight: '600',
                                                    marginRight: '8px',
                                                    minWidth: '140px'
                                                }}>⚠️ Message:</span>
                                                <span className="field-value" style={{ 
                                                    color: '#856404',
                                                    fontWeight: '500'
                                                }}>
                                                    {invoice.message || 'Duplicate invoice detected'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div className="no-duplicate-invoices" style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '40px 20px',
                            textAlign: 'center'
                        }}>
                            <div className="no-duplicate-invoices-icon" style={{
                                fontSize: '48px',
                                marginBottom: '16px'
                            }}>✅</div>
                            <h4 style={{ margin: '0 0 8px 0', fontSize: '18px' }}>No Duplicate Invoices</h4>
                            <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>All invoices are unique!</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});
DuplicateInvoicesModal.displayName = 'DuplicateInvoicesModal';

const Chat = ({
    dashboardUrl,
    setDashboardUrl,
    activeNavItem,
    setActiveNavItem,
    showFAQ,
    setShowFAQ
}) => {

    const navigate = useNavigate();
    const messagesEndRef = useRef(null);
    const textareaRef = useRef(null);
    const [inputText, setInputText] = useState('');
    const [messages, setMessages] = useState([]);
    const [chatHistory, setChatHistory] = useState([]);
    const [activeChatId, setActiveChatId] = useState(null);
    const [isSidebarActive, setSidebarActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showDashboard, setShowDashboard] = useState(false);
    const [activeDashboard, setActiveDashboard] = useState(null);
    const [deletedChats, setDeletedChats] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(null);
    const [newChatTitle, setNewChatTitle] = useState('');
    const [isEditingTitle, setIsEditingTitle] = useState(false);
    const [showChatList, setShowChatList] = useState(false);
    const [openNestedDropdown, setOpenNestedDropdown] = useState(null);
    const [faqQuestionSelected, setFaqQuestionSelected] = useState(false);
    const [placeholder, setPlaceholder] = useState("Ask Savi...");
    const [showSignOutOptions, setShowSignOutOptions] = useState(false);
    const [openSubmenuParent, setOpenSubmenuParent] = useState(null);
    const [loadedDashboards, setLoadedDashboards] = useState({});
    const [showSettings, setShowSettings] = useState(false);
    const [userInitial, setUserInitial] = useState('');
    const [renameAnchorEl, setRenameAnchorEl] = useState(null);
    const [overlayMenus, setOverlayMenus] = useState([]);
    const [typingMessage, setTypingMessage] = useState(null);
    const [currentTypingText, setCurrentTypingText] = useState('');
    const typingInterval = useRef(null);
    const currentRequestRef = useRef(null);
    const [currentTheme, setCurrentTheme] = useState(
        localStorage.getItem('theme') || 'light'
    );
    const [quickResponseLoading, setQuickResponseLoading] = useState(false);
    const [quickResponseError, setQuickResponseError] = useState(null);
    const [messageFeedback, setMessageFeedback] = useState({});
    const [chartLoadingStates, setChartLoadingStates] = useState({});
    const [chartLoadingProgress, setChartLoadingProgress] = useState({});
    const [pendingVisualizations, setPendingVisualizations] = useState({});

    // Attachment states
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    // Table states for invoice data display
    const [invoiceData, setInvoiceData] = useState(null);
    const [dragActive, setDragActive] = useState(false);
    
    // Modal state for line items popup
    const [showItemsModal, setShowItemsModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState(null);
    const [modalTitle, setModalTitle] = useState('');
    
    // Modal state for failed invoices popup
    const [showFailedInvoicesModal, setShowFailedInvoicesModal] = useState(false);
    const [selectedFailedInvoices, setSelectedFailedInvoices] = useState(null);
    
    // Modal state for duplicate invoices popup
    const [showDuplicateInvoicesModal, setShowDuplicateInvoicesModal] = useState(false);
    const [selectedDuplicateInvoices, setSelectedDuplicateInvoices] = useState(null);
    // State for expanded rows (inline items display)
    const [expandedRows, setExpandedRows] = useState(new Set());
    
    // State for email sending
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [emailSendStatus, setEmailSendStatus] = useState(null);

    // Memoize quick responses to prevent re-creation on every render
    const quickResponses = useMemo(() => [
        {
            id: 1,
            text: "Top 3 opportunities",
            prompt: "Top 3 opportunities with respect to annual revenue in our pipeline?",
            category: "creative"
        },
        {
            id: 2,
            text: "Give 5 deals",
            prompt: "Give 5 deals that we won due to",
            category: "writing"
        },
        {
            id: 3,
            text: "Breakdown of accounts",
            prompt: "Breakdown of accounts by sector",
            category: "writing"
        },
        {
            id: 4,
            text: "Show me all project",
            prompt: "Show me all project names under elangovan",
            category: "translation"
        },
        {
            id: 5,
            text: "Companies expecting revenue",
            prompt: "Companies expecting revenue more than 10 Lakh",
            category: "writing"
        },
        {
            id: 6,
            text: "Revenue lost",
            prompt: "Revenue lost in Q1 2024",
            category: "creative"
        },
        {
            id: 7,
            text: "Lost opportunities",
            prompt: "Lost opportunities in Q1 2024",
            category: "advice"
        },
        {
            id: 8,
            text: "healthcare sector",
            prompt: "companies in healthcare sector",
            category: "analysis"
        }
    ], []);

    // Create SummaryCards component with proper event handlers
    const SummaryCards = useMemo(() => React.memo(({ results, onFailedInvoicesClick, onDuplicateInvoicesClick }) => {
        const handleFailedInvoicesClick = useCallback(() => {
            onFailedInvoicesClick(results.failed_invoices || []);
        }, [results.failed_invoices, onFailedInvoicesClick]);
        
        const handleDuplicateInvoicesClick = useCallback(() => {
            onDuplicateInvoicesClick(results.duplicate_invoices || []);
        }, [results.duplicate_invoices, onDuplicateInvoicesClick]);

        return (
            <div className="invoice-summary-cards">
                <div className="summary-card">
                    <div className="summary-card-value">{results.total_invoices_loaded || 0}</div>
                    <div className="summary-card-label">Total Invoices Scanned</div>
                </div>
                <div className="summary-card success">
                    <div className="summary-card-value">{results.successful_pushed_invoices || 0}</div>
                    <div className="summary-card-label">Successfully Pushed to SAP</div>
                </div>
                <div 
                    className="summary-card error clickable failed-invoices-card" 
                    onClick={handleFailedInvoicesClick}
                    style={{ 
                        cursor: 'pointer',
                        pointerEvents: 'auto',
                        zIndex: 10,
                        position: 'relative'
                    }}
                    title="Click to view failed invoices details"
                >
                    <div className="summary-card-value" style={{ pointerEvents: 'none' }}>
                        {results.failed_invoices_count || 0}
                    </div>
                    <div className="summary-card-label" style={{ pointerEvents: 'none' }}>
                        Pending to Process
                    </div>
                    {results.failed_invoices_count > 0 && (
                        <div className="click-hint" style={{ pointerEvents: 'none' }}>
                            Click to view details
                        </div>
                    )}
                </div>
                <div 
                    className="summary-card warning clickable duplicate-invoices-card" 
                    onClick={handleDuplicateInvoicesClick}
                    style={{ 
                        cursor: 'pointer',
                        pointerEvents: 'auto',
                        zIndex: 10,
                        position: 'relative'
                    }}
                    title="Click to view duplicate invoices details"
                >
                    <div className="summary-card-value" style={{ pointerEvents: 'none' }}>
                        {results.duplicates_found || 0}
                    </div>
                    <div className="summary-card-label" style={{ pointerEvents: 'none' }}>
                        Duplicates Found
                    </div>
                    {results.duplicates_found > 0 && (
                        <div className="click-hint" style={{ pointerEvents: 'none' }}>
                            Click to view details
                        </div>
                    )}
                </div>
            </div>
        );
    }), []);
    SummaryCards.displayName = 'SummaryCards';

    // Handler for failed invoices click
    const handleFailedInvoicesClick = useCallback((failedInvoices) => {
        setSelectedFailedInvoices(failedInvoices);
        setShowFailedInvoicesModal(true);
    }, []);
    
    // Handler for duplicate invoices click
    const handleDuplicateInvoicesClick = useCallback((duplicateInvoices) => {
        setSelectedDuplicateInvoices(duplicateInvoices);
        setShowDuplicateInvoicesModal(true);
    }, []);

    // Handler for sending email with invoice data
    const handleSendEmail = useCallback(async (extractedData, invoiceResults) => {
        try {
            setIsSendingEmail(true);
            setEmailSendStatus(null);
            
            // Get user email from localStorage
            const userType = localStorage.getItem('userType');
            const userEmail = userType === 'vendor' 
                ? localStorage.getItem('userEmail') 
                : localStorage.getItem('user');
            
            if (!userEmail) {
                setEmailSendStatus({ type: 'error', message: 'User email not found. Please login again.' });
                return;
            }
            
            // Build the sap_payload_list from extractedData
            const sap_payload_list = [];
            
            if (extractedData && extractedData.length > 0) {
                extractedData.forEach((invoiceArray) => {
                    if (Array.isArray(invoiceArray)) {
                        sap_payload_list.push({
                            extracted_data: invoiceArray,
                            document_file_path: "Uploaded via web interface",
                            document_type: "PDF"
                        });
                    }
                });
            }
            
            // Prepare the request body
            const emailPayload = {
                recipient: userEmail,
                sap_payload_list: sap_payload_list
            };
            
            console.log('📧 Sending email with payload:', emailPayload);
            
            // Send request to the email API
            const response = await axios.post(
                'https://ocrtool.savictech.com/api/invoice/send_email',
                emailPayload,
                {
                    headers: { 'Content-Type': 'application/json' },
                    timeout: 30000
                }
            );
            
            console.log('✅ Email sent successfully:', response.data);
            setEmailSendStatus({ 
                type: 'success', 
                message: `Email sent successfully to ${userEmail}` 
            });
            
            // Clear success message after 5 seconds
            setTimeout(() => setEmailSendStatus(null), 5000);
            
        } catch (error) {
            console.error('❌ Error sending email:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Failed to send email';
            setEmailSendStatus({ 
                type: 'error', 
                message: `Failed to send email: ${errorMessage}` 
            });
            
            // Clear error message after 8 seconds
            setTimeout(() => setEmailSendStatus(null), 8000);
        } finally {
            setIsSendingEmail(false);
        }
    }, []);

    // Handler for downloading Excel file from server
    const handleDownloadExcel = useCallback(async (extractedData, invoiceResults) => {
        try {
            setIsSendingEmail(true); // Reuse loading state
            setEmailSendStatus(null);
            
            // Build the sap_payload_list from extractedData
            const sap_payload_list = [];
            
            if (extractedData && extractedData.length > 0) {
                extractedData.forEach((invoiceArray) => {
                    if (Array.isArray(invoiceArray)) {
                        sap_payload_list.push({
                            extracted_data: invoiceArray,
                            document_file_path: "Uploaded via web interface",
                            document_type: "PDF"
                        });
                    }
                });
            }
            
            // Prepare the request body
            const exportPayload = {
                sap_payload_list: sap_payload_list
            };
            
            console.log('📥 Downloading Excel with payload:', exportPayload);
            
            // Send request to the Excel export API
            const response = await axios.post(
                'https://ocrtool.savictech.com/api/export-invoices-excel',
                exportPayload,
                {
                    headers: { 'Content-Type': 'application/json' },
                    responseType: 'blob', // Important for file download
                    timeout: 60000
                }
            );
            
            // Create blob and download
            const blob = new Blob([response.data], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            
            // Extract filename from Content-Disposition header or use default
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'SAP_Invoices.xlsx';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1].replace(/['"]/g, '');
                }
            }
            
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            console.log('✅ Excel file downloaded successfully');
            setEmailSendStatus({ 
                type: 'success', 
                message: 'Excel file downloaded successfully' 
            });
            
            // Clear success message after 5 seconds
            setTimeout(() => setEmailSendStatus(null), 5000);
            
        } catch (error) {
            console.error('❌ Error downloading Excel:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Failed to download Excel file';
            setEmailSendStatus({ 
                type: 'error', 
                message: `Failed to download: ${errorMessage}` 
            });
            
            // Clear error message after 8 seconds
            setTimeout(() => setEmailSendStatus(null), 8000);
        } finally {
            setIsSendingEmail(false);
        }
    }, []);

    // Optimized ExtractedDataTable component with memoization
    const ExtractedDataTable = useMemo(() => React.memo(({ extractedData, expandedRows, onToggleExpansion, onSendEmail, onDownloadExcel, invoiceResults, isSendingEmail, emailSendStatus }) => {
        // Flatten the extracted data and prepare for table display
        const flattenedData = useMemo(() => {
            const result = [];
            if (extractedData && extractedData.length > 0) {
                extractedData.forEach((invoiceArray, invoiceIndex) => {
                    if (Array.isArray(invoiceArray)) {
                        invoiceArray.forEach((invoice, docIndex) => {
                            // Handle both uppercase 'Items' and lowercase 'items' from backend
                            const { Items, items, ...invoiceWithoutItems } = invoice;
                            const itemsArray = Items || items || [];
                            const rowId = `invoice-${invoiceIndex}-${docIndex}`;
                            result.push({
                                ...invoiceWithoutItems,
                                invoiceIndex,
                                docIndex,
                                Items: itemsArray,
                                id: rowId
                            });
                        });
                    }
                });
            }
            return result;
        }, [extractedData]);

        const columnHelper = createColumnHelper();
        
        // Auto-detect columns from the first invoice (excluding Items)
        const columns = useMemo(() => {
            const firstInvoice = flattenedData[0];
            const dynamicColumns = firstInvoice ? 
                Object.keys(firstInvoice)
                    .filter(key => key !== 'Items' && key !== 'invoiceIndex' && key !== 'docIndex' && key !== 'id')
                    .map(key => 
                        columnHelper.accessor(key, {
                            header: key.replace(/([A-Z])/g, ' $1').trim(),
                            cell: info => info.getValue() || 'N/A',
                        })
                    ) : [];

            // Add action column for viewing items
            return [
                {
                    id: 'actions',
                    header: 'Actions',
                    cell: ({ row }) => {
                        const hasItems = row.original.Items && row.original.Items.length > 0;
                        
                        if (!hasItems) {
                            return <span style={{ color: '#999', fontStyle: 'italic', fontSize: '12px' }}>—</span>;
                        }
                        
                        const isExpanded = expandedRows.has(row.id);
                        
                        return React.createElement('button', {
                            onClick: function(e) {
                                e.preventDefault();
                                e.stopPropagation();
                                onToggleExpansion(row.id);
                            },
                            style: {
                                backgroundColor: isExpanded ? '#dc3545' : '#28a745',
                                color: 'white',
                                border: 'none',
                                padding: '6px 10px',
                                borderRadius: '50%',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: 'bold',
                                whiteSpace: 'nowrap',
                                position: 'relative',
                                zIndex: 9999,
                                pointerEvents: 'auto',
                                width: '32px',
                                height: '32px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease'
                            }
                        }, isExpanded ? '▼' : '▶');
                    }
                },
                ...dynamicColumns
            ];
        }, [flattenedData, expandedRows, onToggleExpansion, columnHelper]);

        const table = useReactTable({
            data: flattenedData,
            columns,
            getCoreRowModel: getCoreRowModel(),
        });

        if (!extractedData || extractedData.length === 0) return null;
        if (!flattenedData[0]) return null;

        return (
            <div className="invoice-table-container">
                <div className="table-header-controls" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap', gap: '10px' }}>
                    <h4 className="table-title" style={{ margin: 0 }}>📋 Extracted Invoice Data</h4>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        {emailSendStatus && (
                            <div style={{
                                padding: '8px 16px',
                                borderRadius: '6px',
                                fontSize: '14px',
                                fontWeight: '500',
                                backgroundColor: emailSendStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                                color: emailSendStatus.type === 'success' ? '#155724' : '#721c24',
                                border: `1px solid ${emailSendStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}>
                                {emailSendStatus.type === 'success' ? '✅' : '❌'} {emailSendStatus.message}
                            </div>
                        )}
                        {/* <button 
                            className="send-email-btn"
                            onClick={() => onSendEmail && onSendEmail(extractedData, invoiceResults)}
                            disabled={isSendingEmail}
                            title="Send invoice data via email"
                            style={{
                                backgroundColor: isSendingEmail ? '#6c757d' : '#007bff',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                cursor: isSendingEmail ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                transition: 'background-color 0.2s ease',
                                opacity: isSendingEmail ? 0.7 : 1
                            }}
                            onMouseEnter={(e) => { if (!isSendingEmail) e.target.style.backgroundColor = '#0056b3'; }}
                            onMouseLeave={(e) => { if (!isSendingEmail) e.target.style.backgroundColor = '#007bff'; }}
                        >
                            {isSendingEmail ? (
                                <>
                                    <div style={{
                                        width: '14px',
                                        height: '14px',
                                        border: '2px solid white',
                                        borderTopColor: 'transparent',
                                        borderRadius: '50%',
                                        animation: 'spin 0.8s linear infinite'
                                    }}></div>
                                    Sending...
                                </>
                            ) : (
                                <>
                                    <FiSend style={{ fontSize: '16px' }} /> Send Email
                                </>
                            )}
                        </button> */}
                        <button 
                            className="download-excel-btn"
                            onClick={() => onDownloadExcel && onDownloadExcel(extractedData, invoiceResults)}
                            disabled={isSendingEmail}
                            title="Download as Excel file"
                            style={{
                                backgroundColor: isSendingEmail ? '#6c757d' : '#28a745',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                cursor: isSendingEmail ? 'not-allowed' : 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                transition: 'background-color 0.2s ease',
                                opacity: isSendingEmail ? 0.7 : 1
                            }}
                            onMouseEnter={(e) => { if (!isSendingEmail) e.target.style.backgroundColor = '#218838'; }}
                            onMouseLeave={(e) => { if (!isSendingEmail) e.target.style.backgroundColor = '#28a745'; }}
                        >
                            {isSendingEmail ? (
                                <>
                                    <div style={{
                                        width: '14px',
                                        height: '14px',
                                        border: '2px solid white',
                                        borderTopColor: 'transparent',
                                        borderRadius: '50%',
                                        animation: 'spin 0.8s linear infinite'
                                    }}></div>
                                    Downloading...
                                </>
                            ) : (
                                <>
                                    <FiDownload style={{ fontSize: '16px' }} /> Download Excel
                                </>
                            )}
                        </button>
                    </div>
                </div>
                <div className="table-wrapper">
                    <table className="invoice-table">
                        <thead>
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map(header => (
                                        <th key={header.id}>
                                            {header.isPlaceholder
                                                ? null
                                                : flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            {table.getRowModel().rows.map(row => (
                                <React.Fragment key={row.id}>
                                    <tr>
                                        {row.getVisibleCells().map(cell => (
                                            <td key={cell.id}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                            </td>
                                        ))}
                                    </tr>
                                    {/* Inline Items Display */}
                                    {expandedRows.has(row.id) && row.original.Items && row.original.Items.length > 0 && (
                                        <tr className="expanded-row">
                                            <td colSpan={columns.length} className="expanded-cell">
                                                <div className="inline-items-container">
                                                    <div className="inline-items-header">
                                                        <h4>📦 Items for Invoice {row.original.InvoiceNumber || row.original.DocumentNumber || 'Unknown'}</h4>
                                                        <div className="items-count-badge">
                                                            {row.original.Items.length} Item{row.original.Items.length !== 1 ? 's' : ''} Found
                                                        </div>
                                                    </div>
                                                    <div className="inline-items-table-wrapper">
                                                        <table className="inline-items-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>#</th>
                                                                    {row.original.Items.length > 0 && Object.keys(row.original.Items[0]).map(key => (
                                                                        <th key={key}>
                                                                            {key.replace(/([A-Z])/g, ' $1').trim()}
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {row.original.Items.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td className="item-number-cell">#{index + 1}</td>
                                                                        {Object.entries(item).map(([key, value]) => (
                                                                            <td key={key} className="item-value-cell">
                                                                                {value !== null && value !== undefined ? String(value) : 'N/A'}
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }), []);
    ExtractedDataTable.displayName = 'ExtractedDataTable';

    // Handler for toggling row expansion
    const handleToggleExpansion = useCallback((rowId) => {
        setExpandedRows(prev => {
            const newSet = new Set(prev);
            if (newSet.has(rowId)) {
                newSet.delete(rowId);
            } else {
                newSet.add(rowId);
            }
            return newSet;
        });
    }, []);

    const handleSignOut = () => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('user');
        localStorage.removeItem('userType');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('token');
        sessionStorage.removeItem('savi_chat_messages');
        sessionStorage.removeItem('savi_chat_token');
        navigate('/', { replace: true });
    };

    // Message feedback handlers - optimized with useCallback
    const handleThumbsUp = useCallback((messageIndex) => {
        setMessageFeedback(prev => ({
            ...prev,
            [messageIndex]: { ...prev[messageIndex], thumbsUp: !prev[messageIndex]?.thumbsUp, thumbsDown: false }
        }));
    }, []);

    const handleThumbsDown = useCallback((messageIndex) => {
        setMessageFeedback(prev => ({
            ...prev,
            [messageIndex]: { ...prev[messageIndex], thumbsDown: !prev[messageIndex]?.thumbsDown, thumbsUp: false }
        }));
    }, []);

    const [copiedMessageId, setCopiedMessageId] = useState(null);

    const handleCopyMessage = useCallback(async (messageText, messageId) => {
        // Create a temporary div to extract text from HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = messageText;
        const plainText = tempDiv.textContent || tempDiv.innerText || messageText;
        
        try {
            await navigator.clipboard.writeText(plainText);
            
            // Show visual feedback
            setCopiedMessageId(messageId);
            setTimeout(() => setCopiedMessageId(null), 2000);
        } catch (err) {
            console.error('Failed to copy message: ', err);
            // Fallback for older browsers
            try {
                const textArea = document.createElement('textarea');
                textArea.value = plainText;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
                setCopiedMessageId(messageId);
                setTimeout(() => setCopiedMessageId(null), 2000);
            } catch (fallbackErr) {
                console.error('Fallback copy method also failed: ', fallbackErr);
            }
        }
    }, []);

    const handleQuickResponse = useCallback(async (response) => {
        try {
            setQuickResponseLoading(true);
            setQuickResponseError(null);

            if (typingMessage) {
                stopTyping();
            }

            setInputText(response.prompt);

            if (textareaRef.current) {
                textareaRef.current.focus();
                const length = response.prompt.length;
                textareaRef.current.setSelectionRange(length, length);
            }

        } catch (error) {
            console.error('Error handling quick response:', error);
            setQuickResponseError('Failed to process quick response. Please try again.');
        } finally {
            setQuickResponseLoading(false);
        }
    }, []);

    const sanitizeInput = (input) => {
        const div = document.createElement('div');
        div.textContent = input;
        return div.innerHTML;
    };
    
    const openOverlayMenu = (items, e, parentName = null) => {
        const rect = e.target.getBoundingClientRect();
        const overlayHeight = 50 * items.length + 16; // 48px per item + padding
        const viewportHeight = window.innerHeight;
        let top = rect.top;

        // If overlay would overflow bottom, adjust top
        if (top + overlayHeight > viewportHeight) {
            top = Math.max(8, viewportHeight - overlayHeight - 8);
        }

        setOverlayMenus(prev => {
            // For nested overlays (CEO, CSO, CMO)
            if (parentName && prev.length > 0) {
                // If clicking the same nested item again, close it (toggle)
                if (prev.length > 1 && prev[1].parentName === parentName) {
                    return [prev[0]]; // Keep only main overlay
                }
                // Otherwise replace existing nested overlay with new one
                return [
                    prev[0], // Keep main overlay
                    {
                        items,
                        position: { left: rect.right, top },
                        parentName
                    }
                ];
            }
            // If the last overlay is for the same parent, close it (toggle)
            if (prev.length > 0 && prev[prev.length - 1].parentName === parentName) {
                setOpenSubmenuParent(null);
                return prev.slice(0, -1);
            }
            // Otherwise, add new overlay
            setOpenSubmenuParent(parentName);
            return [
                ...prev,
                {
                    items,
                    position: { left: rect.right, top },
                    parentName
                }
            ];
        });
    };

    // To close the last overlay (back)
    const closeLastOverlay = () => setOverlayMenus(prev => prev.slice(0, -1));

    // To close all overlays
    const closeAllOverlays = () => {
        setOverlayMenus([]);
        setOpenSubmenuParent(null); // <-- reset submenu state
    };
    const handleShowFAQ = () => {
        stopTyping(); // Stop AI typing effect if running
        setShowFAQ(true);
        setShowDashboard(false);
        setMessages([]);
    };

    const handleInputFocus = () => {
        if (window.innerWidth < 769) {
            setSidebarActive(false); // Collapse sidebar
        }
    };

    // Handle navigation to a specific dashboard
    // const handleDashboardNavigation = (dashboardName, url) => {
    //     stopTyping(); // Stop any typing effect
    //     setActiveNavItem('Dashboard');
    //     setActiveDashboard(dashboardName);
    //     setDashboardUrl(dashboardUrl);
    //     setShowDashboard(true);
    //     setShowFAQ(false);
    //     setActiveChatId(null);
    //     setMessages([]);
    //     setInputText('');

    //     // Track that this dashboard has been loaded
    //     setLoadedDashboards((prev) => ({
    //         ...prev,
    //         [dashboardName]: true,
    //     }));



    //     // Add a helpful system message about the dashboard context
    //     const systemMessage = {
    //         text: `You're now viewing the ${dashboardName} dashboard. You can ask questions about the data shown here.`,
    //         sender: 'system',
    //         timestamp: new Date(),
    //         dashboardContext: dashboardName,
    //     };

    //     // Keep existing messages if they're related to this dashboard
    //     let newMessages = [];
    //     if (activeDashboard === dashboardName) {
    //         newMessages = [...messages, systemMessage];
    //     } else {
    //         newMessages = [systemMessage];
    //     }

    //     setMessages(newMessages);

    //     // Generate contextual prompt suggestions based on dashboard type
    //     let suggestedPrompt = '';
    //     switch (dashboardName) {
    //         case 'Customer Details':
    //             suggestedPrompt = 'What are the top customer segments by revenue?';
    //             break;
    //         case 'Vendor Details':
    //             suggestedPrompt = 'Which vendors have the highest fulfillment rates?';
    //             break;
    //         case 'Vendor Aging':
    //             suggestedPrompt = 'Show me vendors with outstanding payments over 60 days';
    //             break;
    //         default:
    //             suggestedPrompt = `Analyze the data in the ${dashboardName} dashboard`;
    //     }

    //     setInputText(suggestedPrompt);
    // };

    {/*Input Bar logic*/ }
    // Move this useEffect outside of the other useEffect
    // useEffect(() => {
    //     if (localStorage.getItem('isAuthenticated')) {
    //         const manager = setupSessionTimeout(navigate);
    //         setSessionManager(manager);
    //         window.sessionTimeout = manager; // Make it globally available for the warning component
    //         manager.startListening();

    //         return () => {
    //             manager.stopListening();
    //         };
    //     }
    // }, [navigate]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 445) {
                setPlaceholder("");
            } else {
                setPlaceholder("Ask Savi...");
            }
        };

        // Add event listener for window resize
        window.addEventListener("resize", handleResize);

        // Call the function initially
        handleResize();

        // Cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 445) {
                setPlaceholder("Ask Savi...");
            } else {
                setPlaceholder("Ask Savi...");
            }
        };

        // Add event listener for window resize
        window.addEventListener("resize", handleResize);

        // Call the function initially
        handleResize();

        // Cleanup
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    useEffect(() => {
        const handleBackButton = (e) => {
            // Prevent default back button behavior
            e.preventDefault();
            // Optionally, you can show a confirmation message
            // window.confirm('Are you sure you want to leave?');
        };

        // Add event listener when component mounts
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handleBackButton);

        // Clean up event listener when component unmounts
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
    }, []);
    useEffect(() => {
        // Push a new entry to the history stack to prevent going back
        window.history.pushState(null, '', window.location.pathname);

        const handlePopState = (e) => {
            // Prevent default back/forward behavior
            e.preventDefault();
            // Keep the user on the current page
            window.history.pushState(null, '', window.location.pathname);
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    // Add this effect to handle click outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            // Only close if click is outside BOTH the dropdown and the settings modal
            if (
                showSignOutOptions &&
                !e.target.closest('.sign-out-container') &&
                !e.target.closest('.settings-modal')
            ) {
                setShowSignOutOptions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showSignOutOptions]);

    useEffect(() => {
        // Only set user initial, do not redirect
        const userType = localStorage.getItem('userType');
        const userEmail = userType === 'vendor' 
            ? localStorage.getItem('userEmail') 
            : localStorage.getItem('user');
        
        if (userEmail) {
            setUserInitial(userEmail.charAt(0).toUpperCase());
        }
    }, []);

    // Auto-scroll to bottom when messages change
    useEffect(() => {
        const scrollToBottom = () => {
            if (messagesEndRef.current) {
                // Only scroll if user isn't manually scrolling up
                const container = messagesEndRef.current.parentElement;
                const isNearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 100;

                if (isNearBottom || !messages.length) {
                    messagesEndRef.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    });
                }
            }
        };

        // Debounce the scroll to prevent jankiness
        const debouncedScroll = setTimeout(scrollToBottom, 100);

        return () => clearTimeout(debouncedScroll);
    }, [messages]);

    useEffect(() => {
        if (showFAQ) setFaqQuestionSelected(false);
    }, [showFAQ]);

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', currentTheme);
    }, [currentTheme]);

    useEffect(() => {
        // This hook ensures chatHistory in localStorage is always synced with state
        // We debounce to avoid excessive writes
        const timer = setTimeout(() => {
            localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
        }, 300);

        return () => clearTimeout(timer);
    }, [chatHistory]);

    useEffect(() => {
        const storedHistory = localStorage.getItem('chatHistory');
        if (storedHistory) {
            try {
                let parsed = JSON.parse(storedHistory);
                if (!Array.isArray(parsed)) parsed = [];
                // Clean up last chat's messages to avoid duplicate AI responses
                if (parsed.length > 0) {
                    const lastChat = parsed[parsed.length - 1];
                    if (lastChat && Array.isArray(lastChat.messages)) {
                        // Remove empty AI messages and duplicate consecutive AI messages
                        let cleaned = [];
                        for (let i = 0; i < lastChat.messages.length; i++) {
                            const msg = lastChat.messages[i];
                            if (
                                msg.sender === 'ai' &&
                                (!msg.text || msg.text.trim() === '')
                            ) {
                                continue; // skip empty AI messages
                            }
                            if (
                                i > 0 &&
                                msg.sender === 'ai' &&
                                lastChat.messages[i - 1].sender === 'ai'
                            ) {
                                continue; // skip duplicate consecutive AI messages
                            }
                            cleaned.push(msg);
                        }
                        lastChat.messages = cleaned;
                    }
                }
                setChatHistory(parsed);
                setTimeout(cleanupDuplicateChats, 1000);
            } catch (e) {
                console.error('Failed to parse chat history:', e);
                setChatHistory([]); // fallback to empty
            }
        } else {
            setChatHistory([]); // fallback to empty
        }
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setSidebarActive(window.innerWidth > 375);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        localStorage.setItem('chatHistory', JSON.stringify(chatHistory));
    }, [chatHistory]);

    useEffect(() => {
        localStorage.setItem('deletedChats', JSON.stringify(deletedChats));
    }, [deletedChats]);

    // Typing effect for AI response
    // useEffect(() => {
    //     if (!typingMessage) return;

    //     // Use currentTypingText as the starting point
    //     let currentText = currentTypingText || (
    //         typingMessage.originalFullText
    //             ? typingMessage.originalFullText.substring(0, typingMessage.originalFullText.length - typingMessage.fullText.length)
    //             : ''
    //     );

    //     let i = currentText.length;

    //     typingInterval.current = setInterval(() => {
    //         currentText += typingMessage.fullText[i];
    //         i++;
    //         setCurrentTypingText(currentText);
    //         setMessages(prev => {
    //             const updated = [...prev];
    //             // Find the last AI message (should be the last message)
    //             for (let j = updated.length - 1; j >= 0; j--) {
    //                 if (updated[j].sender === 'ai' && updated[j].isTyping) {
    //                     updated[j] = {
    //                         ...updated[j],
    //                         text: currentText,
    //                         fullText: typingMessage.originalFullText || typingMessage.fullText
    //                     };
    //                     break;
    //                 }
    //             }
    //             return updated;
    //         });

    //         if (i >= typingMessage.fullText.length) {
    //             clearInterval(typingInterval.current);
    //             setTypingMessage(null);
    //             setCurrentTypingText('');
    //             localStorage.removeItem('interruptedChatId');
    //             // Remove isTyping flag after done
    //             setMessages(prev => {
    //                 const updated = [...prev];
    //                 for (let j = updated.length - 1; j >= 0; j--) {
    //                     if (updated[j].sender === 'ai' && updated[j].isTyping) {
    //                         updated[j] = {
    //                             ...updated[j],
    //                             isTyping: false,
    //                             text: typingMessage.originalFullText || currentText
    //                         };
    //                         break;
    //                     }
    //                 }
    //                 // Also update chatHistory with the final AI message
    //                 if (activeChatId) {
    //                     setChatHistory(prevHistory =>
    //                         prevHistory.map(chat =>
    //                             chat.id === activeChatId
    //                                 ? {
    //                                     ...chat,
    //                                     messages: updated
    //                                 }
    //                                 : chat
    //                         )
    //                     );
    //                 }
    //                 return updated;
    //             });
    //         }
    //     }, 14); // Typing speed (ms per character)

    //     return () => clearInterval(typingInterval.current);
    // }, [typingMessage, currentTypingText, activeChatId]); 


    // In your useEffect for typing effect
    useEffect(() => {
        if (!typingMessage) return;

        // Use currentTypingText as the starting point
        let currentText = currentTypingText || (
            typingMessage.originalFullText
                ? typingMessage.originalFullText.substring(0, typingMessage.originalFullText.length - typingMessage.fullText.length)
                : ''
        );

        let i = currentText.length;
        const chunkSize = 3; // Type 3 characters at a time for faster appearance
        const typingSpeed = 5; // Reduced from 14ms to 5ms per chunk

        typingInterval.current = setInterval(() => {
            // Add a chunk of characters at once
            const chunk = typingMessage.fullText.substring(i, i + chunkSize);
            currentText += chunk;
            i += chunkSize;

            setCurrentTypingText(currentText);
            setMessages(prev => {
                const updated = [...prev];
                // Find the last AI message (should be the last message)
                for (let j = updated.length - 1; j >= 0; j--) {
                    if (updated[j].sender === 'ai' && updated[j].isTyping) {
                        updated[j] = {
                            ...updated[j],
                            text: currentText,
                            fullText: typingMessage.originalFullText || typingMessage.fullText
                        };
                        break;
                    }
                }
                return updated;
            });

            if (i >= typingMessage.fullText.length) {
                clearInterval(typingInterval.current);
                setTypingMessage(null);
                setCurrentTypingText('');
                localStorage.removeItem('interruptedChatId');
                
                // Remove isTyping flag after done
                setMessages(prev => {
                    const updated = [...prev];
                    let messageIndex = -1;
                    for (let j = updated.length - 1; j >= 0; j--) {
                        if (updated[j].sender === 'ai' && updated[j].isTyping) {
                            updated[j] = {
                                ...updated[j],
                                isTyping: false,
                                text: typingMessage.originalFullText || currentText
                            };
                            messageIndex = j;
                            break;
                        }
                    }
                    
                    // Check if there are pending visualizations for this message
                    if (messageIndex !== -1 && pendingVisualizations[messageIndex]) {
                        const visualizationData = pendingVisualizations[messageIndex];
                        
                        // Start chart loading indicator
                        setChartLoadingStates(prev => ({
                            ...prev,
                            [messageIndex]: true
                        }));
                        
                        // Progress animation: 10% -> 50% -> 75% -> 100%
                        const progressSteps = [10, 50, 75, 100];
                        const stepDuration = 1250; // 5000ms / 4 steps = 1250ms per step
                        
                        progressSteps.forEach((progress, stepIndex) => {
                            setTimeout(() => {
                                setChartLoadingProgress(prev => ({
                                    ...prev,
                                    [messageIndex]: progress
                                }));
                                
                                // When progress reaches 100%, show all charts
                                if (progress === 100) {
                                    setTimeout(() => {
                                        setMessages(prevMessages => {
                                            const updatedMessages = [...prevMessages];
                                            if (updatedMessages[messageIndex]) {
                                                updatedMessages[messageIndex] = {
                                                    ...updatedMessages[messageIndex],
                                                    visualizations: visualizationData
                                                };
                                            }
                                            return updatedMessages;
                                        });
                                        
                                        setChartLoadingStates(prev => {
                                            const newStates = { ...prev };
                                            delete newStates[messageIndex];
                                            return newStates;
                                        });
                                        
                                        setChartLoadingProgress(prev => {
                                            const newProgress = { ...prev };
                                            delete newProgress[messageIndex];
                                            return newProgress;
                                        });
                                        
                                        // Update chat history with complete visualizations
                                        if (activeChatId) {
                                            setChatHistory(prevHistory => 
                                                prevHistory.map(chat => {
                                                    if (chat.id === activeChatId) {
                                                        const updatedChatMessages = [...chat.messages];
                                                        if (updatedChatMessages[messageIndex]) {
                                                            updatedChatMessages[messageIndex] = {
                                                                ...updatedChatMessages[messageIndex],
                                                                visualizations: visualizationData
                                                            };
                                                        }
                                                        return { ...chat, messages: updatedChatMessages };
                                                    }
                                                    return chat;
                                                })
                                            );
                                        }
                                    }, 200); // Small delay after reaching 100%
                                }
                            }, (stepIndex + 1) * stepDuration);
                        });
                        
                        // Clear pending visualization
                        setPendingVisualizations(prev => {
                            const newPending = { ...prev };
                            delete newPending[messageIndex];
                            return newPending;
                        });
                    }
                    
                    // Also update chatHistory with the final AI message
                    if (activeChatId) {
                        setChatHistory(prevHistory =>
                            prevHistory.map(chat =>
                                chat.id === activeChatId
                                    ? {
                                        ...chat,
                                        messages: updated
                                    }
                                    : chat
                            )
                        );
                    }
                    return updated;
                });
            }
        }, typingSpeed); // Reduced typing speed (ms per chunk)

        return () => clearInterval(typingInterval.current);
    }, [typingMessage, currentTypingText, activeChatId]);

    useEffect(() => {
        // Save incomplete AI response if user leaves chat or component unmounts
        return () => {
            if (typingMessage && activeChatId && currentTypingText) {
                setChatHistory(prevHistory => {
                    return prevHistory.map(chat => {
                        if (chat.id === activeChatId) {
                            // Find last AI message (with isTyping)
                            const updatedMessages = [...chat.messages];
                            let found = false;
                            for (let i = updatedMessages.length - 1; i >= 0; i--) {
                                if (updatedMessages[i].sender === 'ai' && updatedMessages[i].isTyping) {
                                    const fullText = typingMessage.originalFullText || typingMessage.fullText;
                                    const isComplete = currentTypingText === fullText;
                                    updatedMessages[i] = {
                                        ...updatedMessages[i],
                                        text: currentTypingText,
                                        isTyping: !isComplete,
                                        fullText: fullText
                                    };
                                    found = true;
                                    break;
                                }
                            }
                            // Only add a new AI message if not found AND we have meaningful content
                            if (!found && currentTypingText && currentTypingText.trim()) {
                                updatedMessages.push({
                                    text: currentTypingText,
                                    sender: 'ai',
                                    timestamp: new Date(),
                                    type: 'text',
                                    isTyping: true,
                                    fullText: typingMessage.originalFullText || typingMessage.fullText
                                });
                            }
                            return { ...chat, messages: updatedMessages };
                        }
                        return chat;
                    });
                });
            }
        };
    }, [activeChatId, typingMessage, currentTypingText]);

    useEffect(() => {
        // Load saved theme
        const savedTheme = localStorage.getItem('theme') || 'light';
        document.documentElement.setAttribute('data-theme', savedTheme);
        setCurrentTheme(savedTheme);
    }, []);

    //  add detection for system preferences
    useEffect(() => {
        // Check for saved theme preference
        const savedTheme = localStorage.getItem('theme');

        if (!savedTheme) {
            // If no saved preference, check system preference
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            const defaultTheme = prefersDark ? 'dark' : 'light';
            setCurrentTheme(defaultTheme);
        }
    }, []);

    const stopTyping = () => {
        if (typingInterval.current) {
            clearInterval(typingInterval.current);
        }

        const incompleteText = currentTypingText;

        setTypingMessage(null);
        setCurrentTypingText('');

        setMessages(prev => {
            const updated = prev.map((msg, index) => {
                if (msg.sender === 'ai' && msg.isTyping) {
                    const fullText = msg.fullText || msg.text;
                    // Always set isTyping: false when manually stopped
                    const updatedMsg = {
                        ...msg,
                        text: incompleteText || msg.text, // Fallback to existing text if incompleteText is empty
                        isTyping: false, // Always set to false when manually stopped
                        fullText: fullText // always preserve fullText for resuming
                    };
                    
                    // Check if there are pending visualizations for this message
                    if (pendingVisualizations[index]) {
                        const visualizationData = pendingVisualizations[index];
                        
                        // Start chart loading indicator
                        setChartLoadingStates(prevStates => ({
                            ...prevStates,
                            [index]: true
                        }));
                        
                        // Progress animation: 10% -> 50% -> 75% -> 100%
                        const progressSteps = [10, 50, 75, 100];
                        const stepDuration = 1250; // 5000ms / 4 steps = 1250ms per step
                        
                        progressSteps.forEach((progress, stepIndex) => {
                            setTimeout(() => {
                                setChartLoadingProgress(prev => ({
                                    ...prev,
                                    [index]: progress
                                }));
                                
                                // When progress reaches 100%, show all charts
                                if (progress === 100) {
                                    setTimeout(() => {
                                        setMessages(prevMessages => {
                                            const updatedMessages = [...prevMessages];
                                            if (updatedMessages[index]) {
                                                updatedMessages[index] = {
                                                    ...updatedMessages[index],
                                                    visualizations: visualizationData
                                                };
                                            }
                                            return updatedMessages;
                                        });
                                        
                                        setChartLoadingStates(prevStates => {
                                            const newStates = { ...prevStates };
                                            delete newStates[index];
                                            return newStates;
                                        });
                                        
                                        setChartLoadingProgress(prev => {
                                            const newProgress = { ...prev };
                                            delete newProgress[index];
                                            return newProgress;
                                        });
                                        
                                        // Update chat history with complete visualizations
                                        if (activeChatId) {
                                            setChatHistory(prevHistory => 
                                                prevHistory.map(chat => {
                                                    if (chat.id === activeChatId) {
                                                        const updatedChatMessages = [...chat.messages];
                                                        if (updatedChatMessages[index]) {
                                                            updatedChatMessages[index] = {
                                                                ...updatedChatMessages[index],
                                                                visualizations: visualizationData
                                                            };
                                                        }
                                                        return { ...chat, messages: updatedChatMessages };
                                                    }
                                                    return chat;
                                                })
                                            );
                                        }
                                    }, 200); // Small delay after reaching 100%
                                }
                            }, (stepIndex + 1) * stepDuration);
                        });
                        
                        // Clear pending visualization
                        setPendingVisualizations(prevPending => {
                            const newPending = { ...prevPending };
                            delete newPending[index];
                            return newPending;
                        });
                    }
                    
                    return updatedMsg;
                }
                return msg;
            });

            // Update chat history if there's an active chat
            if (activeChatId) {
                setChatHistory(prevHistory =>
                    prevHistory.map(chat =>
                        chat.id === activeChatId
                            ? { ...chat, messages: updated }
                            : chat
                    )
                );
            }

            // Save interrupted chat id if not complete and we have meaningful content
            if (activeChatId && incompleteText && typingMessage) {
                const fullText = typingMessage.originalFullText || typingMessage.fullText;
                if (incompleteText !== fullText && incompleteText.trim()) {
                    localStorage.setItem('interruptedChatId', activeChatId);
                } else {
                    localStorage.removeItem('interruptedChatId');
                }
            }

            return updated;
        });
    };

    const cancelRequest = () => {
        // Cancel any ongoing API request
        if (currentRequestRef.current) {
            currentRequestRef.current.abort();
            currentRequestRef.current = null;
        }

        // Stop any typing animation
        stopTyping();

        // Reset loading state
        setLoading(false);

        // Remove the last user message and any pending AI response
        setMessages(prev => {
            // Find the last user message and remove it along with any pending AI response
            const filtered = prev.filter((msg, index) => {
                // Keep all messages except the last user message and any AI response that's currently typing
                if (msg.sender === 'ai' && (msg.isTyping || msg.text === '')) {
                    return false;
                }
                // Check if this is the last user message (most recent one)
                const lastUserIndex = [...prev].reverse().findIndex(m => m.sender === 'user');
                const actualLastUserIndex = lastUserIndex >= 0 ? prev.length - 1 - lastUserIndex : -1;
                return index !== actualLastUserIndex;
            });
            return filtered;
        });

        // Update chat history
        if (activeChatId) {
            setChatHistory(prevHistory =>
                prevHistory.map(chat => {
                    if (chat.id === activeChatId) {
                        const filtered = chat.messages.filter((msg, index) => {
                            if (msg.sender === 'ai' && (msg.isTyping || msg.text === '')) {
                                return false;
                            }
                            const lastUserIndex = [...chat.messages].reverse().findIndex(m => m.sender === 'user');
                            const actualLastUserIndex = lastUserIndex >= 0 ? chat.messages.length - 1 - lastUserIndex : -1;
                            return index !== actualLastUserIndex;
                        });
                        return { ...chat, messages: filtered };
                    }
                    return chat;
                })
            );
        }
    };

    const toggleSidebar = () => {
        setSidebarActive(!isSidebarActive);
    };



    // Function to clean up formatting and convert markdown to HTML-like formatting
    const cleanFormatting = (text) => {
        if (!text) return '';

        // Remove dtype lines completely
        text = text.replace(/\s*dtype:\s*\w+\s*[\r\n]*/g, '');

        // Clean up data frame indices for better readability
        text = text.replace(/^\s*\d+\s+/gm, '');

        // Replace markdown headers with clean bold text
        text = text.replace(/^#+\s*(.*?)\s*#*$/gm, '<strong>$1</strong>');

        // Replace **bold** with <strong>
        text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

        // Replace *italic* with <em>
        text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');

        // Replace literal \n with actual line breaks
        text = text.replace(/\\n/g, '\n');

        // Replace markdown lists with HTML-like lists
        text = text.replace(/^\s*[-*+]\s+(.*)/gm, '• $1');

        // Add special formatting for key metrics and values
        text = text.replace(/(\d+(\.\d+)?)%/g, '<span class="metric-value">$1%</span>');

        // Format dates to be more visible
        text = text.replace(/(\d{4}-\d{2}-\d{2}|\d{2}\/\d{2}\/\d{4})/g,
            '<span class="date-value">$1</span>');

        return text;
    };

    const formatResponse = (data) => {
        // Check for error messages specifically
        if (data.error) {
            return { text: `Error: ${data.error}`, visualizations: null };
        }

        // Handle Django API response format (invoice upload)
        // Check for results object regardless of success flag (backend might return success: false even with data)
        if (data.results && typeof data.results === 'object') {
            // Store invoice data for table display
            setInvoiceData(data.results);
            
            // Debug logging
            console.log('📊 Invoice Data Received:', {
                success: data.success,
                total: data.results.total_invoices_loaded,
                successful: data.results.successful_pushed_invoices,
                failed: data.results.failed_invoices_count,
                duplicates: data.results.duplicates_found,
                extractedDataLength: data.results.extracted_data?.length || 0,
                duplicateInvoicesLength: data.results.duplicate_invoices?.length || 0,
                hasExtractedData: !!(data.results.extracted_data && data.results.extracted_data.length > 0)
            });
            
            // Return minimal text with table display flag
            const summaryText = data.message ? `${data.message}` : 'Invoice processing completed';
            return { 
                text: summaryText, 
                visualizations: null,
                showInvoiceTables: true,
                invoiceResults: data.results 
            };
        }

        // Simple response with just a message
        if (data.response) {
            // Check if the response field contains stringified JSON with visualizations
            try {
                const parsedResponse = JSON.parse(data.response);
                if (parsedResponse.visualizations || parsedResponse.visualisation || parsedResponse.summary) {
                    let formattedText = '';
                    let visualizations = null;

                    // Handle the summary text
                    if (parsedResponse.summary) {
                        formattedText += cleanFormatting(parsedResponse.summary);
                    }

                    // Extract visualizations (handle both spellings: visualizations and visualisation)
                    if (parsedResponse.visualizations && Array.isArray(parsedResponse.visualizations)) {
                        visualizations = parsedResponse.visualizations;
                    } else if (parsedResponse.visualisation) {
                        // Single visualization object, convert to array
                        visualizations = [parsedResponse.visualisation];
                    }

                    return { text: formattedText, visualizations: visualizations };
                }
            } catch (e) {
                // If parsing fails, treat as regular text response
            }
            
            return { text: cleanFormatting(data.response), visualizations: null };
        }

        // Check for report/analysis structure
        if (data.report || data.ai_insights) {
            let formattedText = '';

            // Add a header for report section if it exists
            if (data.report) {
                formattedText += '<strong>📊 Analysis Report</strong>\n\n';
                formattedText += cleanFormatting(data.report);
            }

            // Add a separator if both sections exist
            if (data.report && data.ai_insights) {
                formattedText += '\n\n';
            }

            // Add a header for insights section if it exists
            if (data.ai_insights) {
                formattedText += '<strong>💡 AI Insights</strong>\n\n';
                formattedText += cleanFormatting(data.ai_insights);
            }

            return { text: formattedText, visualizations: null };
        }

        // Check for visualization data in the response
        if (data.visualizations || data.charts) {
            let formattedText = '';
            let visualizations = null;

            // Handle the summary text
            if (data.summary) {
                formattedText += cleanFormatting(data.summary);
            } else {
                formattedText += '<strong>📈 Data Visualization</strong>';
            }

            // Extract visualizations
            if (data.visualizations && Array.isArray(data.visualizations)) {
                visualizations = data.visualizations;
            } else if (data.charts && Array.isArray(data.charts)) {
                visualizations = data.charts;
            }

            return { text: formattedText, visualizations: visualizations };
        }

        // Check for other common fields
        const possibleFields = ['message', 'content', 'answer', 'text'];
        for (const field of possibleFields) {
            if (data[field]) {
                return { text: cleanFormatting(data[field]), visualizations: null };
            }
        }

        // OpenAI format
        if (data.choices && data.choices[0]?.message?.content) {
            return { text: cleanFormatting(data.choices[0].message.content), visualizations: null };
        }

        // If we can't find a specific field to extract, format the entire object
        return { text: cleanFormatting(JSON.stringify(data, null, 2)), visualizations: null };
    };


    // const parseApiResponse = (responseData) => {
    //             if (typeof responseData === 'string') {
    //                 return responseData;
    //             } else if (responseData && typeof responseData === 'object') {
    //                 return responseData.response || JSON.stringify(responseData, null, 2);
    //             }
    //             return String(responseData);
    //         };
    const chatSessionRef = useRef(0);

    






    // Helper function to create a standardized message object
    const createMessage = (text, sender, type = 'text', isTyping = false, visualizations = null, attachments = null, showInvoiceTables = false, invoiceResults = null) => ({
        text: sender === 'user' ? sanitizeInput(text) : text,
        sender,
        timestamp: new Date(),
        type,
        ...(isTyping && { isTyping: true }),
        ...(visualizations && { visualizations }),
        ...(attachments && { attachments }),
        ...(showInvoiceTables && { showInvoiceTables, invoiceResults })
    });

    // Helper function to update chat history efficiently
    const updateChatHistory = (chatId, messages, title) => {
        setChatHistory(prevHistory => {
            const existingChatIndex = prevHistory.findIndex(chat => chat.id === chatId);
            
            if (existingChatIndex >= 0) {
                // Update existing chat
                const updatedHistory = [...prevHistory];
                updatedHistory[existingChatIndex] = {
                    ...updatedHistory[existingChatIndex],
                    messages
                };
                return updatedHistory;
            } else {
                // Add new chat
                return [...prevHistory, {
                    id: chatId,
                    title: title || `New Chat ${new Date().toLocaleTimeString()}`,
                    messages,
                    createdAt: new Date()
                }];
            }
        });
    };

    // Helper function to handle UI state updates
    const updateUIState = (chatId, clearUploadedDoc = true) => {
        setActiveChatId(chatId);
        setShowDashboard(false);
        setShowFAQ(false);
        setActiveNavItem('Chat');
        // uploadedDocument functionality removed
    };

    // Helper function to handle API errors with better categorization
    const handleAPIError = (error, originalInput) => {
        console.error('API call failed:', error);
        
        let errorMessage;
        
        if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
            errorMessage = "Request timed out. Please try again with a shorter message.";
        } else if (error.response?.status === 429) {
            errorMessage = "I'm receiving too many requests right now. Please try again in a moment.";
        } else if (error.response?.status === 503) {
            errorMessage = "Service is temporarily unavailable. Please try again later.";
        } else if (error.response?.status >= 500) {
            errorMessage = "Server error occurred. Please try again later.";
        } else if (!navigator.onLine) {
            errorMessage = "No internet connection. Please check your network and try again.";
        } else {
            errorMessage = "Please try again later.";
        }
        
        return errorMessage;
    };

    // const handleSendMessage = async () => {
    //     // Early validation - prevent multiple sends
    //     if ((!inputText?.trim() && selectedFiles.length === 0) || loading || typingMessage) return;

    //     const originalInput = inputText.trim();
    //     const messageType = detectMessageType(originalInput);
        
    //     // If only files are uploaded without text, show a placeholder message
    //     const displayText = originalInput || (selectedFiles.length > 0 ? `📎 Uploaded ${selectedFiles.length} document${selectedFiles.length > 1 ? 's' : ''}` : '');
        
    //     // Create user message with attachments and update UI immediately
    //     const userMessage = createMessage(displayText, 'user', 'text', false, null, selectedFiles.length > 0 ? [...selectedFiles] : null);
    //     const updatedMessages = [...messages, userMessage];
    //     setMessages(updatedMessages);
        
    //     // Clear input and attachments
    //     setInputText('');
    //     const attachedFiles = [...selectedFiles];
    //     setSelectedFiles([]);

    //     // Get or create chat ID
    //     const currentChatId = activeChatId || createNewChat(updatedMessages, originalInput);
    //     const chatTitle = originalInput.substring(0, 30);

    //     // Handle contextual responses (greetings/farewells) - but not if there are attachments
    //     if ((messageType.isGreeting || messageType.isFarewell) && attachedFiles.length === 0) {
    //         const responseText = generateContextualResponse(messageType);
    //         const aiMessage = createMessage(responseText, 'ai');
    //         const finalMessages = [...updatedMessages, aiMessage];
            
    //         setMessages(finalMessages);
    //         updateChatHistory(currentChatId, finalMessages, chatTitle);
    //         updateUIState(currentChatId, false);
    //         return;
    //     }

    //     // Handle API requests
    //     setLoading(true);
    //     setIsUploading(attachedFiles.length > 0);
        
    //     try {
    //         // Select API endpoint based on whether files are attached
    //         const endpoint = attachedFiles.length > 0 
    //             ? 'https://ocrtool.savictech.com/api/'  // New API for document uploads
    //             : process.env.REACT_APP_UNIFIED_API;  // Unified API for text-only
            
    //         if (!endpoint) {
    //             throw new Error('API endpoint not configured');
    //         }

    //         // Create AbortController for request cancellation
    //         const abortController = new AbortController();
    //         currentRequestRef.current = abortController;

    //         // Prepare API request with files if any
    //         let response;
    //         if (attachedFiles.length > 0) {
    //             // Create FormData for file upload
    //             const formData = new FormData();
    //             formData.append('action', 'upload_invoice');
                
    //             attachedFiles.forEach((fileData) => {
    //                 formData.append('invoice', fileData.file);
    //             });

    //             response = await axios.post(endpoint, formData, {
    //                 headers: { 
    //                     'Content-Type': 'multipart/form-data'
    //                 },
    //                 timeout: 120000, // Longer timeout for file uploads
    //                 signal: abortController.signal,
    //                 maxRetries: 2,
    //                 retryDelay: 1000,
    //                 onUploadProgress: (progressEvent) => {
    //                     // You could add upload progress indication here
    //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //                     console.log(`Upload Progress: ${percentCompleted}%`);
    //                 }
    //             });
    //         } else {
    //             // Regular text-only request
    //             const payload = { question: originalInput };
    //             response = await axios.post(endpoint, payload, {
    //                 headers: { 'Content-Type': 'application/json' },
    //                 timeout: 60000,
    //                 signal: abortController.signal,
    //                 maxRetries: 2,
    //                 retryDelay: 1000
    //             });
    //         }

    //         // Clear the request ref after successful completion
    //         currentRequestRef.current = null;

    //         // Process successful response
    //         console.log('🔍 Full API Response:', response.data);
            
    //         const aiFullText = parseApiResponse(response.data) || 'No response received';
    //         const visualizationData = extractVisualizationData(response.data);
    //         const tableData = extractInvoiceTableData(response.data);
            
    //         console.log('🔍 Table Data:', {
    //             showInvoiceTables: tableData.showInvoiceTables,
    //             hasInvoiceResults: !!tableData.invoiceResults,
    //             extractedDataLength: tableData.invoiceResults?.extracted_data?.length
    //         });
            
    //         // Check if this is an invoice upload response with table data
    //         if (tableData.showInvoiceTables && tableData.invoiceResults) {
    //             console.log('✅ Invoice upload detected - showing tables immediately');
    //             // For invoice uploads, show the complete message immediately with tables
    //             const aiMessage = createMessage(aiFullText, 'ai', 'text', false, null, null, tableData.showInvoiceTables, tableData.invoiceResults);
    //             const finalMessages = [...updatedMessages, aiMessage];
                
    //             console.log('📋 AI Message created:', {
    //                 hasShowInvoiceTables: aiMessage.showInvoiceTables,
    //                 hasInvoiceResults: !!aiMessage.invoiceResults,
    //                 invoiceResultsKeys: aiMessage.invoiceResults ? Object.keys(aiMessage.invoiceResults) : []
    //             });
                
    //             setMessages(finalMessages);
    //             updateChatHistory(currentChatId, finalMessages, chatTitle);
    //             updateUIState(currentChatId);
    //         } else {
    //             console.log('ℹ️ Regular text response - using typing animation');

    //             // For regular text responses, use typing animation
    //             // Create AI message with summary only first
    //             const aiMessage = createMessage('', 'ai', 'text', true, null, null, false, null);
    //             const finalMessages = [...updatedMessages, aiMessage];
                
    //             setMessages(finalMessages);
    //             setTypingMessage({ fullText: aiFullText });
                
    //             // If there are visualizations, store them for delayed loading after typing completes
    //             if (visualizationData) {
    //                 const messageIndex = finalMessages.length - 1;
    //                 setPendingVisualizations(prev => ({
    //                     ...prev,
    //                     [messageIndex]: visualizationData
    //                 }));
    //             }
                
    //             updateChatHistory(currentChatId, finalMessages, chatTitle);
    //             updateUIState(currentChatId);
    //         }

    //     } catch (error) {
    //         // Clear the request ref
    //         currentRequestRef.current = null;
            
    //         // Handle request cancellation
    //         if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
    //             // Request was cancelled, don't show error message
    //             return;
    //         }
            
    //         // Handle API errors gracefully
    //         const errorMessage = handleAPIError(error, originalInput);
    //         const aiMessage = createMessage('', 'ai', 'text', true);
    //         const finalMessages = [...updatedMessages, aiMessage];
            
    //         setMessages(finalMessages);
    //         setTypingMessage({ fullText: sanitizeInput(errorMessage) });
    //         updateChatHistory(currentChatId, finalMessages, chatTitle);
    //         updateUIState(currentChatId);
            
    //     } finally {
    //         setLoading(false);
    //         setIsUploading(false);
    //     }
    // };

    // Main handleSendMessage function - now much cleaner and more maintainable
    const handleSendMessage = async () => {
        // Early validation - prevent multiple sends
        if ((!inputText?.trim() && selectedFiles.length === 0) || loading || typingMessage) return;

        const originalInput = inputText.trim();
        
        // If only files are uploaded without text, show a placeholder message
        const displayText = originalInput || (selectedFiles.length > 0 ? `📎 Uploaded ${selectedFiles.length} document${selectedFiles.length > 1 ? 's' : ''}` : '');
        
        // Create user message with attachments and update UI immediately
        const userMessage = createMessage(displayText, 'user', 'text', false, null, selectedFiles.length > 0 ? [...selectedFiles] : null);
        const updatedMessages = [...messages, userMessage];
        setMessages(updatedMessages);
        
        // Clear input and attachments
        setInputText('');
        const attachedFiles = [...selectedFiles];
        setSelectedFiles([]);

        // Get or create chat ID
        const currentChatId = activeChatId || createNewChat(updatedMessages, originalInput);
        const chatTitle = originalInput.substring(0, 30);

        // Check if user is sending text-only (no files attached) - this would use unified API which user doesn't have access to
        if (attachedFiles.length === 0 && originalInput.length > 0) {
            // User is sending text-only query - they don't have access to unified API
            const denialMessage = "Please upload a document or file to get started. I'm designed to process documents and invoices.";
            
            const aiMessage = createMessage(denialMessage, 'ai');
            const finalMessages = [...updatedMessages, aiMessage];
            
            setMessages(finalMessages);
            updateChatHistory(currentChatId, finalMessages, chatTitle);
            updateUIState(currentChatId, false);
            return;
        }

        // Handle API requests for file uploads only
        setLoading(true);
        setIsUploading(attachedFiles.length > 0);
        
        try {
            // Only proceed if files are attached (OCR API)
            if (attachedFiles.length === 0) {
                throw new Error('No files attached - cannot proceed');
            }

            const endpoint = 'https://adarshocr.savictech.com/api/';  // OCR API for document uploads
            
            if (!endpoint) {
                throw new Error('API endpoint not configured');
            }

            // Create AbortController for request cancellation
            const abortController = new AbortController();
            currentRequestRef.current = abortController;

            // Create FormData for file upload
            const formData = new FormData();
            formData.append('action', 'upload_invoice');
            
            attachedFiles.forEach((fileData) => {
                formData.append('invoice', fileData.file);
            });

            const response = await axios.post(endpoint, formData, {
                headers: { 
                    'Content-Type': 'multipart/form-data'
                    },
                    timeout: 120000, // Longer timeout for file uploads
                    signal: abortController.signal,
                    maxRetries: 2,
                    retryDelay: 1000,
                    onUploadProgress: (progressEvent) => {
                        // You could add upload progress indication here
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        console.log(`Upload Progress: ${percentCompleted}%`);
                    }
                });

            // Clear the request ref after successful completion
            currentRequestRef.current = null;

            // Process successful response
            console.log('🔍 Full API Response:', response.data);
            
            const aiFullText = parseApiResponse(response.data) || 'No response received';
            const visualizationData = extractVisualizationData(response.data);
            const tableData = extractInvoiceTableData(response.data);
            
            console.log('🔍 Table Data:', {
                showInvoiceTables: tableData.showInvoiceTables,
                hasInvoiceResults: !!tableData.invoiceResults,
                extractedDataLength: tableData.invoiceResults?.extracted_data?.length
            });
            
            // Check if this is an invoice upload response with table data
            if (tableData.showInvoiceTables && tableData.invoiceResults) {
                console.log('✅ Invoice upload detected - showing tables immediately');
                // For invoice uploads, show the complete message immediately with tables
                const aiMessage = createMessage(aiFullText, 'ai', 'text', false, null, null, tableData.showInvoiceTables, tableData.invoiceResults);
                const finalMessages = [...updatedMessages, aiMessage];
                
                console.log('📋 AI Message created:', {
                    hasShowInvoiceTables: aiMessage.showInvoiceTables,
                    hasInvoiceResults: !!aiMessage.invoiceResults,
                    invoiceResultsKeys: aiMessage.invoiceResults ? Object.keys(aiMessage.invoiceResults) : []
                });
                
                setMessages(finalMessages);
                updateChatHistory(currentChatId, finalMessages, chatTitle);
                updateUIState(currentChatId);
            } else {
                console.log('ℹ️ Regular text response - using typing animation');

                // For regular text responses, use typing animation
                // Create AI message with summary only first
                const aiMessage = createMessage('', 'ai', 'text', true, null, null, false, null);
                const finalMessages = [...updatedMessages, aiMessage];
                
                setMessages(finalMessages);
                setTypingMessage({ fullText: aiFullText });
                
                // If there are visualizations, store them for delayed loading after typing completes
                if (visualizationData) {
                    const messageIndex = finalMessages.length - 1;
                    setPendingVisualizations(prev => ({
                        ...prev,
                        [messageIndex]: visualizationData
                    }));
                }
                
                updateChatHistory(currentChatId, finalMessages, chatTitle);
                updateUIState(currentChatId);
            }

        } catch (error) {
            // Clear the request ref
            currentRequestRef.current = null;
            
            // Handle request cancellation
            if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') {
                // Request was cancelled, don't show error message
                return;
            }
            
            // Handle API errors gracefully
            const errorMessage = handleAPIError(error, originalInput);
            const aiMessage = createMessage('', 'ai', 'text', true);
            const finalMessages = [...updatedMessages, aiMessage];
            
            setMessages(finalMessages);
            setTypingMessage({ fullText: sanitizeInput(errorMessage) });
            updateChatHistory(currentChatId, finalMessages, chatTitle);
            updateUIState(currentChatId);
            
        } finally {
            setLoading(false);
            setIsUploading(false);
        }
    };





    const createNewChat = (initialMessages = [], chatTitle = '') => {
        const newChatId = Date.now().toString();
        const defaultTitle = chatTitle
            ? sanitizeInput(chatTitle.substring(0, 30))
            : initialMessages.length > 0 && initialMessages[0].text
                ? sanitizeInput(initialMessages[0].text.substring(0, 30))
                : `New Chat ${new Date().toLocaleTimeString()}`;

        setNewChatTitle(defaultTitle);

        // We'll handle the actual creation in updateChat
        return newChatId;
    };

    const updateChat = (chatId, updatedMessages, originalInput, isNewChat) => {
        if (!chatId) return;

        setChatHistory(prevHistory => {
            // For existing chats
            if (!isNewChat) {
                return prevHistory.map(chat =>
                    chat.id === chatId
                        ? { ...chat, messages: updatedMessages }
                        : chat
                );
            }

            // For newly created chats, DO NOT add again (already added in handleSendMessage)
            return prevHistory.map(chat =>
                chat.id === chatId
                    ? { ...chat, messages: updatedMessages }
                    : chat
            );

            // Otherwise, add the new chat
            const newChat = {
                id: chatId,
                title: originalInput.substring(0, 30) || `New Chat ${new Date().toLocaleTimeString()}`,
                messages: updatedMessages,
                createdAt: new Date(),
            };

            return [...prevHistory, newChat];
        });
    }


    const updateCurrentChat = (updatedMessages) => {
        if (!activeChatId) return;

        // Update chat history state with the latest messages
        setChatHistory((prevHistory) => {
            const updatedHistory = prevHistory.map((chat) =>
                chat.id === activeChatId
                    ? { ...chat, messages: updatedMessages }
                    : chat
            );

            // Save the updated chat history to localStorage AFTER updating state
            localStorage.setItem('chatHistory', JSON.stringify(updatedHistory));

            return updatedHistory;
        });
    };

    //Enhanced parser that handles various response formats, including special report formatting
    const parseApiResponse = (responseData) => {
        // For string responses
        if (typeof responseData === 'string') {
            try {
                // Try to parse if it's a stringified JSON
                const parsed = JSON.parse(responseData);
                const formatted = formatResponse(parsed);
                return formatted.text || formatted; // Handle both old and new formats
            } catch {
                // If not valid JSON, return as is
                return responseData;
            }
        }
        // For object responses
        else if (responseData && typeof responseData === 'object') {
            const formatted = formatResponse(responseData);
            return formatted.text || formatted; // Handle both old and new formats
        }

        // If all else fails, convert to string
        return String(responseData);
    };

    // Function to extract visualization data from API response
    const extractVisualizationData = (responseData) => {
        // For string responses
        if (typeof responseData === 'string') {
            try {
                // Try to parse if it's a stringified JSON
                const parsed = JSON.parse(responseData);
                const formatted = formatResponse(parsed);
                return formatted.visualizations || null;
            } catch {
                return null;
            }
        }
        // For object responses
        else if (responseData && typeof responseData === 'object') {
            const formatted = formatResponse(responseData);
            return formatted.visualizations || null;
        }

        return null;
    };

    // Function to extract invoice table data from API response
    const extractInvoiceTableData = (responseData) => {
        // For string responses
        if (typeof responseData === 'string') {
            try {
                // Try to parse if it's a stringified JSON
                const parsed = JSON.parse(responseData);
                const formatted = formatResponse(parsed);
                return {
                    showInvoiceTables: formatted.showInvoiceTables || false,
                    invoiceResults: formatted.invoiceResults || null
                };
            } catch {
                return { showInvoiceTables: false, invoiceResults: null };
            }
        }
        // For object responses
        else if (responseData && typeof responseData === 'object') {
            const formatted = formatResponse(responseData);
            return {
                showInvoiceTables: formatted.showInvoiceTables || false,
                invoiceResults: formatted.invoiceResults || null
            };
        }

        return { showInvoiceTables: false, invoiceResults: null };
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            // Prevent sending message if loading or typing animation is active
            if (!loading && !typingMessage && inputText.trim()) {
                handleSendMessage();
            }
        }
        
        // Cancel request or stop typing with Escape key
        if (e.key === 'Escape') {
            e.preventDefault();
            if (loading && !typingMessage) {
                // Cancel ongoing request
                cancelRequest();
            } else if (typingMessage) {
                // Stop typing animation
                stopTyping();
            }
        }
    };

    const startNewChat = () => {
        stopTyping(); // Stop any typing effect
        chatSessionRef.current += 1; // Reset chat session ID
        setMessages([]); // Clear messages
        setActiveChatId(null);
        setNewChatTitle('');
        setShowDashboard(false);
        setShowFAQ(false);
        setInputText('');
        setActiveNavItem('Chat');
        
        // Clear attachments
        selectedFiles.forEach(file => {
            if (file.preview) {
                URL.revokeObjectURL(file.preview);
            }
        });
        setSelectedFiles([]);
        setDragActive(false);
    };

    const moveToTrash = (chatId, e) => {
        e.stopPropagation();

        const chatToDelete = chatHistory.find(chat => chat.id === chatId);
        if (chatToDelete) {
            setDeletedChats(prev => [...prev, { ...chatToDelete, deletedAt: new Date() }]);
            setChatHistory(prev => prev.filter(chat => chat.id !== chatId));

            if (chatId === activeChatId) {
                setActiveChatId(null);
                setMessages([]);
                setShowDashboard(false);
                setShowFAQ(false);
                setActiveNavItem('Chat');
            }
        }
    };

    const cleanupDuplicateChats = () => {
        setChatHistory(prevHistory => {
            // Group chats by their first user message
            const chatGroups = {};

            prevHistory.forEach(chat => {
                if (!chat.messages || chat.messages.length === 0) return;

                const firstUserMsg = chat.messages.find(msg => msg.sender === 'user');
                if (!firstUserMsg) return;

                const key = firstUserMsg.text;
                if (!chatGroups[key]) chatGroups[key] = [];
                chatGroups[key].push(chat);
            });

            // For each group with multiple chats, keep only the one with most messages
            const chatsToKeep = [];

            Object.values(chatGroups).forEach(group => {
                if (group.length === 1) {
                    chatsToKeep.push(group[0]);
                } else if (group.length > 1) {
                    // Sort by message count (descending) and creation time (ascending)
                    group.sort((a, b) => {
                        const countDiff = (b.messages?.length || 0) - (a.messages?.length || 0);
                        if (countDiff !== 0) return countDiff;
                        return new Date(a.createdAt) - new Date(b.createdAt);
                    });

                    // Keep the chat with most messages (or oldest if tie)
                    chatsToKeep.push(group[0]);
                }
            });

            // Add any chats that didn't have a first user message
            prevHistory.forEach(chat => {
                if (!chat.messages || chat.messages.length === 0 ||
                    !chat.messages.some(msg => msg.sender === 'user')) {
                    chatsToKeep.push(chat);
                }
            });

            return chatsToKeep;
        });
    };

    //Edit
    // Add these functions with your other functions
    const saveTitle = () => {
        if (activeChatId) {
            const updatedHistory = chatHistory.map(chat => {
                if (chat.id === activeChatId) {
                    return { ...chat, title: newChatTitle || 'Untitled Chat' };
                }
                return chat;
            });
            setChatHistory(updatedHistory);
            setNewChatTitle(newChatTitle || 'Untitled Chat');
        }
        setIsEditingTitle(false);
    };

    const startEditTitle = () => {
        const currentChat = chatHistory.find(chat => chat.id === activeChatId);
        if (currentChat) {
            setNewChatTitle(currentChat.title);
        }
        setIsEditingTitle(true);
    };

    const cancelEditTitle = () => {
        const currentChat = chatHistory.find(chat => chat.id === activeChatId);
        if (currentChat) {
            setNewChatTitle(currentChat.title);
        }
        setIsEditingTitle(false);
    };
    //Select a chat from history
    const selectChat = (chatId) => {
        stopTyping();

        setChatHistory(prevHistory => {
            const selectedChat = prevHistory.find(chat => chat.id === chatId);
            if (selectedChat) {
                setActiveChatId(chatId);
                const chatMessages = selectedChat.messages || [];

                // Clean up any duplicate or malformed messages before setting
                const cleanedMessages = chatMessages.filter((message, index) => {
                    // Remove empty AI messages without text
                    if (message.sender === 'ai' && (!message.text || message.text.trim() === '')) {
                        return false;
                    }
                    // Remove duplicate consecutive AI messages
                    if (index > 0 &&
                        message.sender === 'ai' &&
                        chatMessages[index - 1].sender === 'ai' &&
                        !message.isTyping &&
                        !chatMessages[index - 1].isTyping) {
                        return false;
                    }
                    return true;
                });

                setMessages(cleanedMessages); // Only update once
                setNewChatTitle(selectedChat.title || 'Untitled Chat');
                setShowChatList(false);
                setShowFAQ(false);
                setActiveNavItem('Chat');

                // Resume typing if last AI message is incomplete
                const lastMessage = cleanedMessages[cleanedMessages.length - 1];
                if (
                    lastMessage &&
                    lastMessage.sender === 'ai' &&
                    lastMessage.fullText &&
                    lastMessage.text !== lastMessage.fullText
                ) {
                    const fullText = lastMessage.fullText;
                    const currentlyTyped = lastMessage.text || '';
                    const remainingText = fullText.substring(currentlyTyped.length);

                    if (remainingText.length > 0) {
                        setTypingMessage({
                            fullText: remainingText,
                            originalFullText: fullText
                        });
                        setCurrentTypingText(currentlyTyped);

                        localStorage.setItem('interruptedChatId', chatId);

                        // Mark this chat as interrupted for future reference
                        // Optionally, set isTyping to true for this message
                        const updatedMessages = cleanedMessages.map((msg, idx) =>
                            idx === cleanedMessages.length - 1
                                ? { ...msg, isTyping: true }
                                : msg
                        );
                        setMessages(updatedMessages); // Only update once
                    } else {
                        // Message is already complete, just remove isTyping flag
                        const updatedMessages = cleanedMessages.map(msg =>
                            msg === lastMessage ? { ...msg, isTyping: false } : msg
                        );
                        setMessages(updatedMessages); // Only update once
                        localStorage.removeItem('interruptedChatId');
                    }
                }
            }
            return prevHistory;
        });
    };





    // Handle input changes
    const handleInputChange = (e) => {
        setInputText(e.target.value);
    };







    // File upload handlers
    const handleFileSelect = (event) => {
        const files = Array.from(event.target.files);
        handleFilesAdded(files);
        // Clear the input so the same file can be selected again
        event.target.value = '';
    };

    const handleFilesAdded = (files) => {
        const newFiles = files.map(file => ({
            file,
            id: Date.now() + Math.random(),
            preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
            type: getFileType(file.type),
            size: formatFileSize(file.size),
            name: file.name
        }));

        setSelectedFiles(prev => [...prev, ...newFiles]);
    };

    const handleAttachmentRemove = (fileId) => {
        setSelectedFiles(prev => {
            const updated = prev.filter(f => f.id !== fileId);
            // Clean up object URLs to prevent memory leaks
            const removedFile = prev.find(f => f.id === fileId);
            if (removedFile && removedFile.preview) {
                URL.revokeObjectURL(removedFile.preview);
            }
            return updated;
        });
    };

    const handleDragEnter = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(true);
    }, []);

    const handleDragLeave = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
    }, []);

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);

        const files = Array.from(e.dataTransfer.files);
        if (files.length > 0) {
            handleFilesAdded(files);
        }
    }, []);

    // Handle paste event to capture files from clipboard
    const handlePaste = useCallback((e) => {
        const items = e.clipboardData?.items;
        if (!items) return;

        const files = [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            
            // Check if the item is a file
            if (item.kind === 'file') {
                const file = item.getAsFile();
                if (file) {
                    files.push(file);
                }
            }
        }

        // If files were found in clipboard, add them
        if (files.length > 0) {
            e.preventDefault(); // Prevent the default paste behavior for files
            handleFilesAdded(files);
        }
        // If no files, allow normal text paste to continue
    }, []);

    // Helper functions for file handling
    const getFileType = (mimeType) => {
        if (mimeType.startsWith('image/')) return 'image';
        if (mimeType.startsWith('text/') || mimeType.includes('document')) return 'document';
        if (mimeType.includes('pdf')) return 'pdf';
        if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'spreadsheet';
        return 'file';
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const getFileIcon = (fileType) => {
        switch (fileType) {
            case 'image': return <FiImage />;
            case 'document': case 'pdf': return <FiFileText />;
            default: return <FiFile />;
        }
    };

    return (
        <SessionTimeout>
            <div className="app-container">
                {/* Overlay for mobile */}
                {isSidebarActive && (
                    <div
                        className="sidebar-overlay"
                        onClick={toggleSidebar}
                        style={{ display: window.innerWidth <= 426 ? 'block' : 'none' }}
                    />
                )}
                <Sidebar
                    isSidebarActive={isSidebarActive}
                    toggleSidebar={toggleSidebar}
                    startNewChat={startNewChat}
                    chatHistory={chatHistory}
                    activeChatId={activeChatId}
                    selectChat={selectChat}
                    moveToTrash={moveToTrash}
                    deletedChats={deletedChats}
                    setDeletedChats={setDeletedChats}
                    activeNavItem={activeNavItem}
                    setActiveNavItem={setActiveNavItem}
                    showFAQ={showFAQ}
                    setShowFAQ={setShowFAQ}
                    showDashboard={showDashboard}
                    setShowDashboard={setShowDashboard}
                    setActiveChatId={setActiveChatId}
                    setMessages={setMessages}
                    setActiveDashboard={setActiveDashboard}
                    setDashboardUrl={setDashboardUrl}
                    setInputText={setInputText}
                    handleLogout={() => {
                        localStorage.removeItem('isAuthenticated');
                        navigate('/');
                    }}
                    handleSwitch={() => {
                        alert('Account switching functionality would be implemented here');
                    }}
                    openDropdown={openDropdown}
                    setOpenDropdown={setOpenDropdown}
                    openNestedDropdown={openNestedDropdown}
                    setOpenNestedDropdown={setOpenNestedDropdown}
                    setChatHistory={setChatHistory}
                    newChatTitle={newChatTitle}
                    startEditTitle={startEditTitle}
                    cancelEditTitle={cancelEditTitle}
                    setNewChatTitle={setNewChatTitle}
                    isEditingTitle={isEditingTitle}
                    setIsEditingTitle={setIsEditingTitle}
                    activeDashboard={activeDashboard}
                    className={isSidebarActive ? 'active' : ''}
                    renameAnchorEl={renameAnchorEl}
                    setRenameAnchorEl={setRenameAnchorEl}
                    openOverlayMenu={openOverlayMenu}
                    closeAllOverlays={closeAllOverlays}
                    setOverlayMenu={openOverlayMenu}
                    openSubmenuParent={openSubmenuParent}
                    setOpenSubmenuParent={setOpenSubmenuParent}
                />

                {overlayMenus.length > 0 && (
                    <div className="sidebar-overlay-backdrop" onClick={closeAllOverlays}>
                        {overlayMenus.map((menu, idx) => (
                            <div
                                key={idx}
                                className="sidebar-overlay-menu"
                                style={{
                                    left: menu.position.left + 8, // offset each overlay to the right
                                    top: menu.position.top,
                                    position: 'absolute',
                                    zIndex: 1000 + idx
                                }}
                                onClick={e => e.stopPropagation()}
                            >
                                {menu.items.map(item => (
                                    <button
                                        key={item.name}
                                        className="overlay-menu-item"
                                        onClick={e => {
                                            if (item.nestedItems) {
                                                openOverlayMenu(item.nestedItems, e, item.name);
                                            } else if (item.onClick) {
                                                item.onClick();
                                                closeAllOverlays();
                                            }
                                        }}
                                    >
                                        {item.name}
                                        {item.nestedItems && (
                                            <span>
                                                {(openSubmenuParent === item.name)
                                                    ? (isSidebarActive ? '◀' : '▶') // open state
                                                    : (isSidebarActive ? '▶' : '◀') // closed state
                                                }
                                            </span>
                                        )}
                                    </button>
                                ))}
                            </div>
                        ))}
                    </div>
                )}
                {renameAnchorEl && (
                    <div className="rename-popup-overlay" onClick={() => setRenameAnchorEl(null)}>
                        <div
                            className="rename-popup"
                            onClick={e => e.stopPropagation()}
                        >
                            <h4>Rename Chat</h4>
                            <input
                                type="text"
                                value={newChatTitle}
                                onChange={e => setNewChatTitle(e.target.value)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        // Confirm rename logic
                                        if (newChatTitle.trim() && activeChatId) {
                                            const updatedHistory = chatHistory.map(c =>
                                                c.id === activeChatId ? { ...c, title: newChatTitle } : c
                                            );
                                            setChatHistory(updatedHistory);
                                        }
                                        setRenameAnchorEl(null);
                                    }
                                }}
                                autoFocus
                            />
                            <div className="rename-popup-actions">
                                <button
                                    onClick={() => {
                                        if (newChatTitle.trim() && activeChatId) {
                                            const updatedHistory = chatHistory.map(c =>
                                                c.id === activeChatId ? { ...c, title: newChatTitle } : c
                                            );
                                            setChatHistory(updatedHistory);
                                        }
                                        setRenameAnchorEl(null);
                                    }}
                                    className="confirm-btn"
                                >
                                    Confirm
                                </button>
                                <button
                                    onClick={() => setRenameAnchorEl(null)}
                                    className="cancel-btn"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                <div className={`main-content ${isSidebarActive ? 'sidebar-active' : 'sidebar-collapsed'}`}>
                    <div className="top-nav">
                        <div className='logo-container1' onClick={startNewChat} style={{ cursor: 'pointer' }}>
                            {/* <img src={SaviFullLogo} alt="AV Logo" style={{ width: 53, height: 21 }} /> */}
                        </div>
                        {/* {activeChatId && !showFAQ && (
                        <div className="chat-list-dropdown">
                            <div className="chat-title-container">
                                {isEditingTitle ? (
                                    <div className="rename-chat-container">
                                        <input
                                            type="text"
                                            className="rename-chat-input"
                                            value={newChatTitle}
                                            onChange={(e) => setNewChatTitle(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    saveTitle();
                                                }
                                            }}
                                            autoFocus
                                        />
                                        <button className="chat-title-btn" onClick={saveTitle}>
                                            <FiCheck size={16} />
                                        </button>
                                        <button className="chat-title-btn" onClick={cancelEditTitle}>
                                            <FiX size={16} />
                                        </button>
                                    </div>
                                ) : (
                                    <div className="active-chat-controls" onClick={() => setShowChatList(!showChatList)}>
                                        <span className="active-chat-title">{newChatTitle}</span>
                                        <button
                                            className="chat-title-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                startEditTitle();
                                            }}
                                        >
                                            <FiEdit2 size={16} />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )} */}

                        <div className="nav-actions">
                            <div className="user-menu-container sign-out-container">
                                <button
                                    className="user-menu-button"
                                    onClick={() => setShowSignOutOptions(!showSignOutOptions)}
                                >
                                    {userInitial ? (
                                        <div className="user-initial">{userInitial}</div>
                                    ) : (
                                        <FiUser size={18} />
                                    )}
                                </button>

                                {showSignOutOptions && (
                                    <div className="user-menu-dropdown">
                                        <button className="menu-item"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setShowSignOutOptions(false);
                                                setShowSettings(true); // Always open Settings modal
                                            }}>
                                            <FiSettings size={16} />
                                            <span>Settings</span>
                                        </button>
                                        <button className="menu-item" onClick={handleSignOut} >
                                            <FiLogOut size={16} />
                                            <span>Log out</span>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="content-area">
                        {showDashboard && dashboardUrl ? (
                            <div className="dashboard-container">
                                <iframe
                                    title="Dashboard"
                                    src={dashboardUrl}
                                    width="100%"
                                    height="100%"
                                    frameBorder="0"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        ) : showFAQ ? (
                            <Faq
                                setInputText={setInputText}
                                setActiveNavItem={setActiveNavItem}
                                setShowFAQ={setShowFAQ}
                                handleSendMessage={handleSendMessage}
                                setFaqQuestionSelected={setFaqQuestionSelected}
                            />
                        // ) : activeNavItem === 'Revenue' ?
                        //     (
                        //         <RevenueData />
                            // ) : activeNavItem === 'InsightApps' ? (
                            //     <InsightApps /> 
                            // ) : activeNavItem === 'Agents' ? (
                            //     <Agents />
                            ) : (
                                <div className="chat-container">
                                    {/* {messages.length === 0 && !showDashboard && !showFAQ ? (
                                    <div className="welcome-message1" style={{ flexDirection: 'column', gap: '0px' }}>
                                        <div>
                                            <span className="welcome-hello1">Hello,</span>
                                            <span className="welcome-username1">{(() => {
                                                const userType = localStorage.getItem('userType');
                                                const email = userType === 'vendor' 
                                                    ? localStorage.getItem('userEmail') 
                                                    : localStorage.getItem('user');
                                                if (!email) return 'User';
                                                const namePart = email.split('@')[0];
                                                return namePart
                                                    .replace(/[._]/g, ' ')
                                                    .replace(/\b\w/g, c => c.toUpperCase());
                                            })()}</span>
                                        </div>
                                        <div className="welcome-sub-small">How Can I Help You?</div>
                                    </div>
                                ) : ( */}
                                    <div className="messages-container">
                                        {messages.map((message, index) => (

                                            <div key={index} className={`message ${message.sender}`}>
                                                <div className="message-content-wrapper">
                                                        <div className="message-content">
                                                            {message.sender === 'ai' ? (
                                                                <pre
                                                                    className="ai-message-text"
                                                                    style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}
                                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message.text) }}
                                                                />
                                                            ) : (
                                                                message.text
                                                            )}
                                                        </div>
                                                        
                                                        {/* Render attachments for user messages */}
                                                        {message.attachments && message.attachments.length > 0 && (
                                                            <div className="message-attachments">
                                                                {message.attachments.map((attachment) => (
                                                                    <div key={attachment.id} className="message-attachment">
                                                                        {attachment.preview ? (
                                                                            <img 
                                                                                src={attachment.preview} 
                                                                                alt={attachment.name} 
                                                                                className="message-attachment-image"
                                                                                onClick={() => window.open(attachment.preview, '_blank')}
                                                                            />
                                                                        ) : (
                                                                            <div className="message-attachment-file">
                                                                                <div className="message-attachment-icon">
                                                                                    {getFileIcon(attachment.type)}
                                                                                </div>
                                                                                <div className="message-attachment-info">
                                                                                    <span className="message-attachment-name">{attachment.name}</span>
                                                                                    <span className="message-attachment-size">{attachment.size}</span>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        
                                                        {/* Render charts if visualizations data exists */}
                                                        {message.visualizations && (
                                                            <div className="message-charts">
                                                                <ChartVisualization visualizations={message.visualizations} />
                                                            </div>
                                                        )}
                                                        
                                                        {/* Render invoice tables if showInvoiceTables flag is set */}
                                                        {(() => {
                                                            if (message.showInvoiceTables && message.invoiceResults) {
                                                                console.log('🎨 Rendering invoice tables for message:', {
                                                                    showInvoiceTables: message.showInvoiceTables,
                                                                    hasInvoiceResults: !!message.invoiceResults,
                                                                    extractedDataLength: message.invoiceResults.extracted_data?.length,
                                                                    total: message.invoiceResults.total_invoices_loaded,
                                                                    successful: message.invoiceResults.successful_pushed_invoices,
                                                                    failed: message.invoiceResults.failed_invoices_count
                                                                });
                                                                
                                                                return (
                                                                    <div className="invoice-tables-container">
                                                                        {/* Level 1: Summary Cards */}
                                                                        <SummaryCards 
                                                                            results={message.invoiceResults} 
                                                                            onFailedInvoicesClick={handleFailedInvoicesClick}
                                                                            onDuplicateInvoicesClick={handleDuplicateInvoicesClick}
                                                                        />
                                                                        
                                                                        {/* Level 2: Extracted Data with Modal Items */}
                                                                        {message.invoiceResults.extracted_data && 
                                                                         message.invoiceResults.extracted_data.length > 0 ? (
                                                                            <ExtractedDataTable 
                                                                                extractedData={message.invoiceResults.extracted_data}
                                                                                expandedRows={expandedRows}
                                                                                onToggleExpansion={handleToggleExpansion}
                                                                                onSendEmail={handleSendEmail}
                                                                                onDownloadExcel={handleDownloadExcel}
                                                                                invoiceResults={message.invoiceResults}
                                                                                isSendingEmail={isSendingEmail}
                                                                                emailSendStatus={emailSendStatus}
                                                                            />
                                                                        ) : (
                                                                            <div className="no-extracted-data-message" style={{
                                                                                padding: '20px',
                                                                                textAlign: 'center',
                                                                                color: '#666',
                                                                                fontStyle: 'italic'
                                                                            }}>
                                                                                ℹ️ No detailed invoice data was extracted from the uploaded document(s).
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            }
                                                            return null;
                                                        })()}
                                                        {/* Show chart loading indicator */}
                                                        {chartLoadingStates[index] && (
                                                            <div className="message-charts-loading">
                                                                <div className="chart-loading-container">
                                                                    <div className="chart-loading-header">
                                                                        <div className="chart-loading-spinner"></div>
                                                                        <span className="chart-loading-text">
                                                                            Generating charts... {chartLoadingProgress[index] || 0}%
                                                                        </span>
                                                                    </div>
                                                                    <div className="chart-progress-bar">
                                                                        <div 
                                                                            className="chart-progress-fill"
                                                                            style={{ width: `${chartLoadingProgress[index] || 0}%` }}
                                                                        ></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {message.sender === 'ai' && !message.isTyping && (
                                                            <div className="message-actions">
                                                                <button 
                                                                    className={`action-btn ${messageFeedback[index]?.thumbsUp ? 'active' : ''}`}
                                                                    onClick={() => handleThumbsUp(index)}
                                                                    title="Good response"
                                                                >
                                                                    <FiThumbsUp />
                                                                </button>
                                                                <button 
                                                                    className={`action-btn ${messageFeedback[index]?.thumbsDown ? 'active' : ''}`}
                                                                    onClick={() => handleThumbsDown(index)}
                                                                    title="Poor response"
                                                                >
                                                                    <FiThumbsDown />
                                                                </button>
                                                                <button 
                                                                    className={`action-btn ${copiedMessageId === index ? 'copied' : ''}`}
                                                                    onClick={() => handleCopyMessage(message.text, index)}
                                                                    title={copiedMessageId === index ? "Copied!" : "Copy message"}
                                                                >
                                                                    <FiCopy />
                                                                </button>
                                                            </div>
                                                        )}
                                                </div>
                                            </div>
                                        ))}
                                        <div ref={messagesEndRef} />
                                        {loading && (
                                            <div className="message ai">
                                                <div className="message-content loading">
                                                    <div className="typing-indicator">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {/* )} */}
                                </div>
                            )}
                    </div>

                    {!showDashboard && (!showFAQ || faqQuestionSelected)  && (
                        <>
                            {messages.length === 0 ? (
                                <div className="chat-input-floating">
                                    <div className="welcome-message1">
                                        <div>
                                            <span className="welcome-hello1">Hello,</span>
                                            <span className="welcome-username1">{(() => {
                                                const userType = localStorage.getItem('userType');
                                                const email = userType === 'vendor' 
                                                    ? localStorage.getItem('userEmail') 
                                                    : localStorage.getItem('user');
                                                if (!email) return 'User';
                                                const namePart = email.split('@')[0];
                                                return namePart
                                                    .replace(/[._]/g, ' ')
                                                    .replace(/\b\w/g, c => c.toUpperCase());
                                            })()}</span>
                                        </div>
                                        <div className="welcome-sub-small">How Can I Help You?</div>
                                    </div>
                                    
                                    {/* Drag and drop overlay */}
                                    {dragActive && (
                                        <div className="drag-drop-overlay">
                                            <div className="drag-drop-content">
                                                <FiPaperclip size={48} />
                                                <p>Drop files here to attach</p>
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div 
                                        className={`chat-input ${dragActive ? 'drag-active' : ''}`}
                                        onDragEnter={handleDragEnter}
                                        onDragLeave={handleDragLeave}
                                        onDragOver={handleDragOver}
                                        onDrop={handleDrop}
                                    >
                                        {/* Attachment previews */}
                                        {selectedFiles.length > 0 && (
                                            <div className="attachment-previews">
                                                {selectedFiles.map((fileData) => (
                                                    <div key={fileData.id} className="attachment-preview">
                                                        <div className="attachment-content">
                                                            {fileData.preview ? (
                                                                <img src={fileData.preview} alt={fileData.name} className="attachment-image" />
                                                            ) : (
                                                                <div className="attachment-file-icon">
                                                                    {getFileIcon(fileData.type)}
                                                                </div>
                                                            )}
                                                            <div className="attachment-info">
                                                                <span className="attachment-name">{fileData.name}</span>
                                                                <span className="attachment-size">{fileData.size}</span>
                                                            </div>
                                                        </div>
                                                        <button 
                                                            className="attachment-remove"
                                                            onClick={() => handleAttachmentRemove(fileData.id)}
                                                            title="Remove attachment"
                                                        >
                                                            <FiX size={16} />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        <TextareaAutosize
                                            className="text-input"
                                            placeholder={placeholder}
                                            value={inputText}
                                            onChange={handleInputChange}
                                            onKeyDown={handleKeyPress}
                                            onPaste={handlePaste}
                                            minRows={1}
                                            maxRows={4}
                                            style={{ resize: 'none' }}
                                            disabled={loading || !!typingMessage}
                                        />
                                        <div className="input-icons-row">
                                            <div className="left-icons">
                                                <input
                                                    type="file"
                                                    multiple
                                                    onChange={handleFileSelect}
                                                    style={{ display: 'none' }}
                                                    id="file-upload-floating"
                                                    accept="image/*,text/*,.pdf,.doc,.docx,.xls,.xlsx"
                                                />
                                                <label htmlFor="file-upload-floating" className="attachment-btn">
                                                    <FiPaperclip size={18} />
                                                </label>
                                            </div>
                                            <div className="right-icons">
                                                {isUploading ? (
                                                    <button className="upload-progress-btn" disabled>
                                                        <div className="upload-spinner"></div>
                                                    </button>
                                                ) : loading && !typingMessage ? (
                                                    <button
                                                        className="stop-btn"
                                                        onClick={cancelRequest}
                                                        title="Cancel request"
                                                    >
                                                        <FiX size={18} color="white" />
                                                    </button>
                                                ) : typingMessage ? (
                                                    <button
                                                        className="stop-btn"
                                                        onClick={stopTyping}
                                                        title="Stop generating"
                                                    >
                                                        <FiX size={18} color="white" />
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="send-btn"
                                                        onClick={handleSendMessage}
                                                        disabled={(!inputText?.trim() && selectedFiles.length === 0) || loading || !!typingMessage}
                                                        title={(!inputText?.trim() && selectedFiles.length === 0) ? "Type a message or attach a file to send" : "Send message"}
                                                    >
                                                        <FiArrowRight size={20} color="white" />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                     {/* <div className="quick-responses">
                                        {quickResponses.map((response) => (
                                            <button
                                                key={response.id}
                                                className={`quick-response-btn ${response.category}`}
                                                onClick={() => handleQuickResponse(response)}
                                                disabled={loading || !!typingMessage}
                                                title={`Use template: ${response.prompt}`}
                                            >
                                                {response.text}
                                            </button>
                                        ))}
                                    </div>  */}
                                </div>
                            ) : (
                                <div className={`chat-input-container${typingMessage ? ' input-blocked' : ''}`}>
                                    {/* Drag and drop overlay */}
                                    {dragActive && (
                                        <div className="drag-drop-overlay">
                                            <div className="drag-drop-content">
                                                <FiPaperclip size={48} />
                                                <p>Drop files here to attach</p>
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div 
                                        className={`chat-input ${dragActive ? 'drag-active' : ''}`}
                                        onDragEnter={handleDragEnter}
                                        onDragLeave={handleDragLeave}
                                        onDragOver={handleDragOver}
                                        onDrop={handleDrop}
                                    >
                                        {/* Attachment previews */}
                                        {selectedFiles.length > 0 && (
                                            <div className="attachment-previews">
                                                {selectedFiles.map((fileData) => (
                                                    <div key={fileData.id} className="attachment-preview">
                                                        <div className="attachment-content">
                                                            {fileData.preview ? (
                                                                <img src={fileData.preview} alt={fileData.name} className="attachment-image" />
                                                            ) : (
                                                                <div className="attachment-file-icon">
                                                                    {getFileIcon(fileData.type)}
                                                                </div>
                                                            )}
                                                            <div className="attachment-info">
                                                                <span className="attachment-name">{fileData.name}</span>
                                                                <span className="attachment-size">{fileData.size}</span>
                                                            </div>
                                                        </div>
                                                        <button 
                                                            className="attachment-remove"
                                                            onClick={() => handleAttachmentRemove(fileData.id)}
                                                            title="Remove attachment"
                                                        >
                                                            <FiX size={16} />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        <TextareaAutosize
                                            className="text-input"
                                            placeholder={placeholder}
                                            value={inputText}
                                            onChange={handleInputChange}
                                            onKeyDown={handleKeyPress}
                                            onPaste={handlePaste}
                                            minRows={1}
                                            maxRows={4}
                                            style={{ resize: 'none' }}
                                            disabled={loading || !!typingMessage}
                                        />
                                        <div className="input-icons-row">
                                            <div className="left-icons">
                                                <input
                                                    type="file"
                                                    multiple
                                                    onChange={handleFileSelect}
                                                    style={{ display: 'none' }}
                                                    id="file-upload-regular"
                                                    accept="image/*,text/*,.pdf,.doc,.docx,.xls,.xlsx"
                                                />
                                                <label htmlFor="file-upload-regular" className="attachment-btn">
                                                    <FiPaperclip size={18} />
                                                </label>
                                            </div>
                                            <div className="right-icons">
                                                {isUploading ? (
                                                    <button className="upload-progress-btn" disabled>
                                                        <div className="upload-spinner"></div>
                                                    </button>
                                                ) : loading && !typingMessage ? (
                                                    <button
                                                        className="stop-btn"
                                                        onClick={cancelRequest}
                                                        title="Cancel request"
                                                    >
                                                        <FiX size={18} color="white" />
                                                    </button>
                                                ) : typingMessage ? (
                                                    <button
                                                        className="stop-btn"
                                                        onClick={stopTyping}
                                                        title="Stop generating"
                                                    >
                                                        <FiX size={18} color="white" />
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="send-btn"
                                                        onClick={handleSendMessage}
                                                        disabled={(!inputText?.trim() && selectedFiles.length === 0) || loading || !!typingMessage}
                                                        title={(!inputText?.trim() && selectedFiles.length === 0) ? "Type a message or attach a file to send" : "Send message"}
                                                    >
                                                        <FiArrowRight size={20} color="white" />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
                {showSettings && (
                    <Settings
                        onClose={() => setShowSettings(false)}
                        chatHistory={chatHistory}
                        setChatHistory={setChatHistory}
                        deletedChats={deletedChats}
                        setDeletedChats={setDeletedChats}
                        setActiveChatId={setActiveChatId} // add this
                        setMessages={setMessages}         // add this
                        setShowDashboard={setShowDashboard}
                        currentTheme={currentTheme}
                        setCurrentTheme={setCurrentTheme}
                    />
                )}
                {/* {sessionManager && (
            <SessionTimeoutWarning
                onStayLoggedIn={sessionManager.stayLoggedIn}
                onLogout={sessionManager.logout}
            />
        )} */}
                <SessionTimeoutWarning
                    onStayLoggedIn={() => window.sessionTimeout?.stayLoggedIn()}
                    onLogout={() => window.sessionTimeout?.logout()}
                />

                {/* Items Modal */}
                <ItemsModal
                    isOpen={showItemsModal}
                    onClose={() => setShowItemsModal(false)}
                    items={selectedItems}
                    title={modalTitle}
                />

                {/* Failed Invoices Modal */}
                <FailedInvoicesModal
                    isOpen={showFailedInvoicesModal}
                    onClose={() => {
                        setShowFailedInvoicesModal(false);
                        setSelectedFailedInvoices(null);
                    }}
                    failedInvoices={selectedFailedInvoices}
                    title="Failed Invoices Details"
                />
                
                {/* Duplicate Invoices Modal */}
                <DuplicateInvoicesModal
                    isOpen={showDuplicateInvoicesModal}
                    onClose={() => {
                        setShowDuplicateInvoicesModal(false);
                        setSelectedDuplicateInvoices(null);
                    }}
                    duplicateInvoices={selectedDuplicateInvoices}
                    title="Duplicate Invoices Details"
                />
            </div>
        </SessionTimeout>
    );
};

export default Chat;


